(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire76ef"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire76ef"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("wfCCk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $926e87538ce64d15$export$2e2bcd8739ae039; });
parcelRequire("kdoAp");
var $e1gjy = parcelRequire("e1gjy");

var $d5hBS = parcelRequire("d5hBS");

var $5wItV = parcelRequire("5wItV");

var $28kJ3 = parcelRequire("28kJ3");

var $anKEn = parcelRequire("anKEn");

var $icKDq = parcelRequire("icKDq");

var $5ozaj = parcelRequire("5ozaj");
var $926e87538ce64d15$export$2e2bcd8739ae039 = (0, $e1gjy.defineComponent)({
    name: "Root",
    mixins: [
        (0, $5ozaj.default)
    ],
    data: ()=>({
            nInputBits: 2,
            truthTable: [],
            usingProductOfSums: false,
            groups: null,
            focusedGroup: null,
            N_MAX_INPUTS: 8
        }),
    computed: {
        truthTableLength () {
            return 2 ** this.nInputBits;
        },
        nDimensions () {
            return Math.ceil(this.nInputBits / 2);
        }
    },
    methods: {
        updateGroups () {
            if (!this.usingProductOfSums) this.groups = (0, $d5hBS.findKarnaughGroups)(this.truthTable);
            else this.groups = (0, $d5hBS.findKarnaughGroups)(this.truthTable.map((bit)=>!bit));
        },
        repeatTruthTable () {
            const truthTable = [];
            for(let i = 0; i < this.truthTableLength; i++)truthTable[i] = this.truthTable[i % this.truthTable.length];
            this.truthTable = truthTable;
        },
        clearTruthTable (toTrue = true) {
            for(let i = 0; i < this.truthTable.length; i++)this.truthTable[i] = toTrue;
        },
        refreshTruthTable () {
            this.repeatTruthTable();
        },
        setFocusedGroup (group) {
            this.focusedGroup = group;
        },
        range: $5wItV.range
    },
    watch: {
        truthTable: {
            deep: true,
            handler () {
                this.updateGroups();
            }
        },
        usingProductOfSums () {
            this.updateGroups();
        }
    },
    components: {
        Entry: $28kJ3.default,
        KarnaughMap: $anKEn.default,
        Expression: $icKDq.default
    },
    created () {
        this.truthTable = [
            ...Array(this.truthTableLength)
        ].map(()=>Math.random() < 0.5);
    },
    mounted () {
        this.updateGroups();
    }
});

});
parcelRegister("kdoAp", function(module, exports) {
$parcel$export(module.exports, "createApp", function () { return (parcelRequire("95okz")).createApp; });
$parcel$export(module.exports, "vModelCheckbox", function () { return (parcelRequire("95okz")).vModelCheckbox; });
$parcel$export(module.exports, "withModifiers", function () { return (parcelRequire("95okz")).withModifiers; });
$parcel$export(module.exports, "createBlock", function () { return (parcelRequire("e1gjy")).createBlock; });
$parcel$export(module.exports, "createCommentVNode", function () { return (parcelRequire("e1gjy")).createCommentVNode; });
$parcel$export(module.exports, "createElementBlock", function () { return (parcelRequire("e1gjy")).createElementBlock; });
$parcel$export(module.exports, "createElementVNode", function () { return (parcelRequire("e1gjy")).createElementVNode; });
$parcel$export(module.exports, "createTextVNode", function () { return (parcelRequire("e1gjy")).createTextVNode; });
$parcel$export(module.exports, "createVNode", function () { return (parcelRequire("e1gjy")).createVNode; });
$parcel$export(module.exports, "defineComponent", function () { return (parcelRequire("e1gjy")).defineComponent; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("e1gjy")).Fragment; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("e1gjy")).initCustomFormatter; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("ciGHN")).normalizeClass; });
$parcel$export(module.exports, "openBlock", function () { return (parcelRequire("e1gjy")).openBlock; });
$parcel$export(module.exports, "popScopeId", function () { return (parcelRequire("e1gjy")).popScopeId; });
$parcel$export(module.exports, "pushScopeId", function () { return (parcelRequire("e1gjy")).pushScopeId; });
$parcel$export(module.exports, "renderList", function () { return (parcelRequire("e1gjy")).renderList; });
$parcel$export(module.exports, "resolveComponent", function () { return (parcelRequire("e1gjy")).resolveComponent; });
$parcel$export(module.exports, "withCtx", function () { return (parcelRequire("e1gjy")).withCtx; });
$parcel$export(module.exports, "withDirectives", function () { return (parcelRequire("e1gjy")).withDirectives; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("ciGHN")).toDisplayString; });
parcelRequire("95okz");
var $e1gjy = parcelRequire("e1gjy");parcelRequire("ciGHN");
function $eb7817e2a8cd43fb$var$initDev() {
    (0, $e1gjy.initCustomFormatter)();
}
const $eb7817e2a8cd43fb$export$ef7acd7185315e22 = ()=>{};

});
parcelRegister("95okz", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", function () { return (parcelRequire("e1gjy")).BaseTransition; });
$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return (parcelRequire("e1gjy")).callWithAsyncErrorHandling; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("ciGHN")).camelize; });
$parcel$export(module.exports, "createBlock", function () { return (parcelRequire("e1gjy")).createBlock; });
$parcel$export(module.exports, "createCommentVNode", function () { return (parcelRequire("e1gjy")).createCommentVNode; });
$parcel$export(module.exports, "createElementBlock", function () { return (parcelRequire("e1gjy")).createElementBlock; });
$parcel$export(module.exports, "createElementVNode", function () { return (parcelRequire("e1gjy")).createElementVNode; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return (parcelRequire("e1gjy")).createHydrationRenderer; });
$parcel$export(module.exports, "createRenderer", function () { return (parcelRequire("e1gjy")).createRenderer; });
$parcel$export(module.exports, "createTextVNode", function () { return (parcelRequire("e1gjy")).createTextVNode; });
$parcel$export(module.exports, "createVNode", function () { return (parcelRequire("e1gjy")).createVNode; });
$parcel$export(module.exports, "defineComponent", function () { return (parcelRequire("e1gjy")).defineComponent; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("e1gjy")).Fragment; });
$parcel$export(module.exports, "getCurrentInstance", function () { return (parcelRequire("e1gjy")).getCurrentInstance; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return (parcelRequire("e1gjy")).getTransitionRawChildren; });
$parcel$export(module.exports, "h", function () { return (parcelRequire("e1gjy")).h; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("e1gjy")).initCustomFormatter; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return (parcelRequire("e1gjy")).isRuntimeOnly; });
$parcel$export(module.exports, "nextTick", function () { return (parcelRequire("e1gjy")).nextTick; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("ciGHN")).normalizeClass; });
$parcel$export(module.exports, "onMounted", function () { return (parcelRequire("e1gjy")).onMounted; });
$parcel$export(module.exports, "onUnmounted", function () { return (parcelRequire("e1gjy")).onUnmounted; });
$parcel$export(module.exports, "onUpdated", function () { return (parcelRequire("e1gjy")).onUpdated; });
$parcel$export(module.exports, "openBlock", function () { return (parcelRequire("e1gjy")).openBlock; });
$parcel$export(module.exports, "popScopeId", function () { return (parcelRequire("e1gjy")).popScopeId; });
$parcel$export(module.exports, "pushScopeId", function () { return (parcelRequire("e1gjy")).pushScopeId; });
$parcel$export(module.exports, "renderList", function () { return (parcelRequire("e1gjy")).renderList; });
$parcel$export(module.exports, "resolveComponent", function () { return (parcelRequire("e1gjy")).resolveComponent; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return (parcelRequire("e1gjy")).resolveTransitionHooks; });
$parcel$export(module.exports, "setTransitionHooks", function () { return (parcelRequire("e1gjy")).setTransitionHooks; });
$parcel$export(module.exports, "Static", function () { return (parcelRequire("e1gjy")).Static; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("aTBEd")).toRaw; });
$parcel$export(module.exports, "useTransitionState", function () { return (parcelRequire("e1gjy")).useTransitionState; });
$parcel$export(module.exports, "warn", function () { return (parcelRequire("e1gjy")).warn; });
$parcel$export(module.exports, "watchPostEffect", function () { return (parcelRequire("e1gjy")).watchPostEffect; });
$parcel$export(module.exports, "withCtx", function () { return (parcelRequire("e1gjy")).withCtx; });
$parcel$export(module.exports, "withDirectives", function () { return (parcelRequire("e1gjy")).withDirectives; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("ciGHN")).toDisplayString; });

$parcel$export(module.exports, "vModelCheckbox", function () { return $69d77440ef71bcfd$export$8847c2e532b35714; });
$parcel$export(module.exports, "withModifiers", function () { return $69d77440ef71bcfd$export$26bd3b8e29e6f273; });
$parcel$export(module.exports, "createApp", function () { return $69d77440ef71bcfd$export$4e373c34abfa8c68; });

var $e1gjy = parcelRequire("e1gjy");
var $ciGHN = parcelRequire("ciGHN");
var $aTBEd = parcelRequire("aTBEd");parcelRequire("ciGHN");

var $ciGHN = parcelRequire("ciGHN");
const $69d77440ef71bcfd$var$svgNS = "http://www.w3.org/2000/svg";
const $69d77440ef71bcfd$var$doc = typeof document !== "undefined" ? document : null;
const $69d77440ef71bcfd$var$templateContainer = $69d77440ef71bcfd$var$doc && $69d77440ef71bcfd$var$doc.createElement("template");
const $69d77440ef71bcfd$var$nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, isSVG, is, props)=>{
        const el = isSVG ? $69d77440ef71bcfd$var$doc.createElementNS($69d77440ef71bcfd$var$svgNS, tag) : $69d77440ef71bcfd$var$doc.createElement(tag, is ? {
            is: is
        } : undefined);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$69d77440ef71bcfd$var$doc.createTextNode(text),
    createComment: (text)=>$69d77440ef71bcfd$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$69d77440ef71bcfd$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    cloneNode (el) {
        const cloned = el.cloneNode(true);
        // #3072
        // - in `patchDOMProp`, we store the actual value in the `el._value` property.
        // - normally, elements using `:value` bindings will not be hoisted, but if
        //   the bound value is a constant, e.g. `:value="true"` - they do get
        //   hoisted.
        // - in production, hoisted nodes are cloned when subsequent inserts, but
        //   cloneNode() does not copy the custom property we attached.
        // - This may need to account for other custom DOM properties we attach to
        //   elements in addition to `_value` in the future.
        if (`_value` in el) cloned._value = el._value;
        return cloned;
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, isSVG, start, end) {
        // <parent> before | first ... last | anchor </parent>
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        // #5308 can only take cached path if:
        // - has a single root node
        // - nextSibling info is still available
        if (start && (start === end || start.nextSibling)) // cached
        while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            // fresh insert
            $69d77440ef71bcfd$var$templateContainer.innerHTML = isSVG ? `<svg>${content}</svg>` : content;
            const template = $69d77440ef71bcfd$var$templateContainer.content;
            if (isSVG) {
                // remove outer svg wrapper
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
// compiler should normalize class + :class bindings on the same element
// into a single binding ['staticClass', dynamic]
function $69d77440ef71bcfd$var$patchClass(el, value, isSVG) {
    // directly setting className should be faster than setAttribute in theory
    // if this is an element during a transition, take the temporary transition
    // classes into account.
    const transitionClasses = el._vtc;
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
function $69d77440ef71bcfd$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $ciGHN.isString)(next);
    if (next && !isCssString) {
        for(const key in next)$69d77440ef71bcfd$var$setStyle(style, key, next[key]);
        if (prev && !(0, $ciGHN.isString)(prev)) {
            for(const key in prev)if (next[key] == null) $69d77440ef71bcfd$var$setStyle(style, key, "");
        }
    } else {
        const currentDisplay = style.display;
        if (isCssString) {
            if (prev !== next) style.cssText = next;
        } else if (prev) el.removeAttribute("style");
        // indicates that the `display` of the element is controlled by `v-show`,
        // so we always keep the current `display` value regardless of the `style`
        // value, thus handing over control to `v-show`.
        if ("_vod" in el) style.display = currentDisplay;
    }
}
const $69d77440ef71bcfd$var$importantRE = /\s*!important$/;
function $69d77440ef71bcfd$var$setStyle(style, name, val) {
    if ((0, $ciGHN.isArray)(val)) val.forEach((v)=>$69d77440ef71bcfd$var$setStyle(style, name, v));
    else if (name.startsWith("--")) // custom property definition
    style.setProperty(name, val);
    else {
        const prefixed = $69d77440ef71bcfd$var$autoPrefix(style, name);
        if ($69d77440ef71bcfd$var$importantRE.test(val)) // !important
        style.setProperty((0, $ciGHN.hyphenate)(prefixed), val.replace($69d77440ef71bcfd$var$importantRE, ""), "important");
        else style[prefixed] = val;
    }
}
const $69d77440ef71bcfd$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $69d77440ef71bcfd$var$prefixCache = {};
function $69d77440ef71bcfd$var$autoPrefix(style, rawName) {
    const cached = $69d77440ef71bcfd$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $ciGHN.camelize)(rawName);
    if (name !== "filter" && name in style) return $69d77440ef71bcfd$var$prefixCache[rawName] = name;
    name = (0, $ciGHN.capitalize)(name);
    for(let i = 0; i < $69d77440ef71bcfd$var$prefixes.length; i++){
        const prefixed = $69d77440ef71bcfd$var$prefixes[i] + name;
        if (prefixed in style) return $69d77440ef71bcfd$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $69d77440ef71bcfd$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $69d77440ef71bcfd$var$patchAttr(el, key, value, isSVG, instance) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($69d77440ef71bcfd$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($69d77440ef71bcfd$var$xlinkNS, key, value);
    } else {
        // note we are only checking boolean attributes that don't have a
        // corresponding dom prop of the same name here.
        const isBoolean = (0, $ciGHN.isSpecialBooleanAttr)(key);
        if (value == null || isBoolean && !(0, $ciGHN.includeBooleanAttr)(value)) el.removeAttribute(key);
        else el.setAttribute(key, isBoolean ? "" : value);
    }
}
// __UNSAFE__
// functions. The user is responsible for using them with only trusted content.
function $69d77440ef71bcfd$var$patchDOMProp(el, key, value, // the following args are passed only due to potential innerHTML/textContent
// overriding existing VNodes, in which case the old tree must be properly
// unmounted.
prevChildren, parentComponent, parentSuspense, unmountChildren) {
    if (key === "innerHTML" || key === "textContent") {
        if (prevChildren) unmountChildren(prevChildren, parentComponent, parentSuspense);
        el[key] = value == null ? "" : value;
        return;
    }
    if (key === "value" && el.tagName !== "PROGRESS" && // custom elements may use _value internally
    !el.tagName.includes("-")) {
        // store value as _value as well since
        // non-string values will be stringified.
        el._value = value;
        const newValue = value == null ? "" : value;
        if (el.value !== newValue || // #4956: always set for OPTION elements because its value falls back to
        // textContent if no value attribute is present. And setting .value for
        // OPTION has no side effect
        el.tagName === "OPTION") el.value = newValue;
        if (value == null) el.removeAttribute(key);
        return;
    }
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") {
            // e.g. <select multiple> compiles to { multiple: '' }
            el[key] = (0, $ciGHN.includeBooleanAttr)(value);
            return;
        } else if (value == null && type === "string") {
            // e.g. <div :id="null">
            el[key] = "";
            el.removeAttribute(key);
            return;
        } else if (type === "number") {
            // e.g. <img :width="null">
            // the value of some IDL attr must be greater than 0, e.g. input.size = 0 -> error
            try {
                el[key] = 0;
            } catch (_a) {}
            el.removeAttribute(key);
            return;
        }
    }
    // some properties perform value validation and throw
    try {
        el[key] = value;
    } catch (e) {}
}
// Async edge case fix requires storing an event listener's attach timestamp.
let $69d77440ef71bcfd$var$_getNow = Date.now;
let $69d77440ef71bcfd$var$skipTimestampCheck = false;
if (typeof window !== "undefined") {
    // Determine what event timestamp the browser is using. Annoyingly, the
    // timestamp can either be hi-res (relative to page load) or low-res
    // (relative to UNIX epoch), so in order to compare time we have to use the
    // same timestamp type when saving the flush timestamp.
    if ($69d77440ef71bcfd$var$_getNow() > document.createEvent("Event").timeStamp) // if the low-res timestamp which is bigger than the event timestamp
    // (which is evaluated AFTER) it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listeners as well.
    $69d77440ef71bcfd$var$_getNow = ()=>performance.now();
    // #3485: Firefox <= 53 has incorrect Event.timeStamp implementation
    // and does not fire microtasks in between event propagation, so safe to exclude.
    const ffMatch = navigator.userAgent.match(/firefox\/(\d+)/i);
    $69d77440ef71bcfd$var$skipTimestampCheck = !!(ffMatch && Number(ffMatch[1]) <= 53);
}
// To avoid the overhead of repeatedly calling performance.now(), we cache
// and use the same timestamp for all event listeners attached in the same tick.
let $69d77440ef71bcfd$var$cachedNow = 0;
const $69d77440ef71bcfd$var$p = Promise.resolve();
const $69d77440ef71bcfd$var$reset = ()=>{
    $69d77440ef71bcfd$var$cachedNow = 0;
};
const $69d77440ef71bcfd$var$getNow = ()=>$69d77440ef71bcfd$var$cachedNow || ($69d77440ef71bcfd$var$p.then($69d77440ef71bcfd$var$reset), $69d77440ef71bcfd$var$cachedNow = $69d77440ef71bcfd$var$_getNow());
function $69d77440ef71bcfd$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $69d77440ef71bcfd$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
function $69d77440ef71bcfd$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    // vei = vue event invokers
    const invokers = el._vei || (el._vei = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) // patch
    existingInvoker.value = nextValue;
    else {
        const [name, options] = $69d77440ef71bcfd$var$parseName(rawName);
        if (nextValue) {
            // add
            const invoker = invokers[rawName] = $69d77440ef71bcfd$var$createInvoker(nextValue, instance);
            $69d77440ef71bcfd$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            // remove
            $69d77440ef71bcfd$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = undefined;
        }
    }
}
const $69d77440ef71bcfd$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $69d77440ef71bcfd$var$parseName(name) {
    let options;
    if ($69d77440ef71bcfd$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($69d77440ef71bcfd$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    return [
        (0, $ciGHN.hyphenate)(name.slice(2)),
        options
    ];
}
function $69d77440ef71bcfd$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        // async edge case #6566: inner click event triggers patch, event handler
        // attached to outer element during patch, and triggered again. This
        // happens because browsers fire microtask ticks between event propagation.
        // the solution is simple: we save the timestamp when a handler is attached,
        // and the handler would only fire if the event passed to it was fired
        // AFTER it was attached.
        const timeStamp = e.timeStamp || $69d77440ef71bcfd$var$_getNow();
        if ($69d77440ef71bcfd$var$skipTimestampCheck || timeStamp >= invoker.attached - 1) (0, $e1gjy.callWithAsyncErrorHandling)($69d77440ef71bcfd$var$patchStopImmediatePropagation(e, invoker.value), instance, 5 /* NATIVE_EVENT_HANDLER */ , [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $69d77440ef71bcfd$var$getNow();
    return invoker;
}
function $69d77440ef71bcfd$var$patchStopImmediatePropagation(e, value) {
    if ((0, $ciGHN.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e)=>!e._stopped && fn && fn(e));
    } else return value;
}
const $69d77440ef71bcfd$var$nativeOnRE = /^on[a-z]/;
const $69d77440ef71bcfd$var$patchProp = (el, key, prevValue, nextValue, isSVG = false, prevChildren, parentComponent, parentSuspense, unmountChildren)=>{
    if (key === "class") $69d77440ef71bcfd$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $69d77440ef71bcfd$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $ciGHN.isOn)(key)) // ignore v-model listeners
    {
        if (!(0, $ciGHN.isModelListener)(key)) $69d77440ef71bcfd$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $69d77440ef71bcfd$var$shouldSetAsProp(el, key, nextValue, isSVG)) $69d77440ef71bcfd$var$patchDOMProp(el, key, nextValue, prevChildren, parentComponent, parentSuspense, unmountChildren);
    else {
        // special case for <input v-model type="checkbox"> with
        // :true-value & :false-value
        // store value as dom properties since non-string values will be
        // stringified.
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $69d77440ef71bcfd$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $69d77440ef71bcfd$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        // most keys must be set as attribute on svg elements to work
        // ...except innerHTML & textContent
        if (key === "innerHTML" || key === "textContent") return true;
        // or native onclick with function values
        if (key in el && $69d77440ef71bcfd$var$nativeOnRE.test(key) && (0, $ciGHN.isFunction)(value)) return true;
        return false;
    }
    // spellcheck and draggable are numerated attrs, however their
    // corresponding DOM properties are actually booleans - this leads to
    // setting it with a string "false" value leading it to be coerced to
    // `true`, so we need to always treat them as attributes.
    // Note that `contentEditable` doesn't have this problem: its DOM
    // property is also enumerated string values.
    if (key === "spellcheck" || key === "draggable") return false;
    // #1787, #2840 form property on form elements is readonly and must be set as
    // attribute.
    if (key === "form") return false;
    // #1526 <input list> must be set as attribute
    if (key === "list" && el.tagName === "INPUT") return false;
    // #2766 <textarea type> must be set as attribute
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    // native onclick with string value, must be set as attribute
    if ($69d77440ef71bcfd$var$nativeOnRE.test(key) && (0, $ciGHN.isString)(value)) return false;
    return key in el;
}
function $69d77440ef71bcfd$export$a00e2346eabbdbef(options, hydate) {
    const Comp = (0, $e1gjy.defineComponent)(options);
    class VueCustomElement extends $69d77440ef71bcfd$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, hydate);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
const $69d77440ef71bcfd$export$6debb2e68f212638 = (options)=>{
    // @ts-ignore
    return $69d77440ef71bcfd$export$a00e2346eabbdbef(options, $69d77440ef71bcfd$export$fa8d919ba61d84db);
};
const $69d77440ef71bcfd$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $69d77440ef71bcfd$export$b337c1a55163dbe3 extends $69d77440ef71bcfd$var$BaseClass {
    connectedCallback() {
        this._connected = true;
        if (!this._instance) this._resolveDef();
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $e1gjy.nextTick)(()=>{
            if (!this._connected) {
                $69d77440ef71bcfd$export$b3890eb0ae9dca99(null, this.shadowRoot);
                this._instance = null;
            }
        });
    }
    /**
     * resolve inner component definition (handle possible async component)
     */ _resolveDef() {
        if (this._resolved) return;
        this._resolved = true;
        // set initial attrs
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        // watch future attr changes
        new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        }).observe(this, {
            attributes: true
        });
        const resolve = (def)=>{
            const { props: props, styles: styles } = def;
            const hasOptions = !(0, $ciGHN.isArray)(props);
            const rawKeys = props ? hasOptions ? Object.keys(props) : props : [];
            // cast Number-type props set before resolve
            let numberProps;
            if (hasOptions) for(const key in this._props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    this._props[key] = (0, $ciGHN.toNumber)(this._props[key]);
                    (numberProps || (numberProps = Object.create(null)))[key] = true;
                }
            }
            this._numberProps = numberProps;
            // check if there are props set pre-upgrade or connect
            for (const key of Object.keys(this))if (key[0] !== "_") this._setProp(key, this[key], true, false);
            // defining getter/setters on prototype
            for (const key of rawKeys.map((0, $ciGHN.camelize)))Object.defineProperty(this, key, {
                get () {
                    return this._getProp(key);
                },
                set (val) {
                    this._setProp(key, val);
                }
            });
            // apply CSS
            this._applyStyles(styles);
            // initial render
            this._update();
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) asyncDef().then(resolve);
        else resolve(this._def);
    }
    _setAttr(key) {
        let value = this.getAttribute(key);
        if (this._numberProps && this._numberProps[key]) value = (0, $ciGHN.toNumber)(value);
        this._setProp((0, $ciGHN.camelize)(key), value, false);
    }
    /**
     * @internal
     */ _getProp(key) {
        return this._props[key];
    }
    /**
     * @internal
     */ _setProp(key, val, shouldReflect = true, shouldUpdate = true) {
        if (val !== this._props[key]) {
            this._props[key] = val;
            if (shouldUpdate && this._instance) this._update();
            // reflect
            if (shouldReflect) {
                if (val === true) this.setAttribute((0, $ciGHN.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $ciGHN.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $ciGHN.hyphenate)(key));
            }
        }
    }
    _update() {
        $69d77440ef71bcfd$export$b3890eb0ae9dca99(this._createVNode(), this.shadowRoot);
    }
    _createVNode() {
        const vnode = (0, $e1gjy.createVNode)(this._def, (0, $ciGHN.extend)({}, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.isCE = true;
            var newStyles, s;
            // intercept emit
            instance.emit = (event, ...args)=>{
                this.dispatchEvent(new CustomEvent(event, {
                    detail: args
                }));
            };
            // locate nearest Vue custom element parent for provide/inject
            let parent = this;
            while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $69d77440ef71bcfd$export$b337c1a55163dbe3) {
                instance.parent = parent._instance;
                break;
            }
        };
        return vnode;
    }
    _applyStyles(styles) {
        if (styles) styles.forEach((css)=>{
            const s = document.createElement("style");
            s.textContent = css;
            this.shadowRoot.appendChild(s);
        });
    }
    constructor(_def, _props = {}, hydrate){
        super();
        this._def = _def;
        this._props = _props;
        /**
         * @internal
         */ this._instance = null;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        if (this.shadowRoot && hydrate) hydrate(this._createVNode(), this.shadowRoot);
        else this.attachShadow({
            mode: "open"
        });
    }
}
function $69d77440ef71bcfd$export$9300d5b90d56e3d1(name = "$style") {
    /* istanbul ignore else */ {
        const instance = (0, $e1gjy.getCurrentInstance)();
        if (!instance) return 0, $ciGHN.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $ciGHN.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $ciGHN.EMPTY_OBJ;
        return mod;
    }
}
/**
 * Runtime helper for SFC's CSS variable injection feature.
 * @private
 */ function $69d77440ef71bcfd$export$ef28b76f07940108(getter) {
    const instance = (0, $e1gjy.getCurrentInstance)();
    /* istanbul ignore next */ if (!instance) return;
    const setVars = ()=>$69d77440ef71bcfd$var$setVarsOnVNode(instance.subTree, getter(instance.proxy));
    (0, $e1gjy.watchPostEffect)(setVars);
    (0, $e1gjy.onMounted)(()=>{
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $e1gjy.onUnmounted)(()=>ob.disconnect());
    });
}
function $69d77440ef71bcfd$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128 /* SUSPENSE */ ) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $69d77440ef71bcfd$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    // drill down HOCs until it's a non-component vnode
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 /* ELEMENT */  && vnode.el) $69d77440ef71bcfd$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $e1gjy.Fragment)) vnode.children.forEach((c)=>$69d77440ef71bcfd$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $e1gjy.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $69d77440ef71bcfd$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $69d77440ef71bcfd$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        for(const key in vars)style.setProperty(`--${key}`, vars[key]);
    }
}
const $69d77440ef71bcfd$var$TRANSITION = "transition";
const $69d77440ef71bcfd$var$ANIMATION = "animation";
// DOM Transition is a higher-order-component based on the platform-agnostic
// base Transition component, with DOM-specific logic.
const $69d77440ef71bcfd$export$be58926105124dd4 = (props, { slots: slots })=>(0, $e1gjy.h)((0, $e1gjy.BaseTransition), $69d77440ef71bcfd$var$resolveTransitionProps(props), slots);
$69d77440ef71bcfd$export$be58926105124dd4.displayName = "Transition";
const $69d77440ef71bcfd$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $69d77440ef71bcfd$var$TransitionPropsValidators = $69d77440ef71bcfd$export$be58926105124dd4.props = /*#__PURE__*/ (0, $ciGHN.extend)({}, (0, $e1gjy.BaseTransition).props, $69d77440ef71bcfd$var$DOMTransitionPropsValidators);
/**
 * #3227 Incoming hooks may be merged into arrays when wrapping Transition
 * with custom HOCs.
 */ const $69d77440ef71bcfd$var$callHook = (hook, args = [])=>{
    if ((0, $ciGHN.isArray)(hook)) hook.forEach((h)=>h(...args));
    else if (hook) hook(...args);
};
/**
 * Check if a hook expects a callback (2nd arg), which means the user
 * intends to explicitly control the end of the transition.
 */ const $69d77440ef71bcfd$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $ciGHN.isArray)(hook) ? hook.some((h)=>h.length > 1) : hook.length > 1 : false;
};
function $69d77440ef71bcfd$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $69d77440ef71bcfd$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $69d77440ef71bcfd$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done)=>{
        $69d77440ef71bcfd$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $69d77440ef71bcfd$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        $69d77440ef71bcfd$var$removeTransitionClass(el, leaveToClass);
        $69d77440ef71bcfd$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $69d77440ef71bcfd$var$callHook(hook, [
                el,
                resolve
            ]);
            $69d77440ef71bcfd$var$nextFrame(()=>{
                $69d77440ef71bcfd$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $69d77440ef71bcfd$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$69d77440ef71bcfd$var$hasExplicitCallback(hook)) $69d77440ef71bcfd$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $ciGHN.extend)(baseProps, {
        onBeforeEnter (el) {
            $69d77440ef71bcfd$var$callHook(onBeforeEnter, [
                el
            ]);
            $69d77440ef71bcfd$var$addTransitionClass(el, enterFromClass);
            $69d77440ef71bcfd$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $69d77440ef71bcfd$var$callHook(onBeforeAppear, [
                el
            ]);
            $69d77440ef71bcfd$var$addTransitionClass(el, appearFromClass);
            $69d77440ef71bcfd$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            const resolve = ()=>finishLeave(el, done);
            $69d77440ef71bcfd$var$addTransitionClass(el, leaveFromClass);
            // force reflow so *-leave-from classes immediately take effect (#2593)
            $69d77440ef71bcfd$var$forceReflow();
            $69d77440ef71bcfd$var$addTransitionClass(el, leaveActiveClass);
            $69d77440ef71bcfd$var$nextFrame(()=>{
                $69d77440ef71bcfd$var$removeTransitionClass(el, leaveFromClass);
                $69d77440ef71bcfd$var$addTransitionClass(el, leaveToClass);
                if (!$69d77440ef71bcfd$var$hasExplicitCallback(onLeave)) $69d77440ef71bcfd$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $69d77440ef71bcfd$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false);
            $69d77440ef71bcfd$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true);
            $69d77440ef71bcfd$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $69d77440ef71bcfd$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $69d77440ef71bcfd$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $ciGHN.isObject)(duration)) return [
        $69d77440ef71bcfd$var$NumberOf(duration.enter),
        $69d77440ef71bcfd$var$NumberOf(duration.leave)
    ];
    else {
        const n = $69d77440ef71bcfd$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $69d77440ef71bcfd$var$NumberOf(val) {
    const res = (0, $ciGHN.toNumber)(val);
    return res;
}
function $69d77440ef71bcfd$var$validateDuration(val) {
    if (typeof val !== "number") (0, $e1gjy.warn)(`<transition> explicit duration is not a valid number - ` + `got ${JSON.stringify(val)}.`);
    else if (isNaN(val)) (0, $e1gjy.warn)(`<transition> explicit duration is NaN - ` + "the duration expression might be incorrect.");
}
function $69d77440ef71bcfd$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el._vtc || (el._vtc = new Set())).add(cls);
}
function $69d77440ef71bcfd$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const { _vtc: _vtc } = el;
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el._vtc = undefined;
    }
}
function $69d77440ef71bcfd$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $69d77440ef71bcfd$var$endId = 0;
function $69d77440ef71bcfd$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$69d77440ef71bcfd$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $69d77440ef71bcfd$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $69d77440ef71bcfd$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    // JSDOM may return undefined for transition properties
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties($69d77440ef71bcfd$var$TRANSITION + "Delay");
    const transitionDurations = getStyleProperties($69d77440ef71bcfd$var$TRANSITION + "Duration");
    const transitionTimeout = $69d77440ef71bcfd$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties($69d77440ef71bcfd$var$ANIMATION + "Delay");
    const animationDurations = getStyleProperties($69d77440ef71bcfd$var$ANIMATION + "Duration");
    const animationTimeout = $69d77440ef71bcfd$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    /* istanbul ignore if */ if (expectedType === $69d77440ef71bcfd$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $69d77440ef71bcfd$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $69d77440ef71bcfd$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $69d77440ef71bcfd$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $69d77440ef71bcfd$var$TRANSITION : $69d77440ef71bcfd$var$ANIMATION : null;
        propCount = type ? type === $69d77440ef71bcfd$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $69d77440ef71bcfd$var$TRANSITION && /\b(transform|all)(,|$)/.test(styles[$69d77440ef71bcfd$var$TRANSITION + "Property"]);
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $69d77440ef71bcfd$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$69d77440ef71bcfd$var$toMs(d) + $69d77440ef71bcfd$var$toMs(delays[i])));
}
// Old versions of Chromium (below 61.0.3163.100) formats floating pointer
// numbers in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down
// (i.e. acting as a floor function) causing unexpected behaviors
function $69d77440ef71bcfd$var$toMs(s) {
    return Number(s.slice(0, -1).replace(",", ".")) * 1000;
}
// synchronously force layout to put elements into a certain state
function $69d77440ef71bcfd$var$forceReflow() {
    return document.body.offsetHeight;
}
const $69d77440ef71bcfd$var$positionMap = new WeakMap();
const $69d77440ef71bcfd$var$newPositionMap = new WeakMap();
const $69d77440ef71bcfd$var$TransitionGroupImpl = {
    name: "TransitionGroup",
    props: /*#__PURE__*/ (0, $ciGHN.extend)({}, $69d77440ef71bcfd$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $e1gjy.getCurrentInstance)();
        const state = (0, $e1gjy.useTransitionState)();
        let prevChildren;
        let children;
        (0, $e1gjy.onUpdated)(()=>{
            // children is guaranteed to exist after initial render
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$69d77440ef71bcfd$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            // we divide the work into three loops to avoid mixing DOM reads and writes
            // in each iteration - which helps prevent layout thrashing.
            prevChildren.forEach($69d77440ef71bcfd$var$callPendingCbs);
            prevChildren.forEach($69d77440ef71bcfd$var$recordPosition);
            const movedChildren = prevChildren.filter($69d77440ef71bcfd$var$applyTranslation);
            // force reflow to put everything in position
            $69d77440ef71bcfd$var$forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $69d77440ef71bcfd$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el._moveCb = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el._moveCb = null;
                        $69d77440ef71bcfd$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return ()=>{
            const rawProps = (0, $aTBEd.toRaw)(props);
            const cssTransitionProps = $69d77440ef71bcfd$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $e1gjy.Fragment);
            prevChildren = children;
            children = slots.default ? (0, $e1gjy.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $e1gjy.setTransitionHooks)(child, (0, $e1gjy.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            if (prevChildren) for(let i = 0; i < prevChildren.length; i++){
                const child = prevChildren[i];
                (0, $e1gjy.setTransitionHooks)(child, (0, $e1gjy.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                $69d77440ef71bcfd$var$positionMap.set(child, child.el.getBoundingClientRect());
            }
            return (0, $e1gjy.createVNode)(tag, null, children);
        };
    }
};
const $69d77440ef71bcfd$export$19ffa8f511f7bc2e = $69d77440ef71bcfd$var$TransitionGroupImpl;
function $69d77440ef71bcfd$var$callPendingCbs(c) {
    const el = c.el;
    if (el._moveCb) el._moveCb();
    if (el._enterCb) el._enterCb();
}
function $69d77440ef71bcfd$var$recordPosition(c) {
    $69d77440ef71bcfd$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $69d77440ef71bcfd$var$applyTranslation(c) {
    const oldPos = $69d77440ef71bcfd$var$positionMap.get(c);
    const newPos = $69d77440ef71bcfd$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $69d77440ef71bcfd$var$hasCSSTransform(el, root, moveClass) {
    // Detect whether an element with the move class applied has
    // CSS transitions. Since the element may be inside an entering
    // transition at this very moment, we make a clone of it and remove
    // all other transition classes applied to ensure only the move class
    // is applied.
    const clone = el.cloneNode();
    if (el._vtc) el._vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $69d77440ef71bcfd$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $69d77440ef71bcfd$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"];
    return (0, $ciGHN.isArray)(fn) ? (value)=>(0, $ciGHN.invokeArrayFns)(fn, value) : fn;
};
function $69d77440ef71bcfd$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $69d77440ef71bcfd$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        $69d77440ef71bcfd$var$trigger(target, "input");
    }
}
function $69d77440ef71bcfd$var$trigger(el, type) {
    const e = document.createEvent("HTMLEvents");
    e.initEvent(type, true, true);
    el.dispatchEvent(e);
}
// We are exporting the v-model runtime directly as vnode hooks so that it can
// be tree-shaken in case v-model is never used.
const $69d77440ef71bcfd$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el._assign = $69d77440ef71bcfd$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $69d77440ef71bcfd$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            else if (castToNumber) domValue = (0, $ciGHN.toNumber)(domValue);
            el._assign(domValue);
        });
        if (trim) $69d77440ef71bcfd$var$addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            $69d77440ef71bcfd$var$addEventListener(el, "compositionstart", $69d77440ef71bcfd$var$onCompositionStart);
            $69d77440ef71bcfd$var$addEventListener(el, "compositionend", $69d77440ef71bcfd$var$onCompositionEnd);
            // Safari < 10.2 & UIWebView doesn't fire compositionend when
            // switching focus before confirming composition choice
            // this also fixes the issue where some browsers e.g. iOS Chrome
            // fires "change" instead of "input" on autocomplete.
            $69d77440ef71bcfd$var$addEventListener(el, "change", $69d77440ef71bcfd$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el._assign = $69d77440ef71bcfd$var$getModelAssigner(vnode);
        // avoid clearing unresolved text. #2302
        if (el.composing) return;
        if (document.activeElement === el) {
            if (lazy) return;
            if (trim && el.value.trim() === value) return;
            if ((number || el.type === "number") && (0, $ciGHN.toNumber)(el.value) === value) return;
        }
        const newValue = value == null ? "" : value;
        if (el.value !== newValue) el.value = newValue;
    }
};
const $69d77440ef71bcfd$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el._assign = $69d77440ef71bcfd$var$getModelAssigner(vnode);
        $69d77440ef71bcfd$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $69d77440ef71bcfd$var$getValue(el);
            const checked = el.checked;
            const assign = el._assign;
            if ((0, $ciGHN.isArray)(modelValue)) {
                const index = (0, $ciGHN.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $ciGHN.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($69d77440ef71bcfd$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $69d77440ef71bcfd$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el._assign = $69d77440ef71bcfd$var$getModelAssigner(vnode);
        $69d77440ef71bcfd$var$setChecked(el, binding, vnode);
    }
};
function $69d77440ef71bcfd$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    if ((0, $ciGHN.isArray)(value)) el.checked = (0, $ciGHN.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $ciGHN.isSet)(value)) el.checked = value.has(vnode.props.value);
    else if (value !== oldValue) el.checked = (0, $ciGHN.looseEqual)(value, $69d77440ef71bcfd$var$getCheckboxValue(el, true));
}
const $69d77440ef71bcfd$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $ciGHN.looseEqual)(value, vnode.props.value);
        el._assign = $69d77440ef71bcfd$var$getModelAssigner(vnode);
        $69d77440ef71bcfd$var$addEventListener(el, "change", ()=>{
            el._assign($69d77440ef71bcfd$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el._assign = $69d77440ef71bcfd$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $ciGHN.looseEqual)(value, vnode.props.value);
    }
};
const $69d77440ef71bcfd$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $ciGHN.isSet)(value);
        $69d77440ef71bcfd$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $ciGHN.toNumber)($69d77440ef71bcfd$var$getValue(o)) : $69d77440ef71bcfd$var$getValue(o));
            el._assign(el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
        });
        el._assign = $69d77440ef71bcfd$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $69d77440ef71bcfd$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el._assign = $69d77440ef71bcfd$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        $69d77440ef71bcfd$var$setSelected(el, value);
    }
};
function $69d77440ef71bcfd$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    if (isMultiple && !(0, $ciGHN.isArray)(value) && !(0, $ciGHN.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $69d77440ef71bcfd$var$getValue(option);
        if (isMultiple) {
            if ((0, $ciGHN.isArray)(value)) option.selected = (0, $ciGHN.looseIndexOf)(value, optionValue) > -1;
            else option.selected = value.has(optionValue);
        } else if ((0, $ciGHN.looseEqual)($69d77440ef71bcfd$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
// retrieve raw value set via :value bindings
function $69d77440ef71bcfd$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
// retrieve raw value for true-value and false-value set via :true-value or :false-value bindings
function $69d77440ef71bcfd$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $69d77440ef71bcfd$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $69d77440ef71bcfd$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $69d77440ef71bcfd$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $69d77440ef71bcfd$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $69d77440ef71bcfd$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $69d77440ef71bcfd$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    let modelToUse;
    switch(el.tagName){
        case "SELECT":
            modelToUse = $69d77440ef71bcfd$export$87d227567b51ca39;
            break;
        case "TEXTAREA":
            modelToUse = $69d77440ef71bcfd$export$f1f88689f5728478;
            break;
        default:
            switch(vnode.props && vnode.props.type){
                case "checkbox":
                    modelToUse = $69d77440ef71bcfd$export$8847c2e532b35714;
                    break;
                case "radio":
                    modelToUse = $69d77440ef71bcfd$export$b4356c59b38b7aa9;
                    break;
                default:
                    modelToUse = $69d77440ef71bcfd$export$f1f88689f5728478;
            }
    }
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
// SSR vnode transforms, only used when user includes client-oriented render
// function in SSR
function $69d77440ef71bcfd$var$initVModelForSSR() {
    $69d77440ef71bcfd$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $69d77440ef71bcfd$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $ciGHN.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $69d77440ef71bcfd$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $ciGHN.isArray)(value)) {
            if (vnode.props && (0, $ciGHN.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $ciGHN.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
}
const $69d77440ef71bcfd$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $69d77440ef71bcfd$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$69d77440ef71bcfd$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
/**
 * @private
 */ const $69d77440ef71bcfd$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    return (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $69d77440ef71bcfd$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    };
};
// Kept for 2.x compat.
// Note: IE11 compat for `spacebar` and `del` is removed for now.
const $69d77440ef71bcfd$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
/**
 * @private
 */ const $69d77440ef71bcfd$export$f691a8759658f782 = (fn, modifiers)=>{
    return (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $ciGHN.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $69d77440ef71bcfd$var$keyNames[k] === eventKey)) return fn(event);
    };
};
const $69d77440ef71bcfd$export$5cb4fcdc6937d7e1 = {
    beforeMount (el, { value: value }, { transition: transition }) {
        el._vod = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $69d77440ef71bcfd$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $69d77440ef71bcfd$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $69d77440ef71bcfd$var$setDisplay(el, false);
            });
        } else $69d77440ef71bcfd$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $69d77440ef71bcfd$var$setDisplay(el, value);
    }
};
function $69d77440ef71bcfd$var$setDisplay(el, value) {
    el.style.display = value ? el._vod : "none";
}
// SSR vnode transforms, only used when user includes client-oriented render
// function in SSR
function $69d77440ef71bcfd$var$initVShowForSSR() {
    $69d77440ef71bcfd$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $69d77440ef71bcfd$var$rendererOptions = (0, $ciGHN.extend)({
    patchProp: $69d77440ef71bcfd$var$patchProp
}, $69d77440ef71bcfd$var$nodeOps);
// lazy create the renderer - this makes core renderer logic tree-shakable
// in case the user only imports reactivity utilities from Vue.
let $69d77440ef71bcfd$var$renderer;
let $69d77440ef71bcfd$var$enabledHydration = false;
function $69d77440ef71bcfd$var$ensureRenderer() {
    return $69d77440ef71bcfd$var$renderer || ($69d77440ef71bcfd$var$renderer = (0, $e1gjy.createRenderer)($69d77440ef71bcfd$var$rendererOptions));
}
function $69d77440ef71bcfd$var$ensureHydrationRenderer() {
    $69d77440ef71bcfd$var$renderer = $69d77440ef71bcfd$var$enabledHydration ? $69d77440ef71bcfd$var$renderer : (0, $e1gjy.createHydrationRenderer)($69d77440ef71bcfd$var$rendererOptions);
    $69d77440ef71bcfd$var$enabledHydration = true;
    return $69d77440ef71bcfd$var$renderer;
}
// use explicit type casts here to avoid import() calls in rolled-up d.ts
const $69d77440ef71bcfd$export$b3890eb0ae9dca99 = (...args)=>{
    $69d77440ef71bcfd$var$ensureRenderer().render(...args);
};
const $69d77440ef71bcfd$export$fa8d919ba61d84db = (...args)=>{
    $69d77440ef71bcfd$var$ensureHydrationRenderer().hydrate(...args);
};
const $69d77440ef71bcfd$export$4e373c34abfa8c68 = (...args)=>{
    const app = $69d77440ef71bcfd$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $69d77440ef71bcfd$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $ciGHN.isFunction)(component) && !component.render && !component.template) // __UNSAFE__
        // Reason: potential execution of JS expressions in in-DOM template.
        // The user must make sure the in-DOM template is trusted. If it's
        // rendered by the server, the template should not contain any user data.
        component.template = container.innerHTML;
        // clear content before mounting
        container.innerHTML = "";
        const proxy = mount(container, false, container instanceof SVGElement);
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $69d77440ef71bcfd$export$35800275c0037383 = (...args)=>{
    const app = $69d77440ef71bcfd$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $69d77440ef71bcfd$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, container instanceof SVGElement);
    };
    return app;
};
function $69d77440ef71bcfd$var$injectNativeTagCheck(app) {
    // Inject `isNativeTag`
    // this is used for component name validation (dev only)
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $ciGHN.isHTMLTag)(tag) || (0, $ciGHN.isSVGTag)(tag),
        writable: false
    });
}
// dev only
function $69d77440ef71bcfd$var$injectCompilerOptionsCheck(app) {
    if ((0, $e1gjy.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $e1gjy.warn)(`The \`isCustomElement\` config option is deprecated. Use ` + `\`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using ` + `a build of Vue.js that includes the runtime compiler (aka "full build"). ` + `Since you are using the runtime-only build, \`compilerOptions\` ` + `must be passed to \`@vue/compiler-dom\` in the build setup instead.\n` + `- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.\n` + `- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader\n` + `- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-dom`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $e1gjy.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $e1gjy.warn)(msg);
            }
        });
    }
}
function $69d77440ef71bcfd$var$normalizeContainer(container) {
    if ((0, $ciGHN.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $69d77440ef71bcfd$var$ssrDirectiveInitialized = false;
/**
 * @internal
 */ const $69d77440ef71bcfd$export$800b28255aa678d9 = ()=>{
    if (!$69d77440ef71bcfd$var$ssrDirectiveInitialized) {
        $69d77440ef71bcfd$var$ssrDirectiveInitialized = true;
        $69d77440ef71bcfd$var$initVModelForSSR();
        $69d77440ef71bcfd$var$initVShowForSSR();
    }
};

});
parcelRegister("e1gjy", function(module, exports) {

$parcel$export(module.exports, "warn", function () { return $a34dd0657f3f171d$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return $a34dd0657f3f171d$export$dae85862a8d94378; });
$parcel$export(module.exports, "nextTick", function () { return $a34dd0657f3f171d$export$bdd553fddd433dcb; });
$parcel$export(module.exports, "Fragment", function () { return $a34dd0657f3f171d$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Static", function () { return $a34dd0657f3f171d$export$c1b9a1d3af45b7b6; });
$parcel$export(module.exports, "pushScopeId", function () { return $a34dd0657f3f171d$export$ac020265ca2cc4cd; });
$parcel$export(module.exports, "popScopeId", function () { return $a34dd0657f3f171d$export$f2dc6805dc11834e; });
$parcel$export(module.exports, "withCtx", function () { return $a34dd0657f3f171d$export$694b237e827a3d23; });
$parcel$export(module.exports, "createVNode", function () { return $a34dd0657f3f171d$export$bf5c4cf060303d58; });
$parcel$export(module.exports, "openBlock", function () { return $a34dd0657f3f171d$export$e7eaa45e502fe5cc; });
$parcel$export(module.exports, "watchPostEffect", function () { return $a34dd0657f3f171d$export$b7f27ea67102d543; });
$parcel$export(module.exports, "useTransitionState", function () { return $a34dd0657f3f171d$export$d2a0a1bc267c90f6; });
$parcel$export(module.exports, "onMounted", function () { return $a34dd0657f3f171d$export$6d1641039221b5cb; });
$parcel$export(module.exports, "getCurrentInstance", function () { return $a34dd0657f3f171d$export$f13e630aa3915748; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return $a34dd0657f3f171d$export$a67f9b1229c7c97a; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return $a34dd0657f3f171d$export$76ac1779589cd824; });
$parcel$export(module.exports, "setTransitionHooks", function () { return $a34dd0657f3f171d$export$7770a22486565649; });
$parcel$export(module.exports, "BaseTransition", function () { return $a34dd0657f3f171d$export$abd95b5f5e8a8837; });
$parcel$export(module.exports, "defineComponent", function () { return $a34dd0657f3f171d$export$afa64b67e5a01c3b; });
$parcel$export(module.exports, "onUpdated", function () { return $a34dd0657f3f171d$export$5876c47052fb88b1; });
$parcel$export(module.exports, "onUnmounted", function () { return $a34dd0657f3f171d$export$13348a43ccacfe58; });
$parcel$export(module.exports, "withDirectives", function () { return $a34dd0657f3f171d$export$49729353e7c1e6c5; });
$parcel$export(module.exports, "createTextVNode", function () { return $a34dd0657f3f171d$export$22f9b5ffd89dac9; });
$parcel$export(module.exports, "createRenderer", function () { return $a34dd0657f3f171d$export$53ae2f996c64e9a; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return $a34dd0657f3f171d$export$200524cf0d997ff0; });
$parcel$export(module.exports, "resolveComponent", function () { return $a34dd0657f3f171d$export$681d65eec9d1d1e8; });
$parcel$export(module.exports, "createElementBlock", function () { return $a34dd0657f3f171d$export$167055419fc69ec1; });
$parcel$export(module.exports, "createElementVNode", function () { return $a34dd0657f3f171d$export$42098e0eaa15c48e; });
$parcel$export(module.exports, "createBlock", function () { return $a34dd0657f3f171d$export$9f2dfe8048dfb22b; });
$parcel$export(module.exports, "createCommentVNode", function () { return $a34dd0657f3f171d$export$49553837c7236d3c; });
$parcel$export(module.exports, "renderList", function () { return $a34dd0657f3f171d$export$4bf387f59bfc6d67; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return $a34dd0657f3f171d$export$c93a9c496c5211fa; });
$parcel$export(module.exports, "h", function () { return $a34dd0657f3f171d$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "initCustomFormatter", function () { return $a34dd0657f3f171d$export$aed4979be6a60047; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("aTBEd")).toRaw; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("ciGHN")).camelize; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("ciGHN")).normalizeClass; });

var $aTBEd = parcelRequire("aTBEd");

var $ciGHN = parcelRequire("ciGHN");
const $a34dd0657f3f171d$var$stack = [];
function $a34dd0657f3f171d$var$pushWarningContext(vnode) {
    $a34dd0657f3f171d$var$stack.push(vnode);
}
function $a34dd0657f3f171d$var$popWarningContext() {
    $a34dd0657f3f171d$var$stack.pop();
}
function $a34dd0657f3f171d$export$c106dd0671a0fc2d(msg, ...args) {
    // avoid props formatting or warn handler tracking deps that might be mutated
    // during patch, leading to infinite recursion.
    (0, $aTBEd.pauseTracking)();
    const instance = $a34dd0657f3f171d$var$stack.length ? $a34dd0657f3f171d$var$stack[$a34dd0657f3f171d$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $a34dd0657f3f171d$var$getComponentTrace();
    if (appWarnHandler) $a34dd0657f3f171d$export$b22fcaf88446e9bf(appWarnHandler, instance, 11 /* APP_WARN_HANDLER */ , [
        msg + args.join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$a34dd0657f3f171d$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        /* istanbul ignore if */ if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`\n`, ...$a34dd0657f3f171d$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $aTBEd.resetTracking)();
}
function $a34dd0657f3f171d$var$getComponentTrace() {
    let currentVNode = $a34dd0657f3f171d$var$stack[$a34dd0657f3f171d$var$stack.length - 1];
    if (!currentVNode) return [];
    // we can't just use the stack because it will be incomplete during updates
    // that did not start from the root. Re-construct the parent chain using
    // instance parent pointers.
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
/* istanbul ignore next */ function $a34dd0657f3f171d$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `\n`
        ], ...$a34dd0657f3f171d$var$formatTraceEntry(entry));
    });
    return logs;
}
function $a34dd0657f3f171d$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$a34dd0657f3f171d$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$a34dd0657f3f171d$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
/* istanbul ignore next */ function $a34dd0657f3f171d$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$a34dd0657f3f171d$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
/* istanbul ignore next */ function $a34dd0657f3f171d$var$formatProp(key, value, raw) {
    if ((0, $ciGHN.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $aTBEd.isRef)(value)) {
        value = $a34dd0657f3f171d$var$formatProp(key, (0, $aTBEd.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $ciGHN.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $aTBEd.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
const $a34dd0657f3f171d$var$ErrorTypeStrings = {
    ["sp" /* SERVER_PREFETCH */ ]: "serverPrefetch hook",
    ["bc" /* BEFORE_CREATE */ ]: "beforeCreate hook",
    ["c" /* CREATED */ ]: "created hook",
    ["bm" /* BEFORE_MOUNT */ ]: "beforeMount hook",
    ["m" /* MOUNTED */ ]: "mounted hook",
    ["bu" /* BEFORE_UPDATE */ ]: "beforeUpdate hook",
    ["u" /* UPDATED */ ]: "updated",
    ["bum" /* BEFORE_UNMOUNT */ ]: "beforeUnmount hook",
    ["um" /* UNMOUNTED */ ]: "unmounted hook",
    ["a" /* ACTIVATED */ ]: "activated hook",
    ["da" /* DEACTIVATED */ ]: "deactivated hook",
    ["ec" /* ERROR_CAPTURED */ ]: "errorCaptured hook",
    ["rtc" /* RENDER_TRACKED */ ]: "renderTracked hook",
    ["rtg" /* RENDER_TRIGGERED */ ]: "renderTriggered hook",
    [0 /* SETUP_FUNCTION */ ]: "setup function",
    [1 /* RENDER_FUNCTION */ ]: "render function",
    [2 /* WATCH_GETTER */ ]: "watcher getter",
    [3 /* WATCH_CALLBACK */ ]: "watcher callback",
    [4 /* WATCH_CLEANUP */ ]: "watcher cleanup function",
    [5 /* NATIVE_EVENT_HANDLER */ ]: "native event handler",
    [6 /* COMPONENT_EVENT_HANDLER */ ]: "component event handler",
    [7 /* VNODE_HOOK */ ]: "vnode hook",
    [8 /* DIRECTIVE_HOOK */ ]: "directive hook",
    [9 /* TRANSITION_HOOK */ ]: "transition hook",
    [10 /* APP_ERROR_HANDLER */ ]: "app errorHandler",
    [11 /* APP_WARN_HANDLER */ ]: "app warnHandler",
    [12 /* FUNCTION_REF */ ]: "ref function",
    [13 /* ASYNC_COMPONENT_LOADER */ ]: "async component loader",
    [14 /* SCHEDULER */ ]: "scheduler flush. This is likely a Vue internals bug. Please open an issue at https://new-issue.vuejs.org/?repo=vuejs/core"
};
function $a34dd0657f3f171d$export$b22fcaf88446e9bf(fn, instance, type, args) {
    let res;
    try {
        res = args ? fn(...args) : fn();
    } catch (err) {
        $a34dd0657f3f171d$export$d3da1ecaf1206c58(err, instance, type);
    }
    return res;
}
function $a34dd0657f3f171d$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $ciGHN.isFunction)(fn)) {
        const res = $a34dd0657f3f171d$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $ciGHN.isPromise)(res)) res.catch((err)=>{
            $a34dd0657f3f171d$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    const values = [];
    for(let i = 0; i < fn.length; i++)values.push($a34dd0657f3f171d$export$dae85862a8d94378(fn[i], instance, type, args));
    return values;
}
function $a34dd0657f3f171d$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    if (instance) {
        let cur = instance.parent;
        // the exposed instance is the render proxy to keep it consistent with 2.x
        const exposedInstance = instance.proxy;
        // in production the hook receives only the error code
        const errorInfo = type;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        // app-level handling
        const appErrorHandler = instance.appContext.config.errorHandler;
        if (appErrorHandler) {
            $a34dd0657f3f171d$export$b22fcaf88446e9bf(appErrorHandler, null, 10 /* APP_ERROR_HANDLER */ , [
                err,
                exposedInstance,
                errorInfo
            ]);
            return;
        }
    }
    $a34dd0657f3f171d$var$logError(err, type, contextVNode, throwInDev);
}
function $a34dd0657f3f171d$var$logError(err, type, contextVNode, throwInDev = true) {
    // recover in prod to reduce the impact on end-user
    console.error(err);
}
let $a34dd0657f3f171d$var$isFlushing = false;
let $a34dd0657f3f171d$var$isFlushPending = false;
const $a34dd0657f3f171d$var$queue = [];
let $a34dd0657f3f171d$var$flushIndex = 0;
const $a34dd0657f3f171d$var$pendingPreFlushCbs = [];
let $a34dd0657f3f171d$var$activePreFlushCbs = null;
let $a34dd0657f3f171d$var$preFlushIndex = 0;
const $a34dd0657f3f171d$var$pendingPostFlushCbs = [];
let $a34dd0657f3f171d$var$activePostFlushCbs = null;
let $a34dd0657f3f171d$var$postFlushIndex = 0;
const $a34dd0657f3f171d$var$resolvedPromise = Promise.resolve();
let $a34dd0657f3f171d$var$currentFlushPromise = null;
let $a34dd0657f3f171d$var$currentPreFlushParentJob = null;
const $a34dd0657f3f171d$var$RECURSION_LIMIT = 100;
function $a34dd0657f3f171d$export$bdd553fddd433dcb(fn) {
    const p = $a34dd0657f3f171d$var$currentFlushPromise || $a34dd0657f3f171d$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
// #2768
// Use binary-search to find a suitable position in the queue,
// so that the queue maintains the increasing order of job's id,
// which can prevent the job from being skipped and also can avoid repeated patching.
function $a34dd0657f3f171d$var$findInsertionIndex(id) {
    // the start index should be `flushIndex + 1`
    let start = $a34dd0657f3f171d$var$flushIndex + 1;
    let end = $a34dd0657f3f171d$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJobId = $a34dd0657f3f171d$var$getId($a34dd0657f3f171d$var$queue[middle]);
        middleJobId < id ? start = middle + 1 : end = middle;
    }
    return start;
}
function $a34dd0657f3f171d$var$queueJob(job) {
    // the dedupe search uses the startIndex argument of Array.includes()
    // by default the search index includes the current job that is being run
    // so it cannot recursively trigger itself again.
    // if the job is a watch() callback, the search will start with a +1 index to
    // allow it recursively trigger itself - it is the user's responsibility to
    // ensure it doesn't end up in an infinite loop.
    if ((!$a34dd0657f3f171d$var$queue.length || !$a34dd0657f3f171d$var$queue.includes(job, $a34dd0657f3f171d$var$isFlushing && job.allowRecurse ? $a34dd0657f3f171d$var$flushIndex + 1 : $a34dd0657f3f171d$var$flushIndex)) && job !== $a34dd0657f3f171d$var$currentPreFlushParentJob) {
        if (job.id == null) $a34dd0657f3f171d$var$queue.push(job);
        else $a34dd0657f3f171d$var$queue.splice($a34dd0657f3f171d$var$findInsertionIndex(job.id), 0, job);
        $a34dd0657f3f171d$var$queueFlush();
    }
}
function $a34dd0657f3f171d$var$queueFlush() {
    if (!$a34dd0657f3f171d$var$isFlushing && !$a34dd0657f3f171d$var$isFlushPending) {
        $a34dd0657f3f171d$var$isFlushPending = true;
        $a34dd0657f3f171d$var$currentFlushPromise = $a34dd0657f3f171d$var$resolvedPromise.then($a34dd0657f3f171d$var$flushJobs);
    }
}
function $a34dd0657f3f171d$var$invalidateJob(job) {
    const i = $a34dd0657f3f171d$var$queue.indexOf(job);
    if (i > $a34dd0657f3f171d$var$flushIndex) $a34dd0657f3f171d$var$queue.splice(i, 1);
}
function $a34dd0657f3f171d$var$queueCb(cb, activeQueue, pendingQueue, index) {
    if (!(0, $ciGHN.isArray)(cb)) {
        if (!activeQueue || !activeQueue.includes(cb, cb.allowRecurse ? index + 1 : index)) pendingQueue.push(cb);
    } else // if cb is an array, it is a component lifecycle hook which can only be
    // triggered by a job, which is already deduped in the main queue, so
    // we can skip duplicate check here to improve perf
    pendingQueue.push(...cb);
    $a34dd0657f3f171d$var$queueFlush();
}
function $a34dd0657f3f171d$var$queuePreFlushCb(cb) {
    $a34dd0657f3f171d$var$queueCb(cb, $a34dd0657f3f171d$var$activePreFlushCbs, $a34dd0657f3f171d$var$pendingPreFlushCbs, $a34dd0657f3f171d$var$preFlushIndex);
}
function $a34dd0657f3f171d$export$59536a0199721cab(cb) {
    $a34dd0657f3f171d$var$queueCb(cb, $a34dd0657f3f171d$var$activePostFlushCbs, $a34dd0657f3f171d$var$pendingPostFlushCbs, $a34dd0657f3f171d$var$postFlushIndex);
}
function $a34dd0657f3f171d$var$flushPreFlushCbs(seen, parentJob = null) {
    if ($a34dd0657f3f171d$var$pendingPreFlushCbs.length) {
        $a34dd0657f3f171d$var$currentPreFlushParentJob = parentJob;
        $a34dd0657f3f171d$var$activePreFlushCbs = [
            ...new Set($a34dd0657f3f171d$var$pendingPreFlushCbs)
        ];
        $a34dd0657f3f171d$var$pendingPreFlushCbs.length = 0;
        for($a34dd0657f3f171d$var$preFlushIndex = 0; $a34dd0657f3f171d$var$preFlushIndex < $a34dd0657f3f171d$var$activePreFlushCbs.length; $a34dd0657f3f171d$var$preFlushIndex++)$a34dd0657f3f171d$var$activePreFlushCbs[$a34dd0657f3f171d$var$preFlushIndex]();
        $a34dd0657f3f171d$var$activePreFlushCbs = null;
        $a34dd0657f3f171d$var$preFlushIndex = 0;
        $a34dd0657f3f171d$var$currentPreFlushParentJob = null;
        // recursively flush until it drains
        $a34dd0657f3f171d$var$flushPreFlushCbs(seen, parentJob);
    }
}
function $a34dd0657f3f171d$var$flushPostFlushCbs(seen) {
    if ($a34dd0657f3f171d$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($a34dd0657f3f171d$var$pendingPostFlushCbs)
        ];
        $a34dd0657f3f171d$var$pendingPostFlushCbs.length = 0;
        // #1947 already has active queue, nested flushPostFlushCbs call
        if ($a34dd0657f3f171d$var$activePostFlushCbs) {
            $a34dd0657f3f171d$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $a34dd0657f3f171d$var$activePostFlushCbs = deduped;
        $a34dd0657f3f171d$var$activePostFlushCbs.sort((a, b)=>$a34dd0657f3f171d$var$getId(a) - $a34dd0657f3f171d$var$getId(b));
        for($a34dd0657f3f171d$var$postFlushIndex = 0; $a34dd0657f3f171d$var$postFlushIndex < $a34dd0657f3f171d$var$activePostFlushCbs.length; $a34dd0657f3f171d$var$postFlushIndex++)$a34dd0657f3f171d$var$activePostFlushCbs[$a34dd0657f3f171d$var$postFlushIndex]();
        $a34dd0657f3f171d$var$activePostFlushCbs = null;
        $a34dd0657f3f171d$var$postFlushIndex = 0;
    }
}
const $a34dd0657f3f171d$var$getId = (job)=>job.id == null ? Infinity : job.id;
function $a34dd0657f3f171d$var$flushJobs(seen) {
    $a34dd0657f3f171d$var$isFlushPending = false;
    $a34dd0657f3f171d$var$isFlushing = true;
    $a34dd0657f3f171d$var$flushPreFlushCbs(seen);
    // Sort queue before flush.
    // This ensures that:
    // 1. Components are updated from parent to child. (because parent is always
    //    created before the child so its render effect will have smaller
    //    priority number)
    // 2. If a component is unmounted during a parent component's update,
    //    its update can be skipped.
    $a34dd0657f3f171d$var$queue.sort((a, b)=>$a34dd0657f3f171d$var$getId(a) - $a34dd0657f3f171d$var$getId(b));
    // conditional usage of checkRecursiveUpdate must be determined out of
    // try ... catch block since Rollup by default de-optimizes treeshaking
    // inside try-catch. This can leave all warning code unshaked. Although
    // they would get eventually shaken by a minifier like terser, some minifiers
    // would fail to do that (e.g. https://github.com/evanw/esbuild/issues/1610)
    const check = (0, $ciGHN.NOOP);
    try {
        for($a34dd0657f3f171d$var$flushIndex = 0; $a34dd0657f3f171d$var$flushIndex < $a34dd0657f3f171d$var$queue.length; $a34dd0657f3f171d$var$flushIndex++){
            const job = $a34dd0657f3f171d$var$queue[$a34dd0657f3f171d$var$flushIndex];
            if (job && job.active !== false) // console.log(`running:`, job.id)
            $a34dd0657f3f171d$export$b22fcaf88446e9bf(job, null, 14 /* SCHEDULER */ );
        }
    } finally{
        $a34dd0657f3f171d$var$flushIndex = 0;
        $a34dd0657f3f171d$var$queue.length = 0;
        $a34dd0657f3f171d$var$flushPostFlushCbs(seen);
        $a34dd0657f3f171d$var$isFlushing = false;
        $a34dd0657f3f171d$var$currentFlushPromise = null;
        // some postFlushCb queued jobs!
        // keep flushing until it drains.
        if ($a34dd0657f3f171d$var$queue.length || $a34dd0657f3f171d$var$pendingPreFlushCbs.length || $a34dd0657f3f171d$var$pendingPostFlushCbs.length) $a34dd0657f3f171d$var$flushJobs(seen);
    }
}
function $a34dd0657f3f171d$var$checkRecursiveUpdates(seen, fn) {
    if (!seen.has(fn)) seen.set(fn, 1);
    else {
        const count = seen.get(fn);
        if (count > $a34dd0657f3f171d$var$RECURSION_LIMIT) {
            const instance = fn.ownerInstance;
            const componentName = instance && $a34dd0657f3f171d$var$getComponentName(instance.type);
            $a34dd0657f3f171d$export$c106dd0671a0fc2d(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. ` + `This means you have a reactive effect that is mutating its own ` + `dependencies and thus recursively triggering itself. Possible sources ` + `include component template, render function, updated hook or ` + `watcher source function.`);
            return true;
        } else seen.set(fn, count + 1);
    }
}
/* eslint-disable no-restricted-globals */ let $a34dd0657f3f171d$var$isHmrUpdating = false;
const $a34dd0657f3f171d$var$hmrDirtyComponents = new Set();
const $a34dd0657f3f171d$var$map = new Map();
function $a34dd0657f3f171d$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $a34dd0657f3f171d$var$map.get(id);
    if (!record) {
        $a34dd0657f3f171d$var$createRecord(id, instance.type);
        record = $a34dd0657f3f171d$var$map.get(id);
    }
    record.instances.add(instance);
}
function $a34dd0657f3f171d$var$unregisterHMR(instance) {
    $a34dd0657f3f171d$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $a34dd0657f3f171d$var$createRecord(id, initialDef) {
    if ($a34dd0657f3f171d$var$map.has(id)) return false;
    $a34dd0657f3f171d$var$map.set(id, {
        initialDef: $a34dd0657f3f171d$var$normalizeClassComponent(initialDef),
        instances: new Set()
    });
    return true;
}
function $a34dd0657f3f171d$var$normalizeClassComponent(component) {
    return $a34dd0657f3f171d$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $a34dd0657f3f171d$var$rerender(id, newRender) {
    const record = $a34dd0657f3f171d$var$map.get(id);
    if (!record) return;
    // update initial record (for not-yet-rendered component)
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $a34dd0657f3f171d$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        // this flag forces child components with slot content to update
        $a34dd0657f3f171d$var$isHmrUpdating = true;
        instance.update();
        $a34dd0657f3f171d$var$isHmrUpdating = false;
    });
}
function $a34dd0657f3f171d$var$reload(id, newComp) {
    const record = $a34dd0657f3f171d$var$map.get(id);
    if (!record) return;
    newComp = $a34dd0657f3f171d$var$normalizeClassComponent(newComp);
    // update initial def (for not-yet-rendered components)
    $a34dd0657f3f171d$var$updateComponentDef(record.initialDef, newComp);
    // create a snapshot which avoids the set being mutated during updates
    const instances = [
        ...record.instances
    ];
    for (const instance of instances){
        const oldComp = $a34dd0657f3f171d$var$normalizeClassComponent(instance.type);
        if (!$a34dd0657f3f171d$var$hmrDirtyComponents.has(oldComp)) {
            // 1. Update existing comp definition to match new one
            if (oldComp !== record.initialDef) $a34dd0657f3f171d$var$updateComponentDef(oldComp, newComp);
            // 2. mark definition dirty. This forces the renderer to replace the
            // component on patch.
            $a34dd0657f3f171d$var$hmrDirtyComponents.add(oldComp);
        }
        // 3. invalidate options resolution cache
        instance.appContext.optionsCache.delete(instance.type);
        // 4. actually update
        if (instance.ceReload) {
            // custom element
            $a34dd0657f3f171d$var$hmrDirtyComponents.add(oldComp);
            instance.ceReload(newComp.styles);
            $a34dd0657f3f171d$var$hmrDirtyComponents.delete(oldComp);
        } else if (instance.parent) {
            // 4. Force the parent instance to re-render. This will cause all updated
            // components to be unmounted and re-mounted. Queue the update so that we
            // don't end up forcing the same parent to re-render multiple times.
            $a34dd0657f3f171d$var$queueJob(instance.parent.update);
            // instance is the inner component of an async custom element
            // invoke to reset styles
            if (instance.parent.type.__asyncLoader && instance.parent.ceReload) instance.parent.ceReload(newComp.styles);
        } else if (instance.appContext.reload) // root instance mounted via createApp() has a reload method
        instance.appContext.reload();
        else if (typeof window !== "undefined") // root instance inside tree created via raw render(). Force reload.
        window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
    }
    // 5. make sure to cleanup dirty hmr components after update
    $a34dd0657f3f171d$export$59536a0199721cab(()=>{
        for (const instance of instances)$a34dd0657f3f171d$var$hmrDirtyComponents.delete($a34dd0657f3f171d$var$normalizeClassComponent(instance.type));
    });
}
function $a34dd0657f3f171d$var$updateComponentDef(oldComp, newComp) {
    (0, $ciGHN.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $a34dd0657f3f171d$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. ` + `Full reload required.`);
        }
    };
}
let $a34dd0657f3f171d$export$6922d3b3a607469e;
let $a34dd0657f3f171d$var$buffer = [];
let $a34dd0657f3f171d$var$devtoolsNotInstalled = false;
function $a34dd0657f3f171d$var$emit(event, ...args) {
    if ($a34dd0657f3f171d$export$6922d3b3a607469e) $a34dd0657f3f171d$export$6922d3b3a607469e.emit(event, ...args);
    else if (!$a34dd0657f3f171d$var$devtoolsNotInstalled) $a34dd0657f3f171d$var$buffer.push({
        event: event,
        args: args
    });
}
function $a34dd0657f3f171d$export$b0c258b32c26c785(hook, target) {
    var _a, _b;
    $a34dd0657f3f171d$export$6922d3b3a607469e = hook;
    if ($a34dd0657f3f171d$export$6922d3b3a607469e) {
        $a34dd0657f3f171d$export$6922d3b3a607469e.enabled = true;
        $a34dd0657f3f171d$var$buffer.forEach(({ event: event, args: args })=>$a34dd0657f3f171d$export$6922d3b3a607469e.emit(event, ...args));
        $a34dd0657f3f171d$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    // eslint-disable-next-line no-restricted-globals
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    !((_b = (_a = window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) === null || _b === void 0 ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $a34dd0657f3f171d$export$b0c258b32c26c785(newHook, target);
        });
        // clear buffer after 3s - the user probably doesn't have devtools installed
        // at all, and keeping the buffer will cause memory leaks (#4738)
        setTimeout(()=>{
            if (!$a34dd0657f3f171d$export$6922d3b3a607469e) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $a34dd0657f3f171d$var$devtoolsNotInstalled = true;
                $a34dd0657f3f171d$var$buffer = [];
            }
        }, 3000);
    } else {
        // non-browser env, assume not installed
        $a34dd0657f3f171d$var$devtoolsNotInstalled = true;
        $a34dd0657f3f171d$var$buffer = [];
    }
}
function $a34dd0657f3f171d$var$devtoolsInitApp(app, version) {
    $a34dd0657f3f171d$var$emit("app:init" /* APP_INIT */ , app, version, {
        Fragment: $a34dd0657f3f171d$export$ffb0004e005737fa,
        Text: $a34dd0657f3f171d$export$5f1af8db9871e1d6,
        Comment: $a34dd0657f3f171d$export$4d299b491347818a,
        Static: $a34dd0657f3f171d$export$c1b9a1d3af45b7b6
    });
}
function $a34dd0657f3f171d$var$devtoolsUnmountApp(app) {
    $a34dd0657f3f171d$var$emit("app:unmount" /* APP_UNMOUNT */ , app);
}
const $a34dd0657f3f171d$var$devtoolsComponentAdded = /*#__PURE__*/ $a34dd0657f3f171d$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $a34dd0657f3f171d$var$devtoolsComponentUpdated = /*#__PURE__*/ $a34dd0657f3f171d$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $a34dd0657f3f171d$var$devtoolsComponentRemoved = /*#__PURE__*/ $a34dd0657f3f171d$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
function $a34dd0657f3f171d$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $a34dd0657f3f171d$var$emit(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : undefined, component);
    };
}
const $a34dd0657f3f171d$var$devtoolsPerfStart = /*#__PURE__*/ $a34dd0657f3f171d$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $a34dd0657f3f171d$var$devtoolsPerfEnd = /*#__PURE__*/ $a34dd0657f3f171d$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $a34dd0657f3f171d$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $a34dd0657f3f171d$var$emit(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $a34dd0657f3f171d$var$devtoolsComponentEmit(component, event, params) {
    $a34dd0657f3f171d$var$emit("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
function $a34dd0657f3f171d$var$emit$1(instance, event, ...rawArgs) {
    const props = instance.vnode.props || (0, $ciGHN.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    // for v-model update:xxx events, apply modifiers on args
    const modelArg = isModelListener && event.slice(7);
    if (modelArg && modelArg in props) {
        const modifiersKey = `${modelArg === "modelValue" ? "model" : modelArg}Modifiers`;
        const { number: number, trim: trim } = props[modifiersKey] || (0, $ciGHN.EMPTY_OBJ);
        if (trim) args = rawArgs.map((a)=>a.trim());
        else if (number) args = rawArgs.map((0, $ciGHN.toNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $a34dd0657f3f171d$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $ciGHN.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $ciGHN.toHandlerKey)((0, $ciGHN.camelize)(event))];
    // for v-model update:xxx events, also trigger kebab-case equivalent
    // for props passed via kebab-case
    if (!handler && isModelListener) handler = props[handlerName = (0, $ciGHN.toHandlerKey)((0, $ciGHN.hyphenate)(event))];
    if (handler) $a34dd0657f3f171d$export$dae85862a8d94378(handler, instance, 6 /* COMPONENT_EVENT_HANDLER */ , args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $a34dd0657f3f171d$export$dae85862a8d94378(onceHandler, instance, 6 /* COMPONENT_EVENT_HANDLER */ , args);
    }
}
function $a34dd0657f3f171d$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== undefined) return cached;
    const raw = comp.emits;
    let normalized = {};
    // apply mixin/extends props
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $ciGHN.isFunction)(comp)) {
        const extendEmits = (raw)=>{
            const normalizedFromExtend = $a34dd0657f3f171d$var$normalizeEmitsOptions(raw, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $ciGHN.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        cache.set(comp, null);
        return null;
    }
    if ((0, $ciGHN.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $ciGHN.extend)(normalized, raw);
    cache.set(comp, normalized);
    return normalized;
}
// Check if an incoming prop key is a declared emit event listener.
// e.g. With `emits: { click: null }`, props named `onClick` and `onclick` are
// both considered matched listeners.
function $a34dd0657f3f171d$var$isEmitListener(options, key) {
    if (!options || !(0, $ciGHN.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $ciGHN.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $ciGHN.hasOwn)(options, (0, $ciGHN.hyphenate)(key)) || (0, $ciGHN.hasOwn)(options, key);
}
/**
 * mark the current rendering instance for asset resolution (e.g.
 * resolveComponent, resolveDirective) during render
 */ let $a34dd0657f3f171d$var$currentRenderingInstance = null;
let $a34dd0657f3f171d$var$currentScopeId = null;
/**
 * Note: rendering calls maybe nested. The function returns the parent rendering
 * instance if present, which should be restored after the render is done:
 *
 * ```js
 * const prev = setCurrentRenderingInstance(i)
 * // ...render
 * setCurrentRenderingInstance(prev)
 * ```
 */ function $a34dd0657f3f171d$var$setCurrentRenderingInstance(instance) {
    const prev = $a34dd0657f3f171d$var$currentRenderingInstance;
    $a34dd0657f3f171d$var$currentRenderingInstance = instance;
    $a34dd0657f3f171d$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
/**
 * Set scope id when creating hoisted vnodes.
 * @private compiler helper
 */ function $a34dd0657f3f171d$export$ac020265ca2cc4cd(id) {
    $a34dd0657f3f171d$var$currentScopeId = id;
}
/**
 * Technically we no longer need this after 3.0.8 but we need to keep the same
 * API for backwards compat w/ code generated by compilers.
 * @private
 */ function $a34dd0657f3f171d$export$f2dc6805dc11834e() {
    $a34dd0657f3f171d$var$currentScopeId = null;
}
/**
 * Only for backwards compat
 * @private
 */ const $a34dd0657f3f171d$export$15ba313e13f3dd04 = (_id)=>$a34dd0657f3f171d$export$694b237e827a3d23;
/**
 * Wrap a slot function to memoize current rendering instance
 * @private compiler helper
 */ function $a34dd0657f3f171d$export$694b237e827a3d23(fn, ctx = $a34dd0657f3f171d$var$currentRenderingInstance, isNonScopedSlot // false only
) {
    if (!ctx) return fn;
    // already normalized
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        // If a user calls a compiled slot inside a template expression (#1745), it
        // can mess up block tracking, so by default we disable block tracking and
        // force bail out when invoking a compiled slot (indicated by the ._d flag).
        // This isn't necessary if rendering a compiled `<slot>`, so we flip the
        // ._d flag off when invoking the wrapped fn inside `renderSlot`.
        if (renderFnWithContext._d) $a34dd0657f3f171d$export$c20bee82f26f1e27(-1);
        const prevInstance = $a34dd0657f3f171d$var$setCurrentRenderingInstance(ctx);
        const res = fn(...args);
        $a34dd0657f3f171d$var$setCurrentRenderingInstance(prevInstance);
        if (renderFnWithContext._d) $a34dd0657f3f171d$export$c20bee82f26f1e27(1);
        if (__VUE_PROD_DEVTOOLS__) $a34dd0657f3f171d$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    // mark normalized to avoid duplicated wrapping
    renderFnWithContext._n = true;
    // mark this as compiled by default
    // this is used in vnode.ts -> normalizeChildren() to set the slot
    // rendering flag.
    renderFnWithContext._c = true;
    // disable block tracking by default
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
/**
 * dev only flag to track whether $attrs was used during render.
 * If $attrs was used during render then the warning for failed attrs
 * fallthrough can be suppressed.
 */ let $a34dd0657f3f171d$var$accessedAttrs = false;
function $a34dd0657f3f171d$var$markAttrsAccessed() {
    $a34dd0657f3f171d$var$accessedAttrs = true;
}
function $a34dd0657f3f171d$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, props: props, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    let result;
    let fallthroughAttrs;
    const prev = $a34dd0657f3f171d$var$setCurrentRenderingInstance(instance);
    try {
        if (vnode.shapeFlag & 4 /* STATEFUL_COMPONENT */ ) {
            // withProxy is a proxy with a different `has` trap only for
            // runtime-compiled render functions using `with` block.
            const proxyToUse = withProxy || proxy;
            result = $a34dd0657f3f171d$var$normalizeVNode(render.call(proxyToUse, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            // functional
            const render = Component;
            result = $a34dd0657f3f171d$var$normalizeVNode(render.length > 1 ? render(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render(props, null));
            fallthroughAttrs = Component.props ? attrs : $a34dd0657f3f171d$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $a34dd0657f3f171d$var$blockStack.length = 0;
        $a34dd0657f3f171d$export$d3da1ecaf1206c58(err, instance, 1 /* RENDER_FUNCTION */ );
        result = $a34dd0657f3f171d$export$bf5c4cf060303d58($a34dd0657f3f171d$export$4d299b491347818a);
    }
    // attr merging
    // in dev mode, comments are preserved, and it's possible for a template
    // to have comments along side the root element which makes it a fragment
    let root = result;
    let setRoot = undefined;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7 /* COMPONENT */ ) {
                if (propsOptions && keys.some((0, $ciGHN.isModelListener))) // If a v-model listener (onUpdate:xxx) has a corresponding declared
                // prop, it indicates this component expects to handle v-model and
                // it should not fallthrough.
                // related: #1543, #1643, #1989
                fallthroughAttrs = $a34dd0657f3f171d$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $a34dd0657f3f171d$export$ee4f9e12c0a92a1a(root, fallthroughAttrs);
            }
        }
    }
    // inherit directives
    if (vnode.dirs) root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    // inherit transition data
    if (vnode.transition) root.transition = vnode.transition;
    result = root;
    $a34dd0657f3f171d$var$setCurrentRenderingInstance(prev);
    return result;
}
/**
 * dev only
 * In dev mode, template root level comments are rendered, which turns the
 * template into a fragment root, but we need to locate the single element
 * root for attrs and scope id processing.
 */ const $a34dd0657f3f171d$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $a34dd0657f3f171d$var$filterSingleRoot(rawChildren);
    if (!childRoot) return [
        vnode,
        undefined
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $a34dd0657f3f171d$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $a34dd0657f3f171d$var$filterSingleRoot(children) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($a34dd0657f3f171d$export$3868d13f8734ae81(child)) // ignore user comment
        {
            if (child.type !== $a34dd0657f3f171d$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) // has more than 1 non-comment child, return now
                return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $a34dd0657f3f171d$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $ciGHN.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $a34dd0657f3f171d$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $ciGHN.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $a34dd0657f3f171d$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 /* ELEMENT */  || vnode.type === $a34dd0657f3f171d$export$4d299b491347818a // potential v-if branch switch
    ;
};
function $a34dd0657f3f171d$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    // force child update for runtime directive or transition on component vnode.
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024 /* DYNAMIC_SLOTS */ ) // slot content that references values that might have changed,
        // e.g. in a v-for
        return true;
        if (patchFlag & 16 /* FULL_PROPS */ ) {
            if (!prevProps) return !!nextProps;
            // presence of this flag indicates props are always non-null
            return $a34dd0657f3f171d$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8 /* PROPS */ ) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$a34dd0657f3f171d$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        // this path is only taken by manually written render functions
        // so presence of any children leads to a forced update
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $a34dd0657f3f171d$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $a34dd0657f3f171d$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$a34dd0657f3f171d$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $a34dd0657f3f171d$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el // HostNode
) {
    while(parent && parent.subTree === vnode){
        (vnode = parent.vnode).el = el;
        parent = parent.parent;
    }
}
const $a34dd0657f3f171d$var$isSuspense = (type)=>type.__isSuspense;
// Suspense exposes a component-like API, and is treated like a component
// in the compiler, but internally it's a special built-in type that hooks
// directly into the renderer.
const $a34dd0657f3f171d$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, // platform-specific impl passed from renderer
    rendererInternals) {
        if (n1 == null) $a34dd0657f3f171d$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals);
        else $a34dd0657f3f171d$var$patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, slotScopeIds, optimized, rendererInternals);
    },
    hydrate: $a34dd0657f3f171d$var$hydrateSuspense,
    create: $a34dd0657f3f171d$var$createSuspenseBoundary,
    normalize: $a34dd0657f3f171d$var$normalizeSuspenseChildren
};
// Force-casted public typing for h and TSX props inference
const $a34dd0657f3f171d$export$74bf444e3cd11ea5 = $a34dd0657f3f171d$var$SuspenseImpl;
function $a34dd0657f3f171d$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $ciGHN.isFunction)(eventListener)) eventListener();
}
function $a34dd0657f3f171d$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $a34dd0657f3f171d$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, isSVG, slotScopeIds, optimized, rendererInternals);
    // start mounting the content subtree in an off-dom container
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds);
    // now check if we have encountered any async deps
    if (suspense.deps > 0) {
        // has async
        // invoke @fallback event
        $a34dd0657f3f171d$var$triggerEvent(vnode, "onPending");
        $a34dd0657f3f171d$var$triggerEvent(vnode, "onFallback");
        // mount the fallback tree
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, isSVG, slotScopeIds);
        $a34dd0657f3f171d$var$setActiveBranch(suspense, vnode.ssFallback);
    } else // Suspense has no async deps. Just resolve.
    suspense.resolve();
}
function $a34dd0657f3f171d$var$patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($a34dd0657f3f171d$var$isSameVNodeType(newBranch, pendingBranch)) {
            // same root type but content may have changed.
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                patch(activeBranch, newFallback, container, anchor, parentComponent, null, isSVG, slotScopeIds, optimized);
                $a34dd0657f3f171d$var$setActiveBranch(suspense, newFallback);
            }
        } else {
            // toggled before pending tree is resolved
            suspense.pendingId++;
            if (isHydrating) {
                // if toggled before hydration is finished, the current DOM tree is
                // no longer valid. set it as the active branch so it will be unmounted
                // when resolved
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            // increment pending ID. this is used to invalidate async callbacks
            // reset suspense state
            suspense.deps = 0;
            // discard effects from pending branch
            suspense.effects.length = 0;
            // discard previous container
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                // already in fallback state
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, isSVG, slotScopeIds, optimized);
                    $a34dd0657f3f171d$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $a34dd0657f3f171d$var$isSameVNodeType(newBranch, activeBranch)) {
                // toggled "back" to current active branch
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                // force resolve
                suspense.resolve(true);
            } else {
                // switched to a 3rd branch
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $a34dd0657f3f171d$var$isSameVNodeType(newBranch, activeBranch)) {
        // root did not change, just normal patch
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG, slotScopeIds, optimized);
        $a34dd0657f3f171d$var$setActiveBranch(suspense, newBranch);
    } else {
        // root node toggled
        // invoke @pending event
        $a34dd0657f3f171d$var$triggerEvent(n2, "onPending");
        // mount pending branch in off-dom container
        suspense.pendingBranch = newBranch;
        suspense.pendingId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
        if (suspense.deps <= 0) // incoming branch has no async deps, resolve now.
        suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $a34dd0657f3f171d$var$hasWarned = false;
function $a34dd0657f3f171d$var$createSuspenseBoundary(vnode, parent, parentComponent, container, hiddenContainer, anchor, isSVG, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    const timeout = (0, $ciGHN.toNumber)(vnode.props && vnode.props.timeout);
    const suspense = {
        vnode: vnode,
        parent: parent,
        parentComponent: parentComponent,
        isSVG: isSVG,
        container: container,
        hiddenContainer: hiddenContainer,
        anchor: anchor,
        deps: 0,
        pendingId: 0,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: true,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false) {
            const { vnode: vnode, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent, container: container } = suspense;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                const delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) move(pendingBranch, container, anchor, 0 /* ENTER */ );
                };
                // this is initial anchor on mount
                let { anchor: anchor } = suspense;
                // unmount current active tree
                if (activeBranch) {
                    // if the fallback tree was mounted, it may have been moved
                    // as part of a parent suspense. get the latest anchor for insertion
                    anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent, suspense, true);
                }
                if (!delayEnter) // move content from off-dom container to actual container
                move(pendingBranch, container, anchor, 0 /* ENTER */ );
            }
            $a34dd0657f3f171d$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            // flush buffered effects
            // check if there is a pending parent suspense
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    // found a pending parent suspense, merge buffered post jobs
                    // into that parent
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            // no pending parent suspense, flush all jobs
            if (!hasUnresolvedAncestor) $a34dd0657f3f171d$export$59536a0199721cab(effects);
            suspense.effects = [];
            // invoke @resolve event
            $a34dd0657f3f171d$var$triggerEvent(vnode, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode, activeBranch: activeBranch, parentComponent: parentComponent, container: container, isSVG: isSVG } = suspense;
            // invoke @fallback event
            $a34dd0657f3f171d$var$triggerEvent(vnode, "onFallback");
            const anchor = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                // mount the fallback tree
                patch(null, fallbackVNode, container, anchor, parentComponent, null, isSVG, slotScopeIds, optimized);
                $a34dd0657f3f171d$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            // unmount current active branch
            unmount(activeBranch, parentComponent, null, true // shouldRemove
            );
            if (!delayEnter) mountFallback();
        },
        move (container, anchor, type) {
            suspense.activeBranch && move(suspense.activeBranch, container, anchor, type);
            suspense.container = container;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $a34dd0657f3f171d$export$d3da1ecaf1206c58(err, instance, 0 /* SETUP_FUNCTION */ );
            }).then((asyncSetupResult)=>{
                // retry when the setup() promise resolves.
                // component may have been unmounted before resolve.
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                // retry from this component
                instance.asyncResolved = true;
                const { vnode: vnode } = instance;
                $a34dd0657f3f171d$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) // vnode may have been replaced if an update happened before the
                // async dep is resolved.
                vnode.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, isSVG, optimized);
                if (placeholder) remove(placeholder);
                $a34dd0657f3f171d$var$updateHOCHostEl(instance, vnode.el);
                // only decrease deps count if suspense is not already resolved
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense, doRemove);
        }
    };
    return suspense;
}
function $a34dd0657f3f171d$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    /* eslint-disable no-restricted-globals */ const suspense = vnode.suspense = $a34dd0657f3f171d$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, document.createElement("div"), null, isSVG, slotScopeIds, optimized, rendererInternals, true);
    // there are two possible scenarios for server-rendered suspense:
    // - success: ssr content should be fully resolved
    // - failure: ssr content should be the fallback branch.
    // however, on the client we don't really know if it has failed or not
    // attempt to hydrate the DOM assuming it has succeeded, but we still
    // need to construct a suspense boundary first
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve();
    return result;
/* eslint-enable no-restricted-globals */ }
function $a34dd0657f3f171d$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32 /* SLOTS_CHILDREN */ ;
    vnode.ssContent = $a34dd0657f3f171d$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $a34dd0657f3f171d$var$normalizeSuspenseSlot(children.fallback) : $a34dd0657f3f171d$export$bf5c4cf060303d58($a34dd0657f3f171d$export$4d299b491347818a);
}
function $a34dd0657f3f171d$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $ciGHN.isFunction)(s)) {
        const trackBlock = $a34dd0657f3f171d$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            // disableTracking: false
            // allow block tracking for compiled slots
            // (see ./componentRenderContext.ts)
            s._d = false;
            $a34dd0657f3f171d$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $a34dd0657f3f171d$var$currentBlock;
            $a34dd0657f3f171d$var$closeBlock();
        }
    }
    if ((0, $ciGHN.isArray)(s)) {
        const singleChild = $a34dd0657f3f171d$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $a34dd0657f3f171d$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $a34dd0657f3f171d$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $ciGHN.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $a34dd0657f3f171d$export$59536a0199721cab(fn);
}
function $a34dd0657f3f171d$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    const el = vnode.el = branch.el;
    // in case suspense is the root node of a component,
    // recursively update the HOC el
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $a34dd0657f3f171d$var$updateHOCHostEl(parentComponent, el);
    }
}
function $a34dd0657f3f171d$export$abe1e183e22e10ad(key, value) {
    if (!$a34dd0657f3f171d$var$currentInstance) ;
    else {
        let provides = $a34dd0657f3f171d$var$currentInstance.provides;
        // by default an instance inherits its parent's provides object
        // but when it needs to provide values of its own, it creates its
        // own provides object using parent provides object as prototype.
        // this way in `inject` we can simply look up injections from direct
        // parent and let the prototype chain do the work.
        const parentProvides = $a34dd0657f3f171d$var$currentInstance.parent && $a34dd0657f3f171d$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $a34dd0657f3f171d$var$currentInstance.provides = Object.create(parentProvides);
        // TS doesn't allow symbol as index type
        provides[key] = value;
    }
}
function $a34dd0657f3f171d$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    // fallback to `currentRenderingInstance` so that this can be called in
    // a functional component
    const instance = $a34dd0657f3f171d$var$currentInstance || $a34dd0657f3f171d$var$currentRenderingInstance;
    if (instance) {
        // #2400
        // to support `app.use` plugins,
        // fallback to appContext's `provides` if the instance is at root
        const provides = instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides;
        if (provides && key in provides) // TS doesn't allow symbol as index type
        return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $ciGHN.isFunction)(defaultValue) ? defaultValue.call(instance.proxy) : defaultValue;
    }
}
// Simple effect.
function $a34dd0657f3f171d$export$ede35fc0e5500309(effect, options) {
    return $a34dd0657f3f171d$var$doWatch(effect, null, options);
}
function $a34dd0657f3f171d$export$b7f27ea67102d543(effect, options) {
    return $a34dd0657f3f171d$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $a34dd0657f3f171d$export$2035654f31b0e555(effect, options) {
    return $a34dd0657f3f171d$var$doWatch(effect, null, {
        flush: "sync"
    });
}
// initial value for watchers to trigger on undefined initial values
const $a34dd0657f3f171d$var$INITIAL_WATCHER_VALUE = {};
// implementation
function $a34dd0657f3f171d$export$3db5d71bdb2d5499(source, cb, options) {
    return $a34dd0657f3f171d$var$doWatch(source, cb, options);
}
function $a34dd0657f3f171d$var$doWatch(source, cb, { immediate: immediate, deep: deep, flush: flush, onTrack: onTrack, onTrigger: onTrigger } = (0, $ciGHN.EMPTY_OBJ)) {
    const warnInvalidSource = (s)=>{
        $a34dd0657f3f171d$export$c106dd0671a0fc2d(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, ` + `a reactive object, or an array of these types.`);
    };
    const instance = $a34dd0657f3f171d$var$currentInstance;
    let getter;
    let forceTrigger = false;
    let isMultiSource = false;
    if ((0, $aTBEd.isRef)(source)) {
        getter = ()=>source.value;
        forceTrigger = (0, $aTBEd.isShallow)(source);
    } else if ((0, $aTBEd.isReactive)(source)) {
        getter = ()=>source;
        deep = true;
    } else if ((0, $ciGHN.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((0, $aTBEd.isReactive));
        getter = ()=>source.map((s)=>{
                if ((0, $aTBEd.isRef)(s)) return s.value;
                else if ((0, $aTBEd.isReactive)(s)) return $a34dd0657f3f171d$var$traverse(s);
                else if ((0, $ciGHN.isFunction)(s)) return $a34dd0657f3f171d$export$b22fcaf88446e9bf(s, instance, 2 /* WATCH_GETTER */ );
            });
    } else if ((0, $ciGHN.isFunction)(source)) {
        if (cb) // getter with cb
        getter = ()=>$a34dd0657f3f171d$export$b22fcaf88446e9bf(source, instance, 2 /* WATCH_GETTER */ );
        else // no cb -> simple effect
        getter = ()=>{
            if (instance && instance.isUnmounted) return;
            if (cleanup) cleanup();
            return $a34dd0657f3f171d$export$dae85862a8d94378(source, instance, 3 /* WATCH_CALLBACK */ , [
                onCleanup
            ]);
        };
    } else getter = (0, $ciGHN.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        getter = ()=>$a34dd0657f3f171d$var$traverse(baseGetter());
    }
    let cleanup;
    let onCleanup = (fn)=>{
        cleanup = effect.onStop = ()=>{
            $a34dd0657f3f171d$export$b22fcaf88446e9bf(fn, instance, 4 /* WATCH_CLEANUP */ );
        };
    };
    // in SSR there is no need to setup an actual effect, and it should be noop
    // unless it's eager
    if ($a34dd0657f3f171d$var$isInSSRComponentSetup) {
        // we will also not call the invalidate callback (+ runner is not set up)
        onCleanup = (0, $ciGHN.NOOP);
        if (!cb) getter();
        else if (immediate) $a34dd0657f3f171d$export$dae85862a8d94378(cb, instance, 3 /* WATCH_CALLBACK */ , [
            getter(),
            isMultiSource ? [] : undefined,
            onCleanup
        ]);
        return 0, $ciGHN.NOOP;
    }
    let oldValue = isMultiSource ? [] : $a34dd0657f3f171d$var$INITIAL_WATCHER_VALUE;
    const job = ()=>{
        if (!effect.active) return;
        if (cb) {
            // watch(source, cb)
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v1, i)=>(0, $ciGHN.hasChanged)(v1, oldValue[i])) : (0, $ciGHN.hasChanged)(newValue, oldValue)) || false) {
                // cleanup before running cb again
                if (cleanup) cleanup();
                $a34dd0657f3f171d$export$dae85862a8d94378(cb, instance, 3 /* WATCH_CALLBACK */ , [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === $a34dd0657f3f171d$var$INITIAL_WATCHER_VALUE ? undefined : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        } else // watchEffect
        effect.run();
    };
    // important: mark the job as a watcher callback so that scheduler knows
    // it is allowed to self-trigger (#1727)
    job.allowRecurse = !!cb;
    let scheduler;
    if (flush === "sync") scheduler = job; // the scheduler function gets called directly
    else if (flush === "post") scheduler = ()=>$a34dd0657f3f171d$var$queuePostRenderEffect(job, instance && instance.suspense);
    else // default: 'pre'
    scheduler = ()=>{
        if (!instance || instance.isMounted) $a34dd0657f3f171d$var$queuePreFlushCb(job);
        else // with 'pre' option, the first call must happen before
        // the component is mounted so it is called synchronously.
        job();
    };
    const effect = new (0, $aTBEd.ReactiveEffect)(getter, scheduler);
    // initial run
    if (cb) {
        if (immediate) job();
        else oldValue = effect.run();
    } else if (flush === "post") $a34dd0657f3f171d$var$queuePostRenderEffect(effect.run.bind(effect), instance && instance.suspense);
    else effect.run();
    return ()=>{
        effect.stop();
        if (instance && instance.scope) (0, $ciGHN.remove)(instance.scope.effects, effect);
    };
}
// this.$watch
function $a34dd0657f3f171d$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $ciGHN.isString)(source) ? source.includes(".") ? $a34dd0657f3f171d$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $ciGHN.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const cur = $a34dd0657f3f171d$var$currentInstance;
    $a34dd0657f3f171d$var$setCurrentInstance(this);
    const res = $a34dd0657f3f171d$var$doWatch(getter, cb.bind(publicThis), options);
    if (cur) $a34dd0657f3f171d$var$setCurrentInstance(cur);
    else $a34dd0657f3f171d$var$unsetCurrentInstance();
    return res;
}
function $a34dd0657f3f171d$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $a34dd0657f3f171d$var$traverse(value, seen) {
    if (!(0, $ciGHN.isObject)(value) || value["__v_skip" /* SKIP */ ]) return value;
    seen = seen || new Set();
    if (seen.has(value)) return value;
    seen.add(value);
    if ((0, $aTBEd.isRef)(value)) $a34dd0657f3f171d$var$traverse(value.value, seen);
    else if ((0, $ciGHN.isArray)(value)) for(let i = 0; i < value.length; i++)$a34dd0657f3f171d$var$traverse(value[i], seen);
    else if ((0, $ciGHN.isSet)(value) || (0, $ciGHN.isMap)(value)) value.forEach((v1)=>{
        $a34dd0657f3f171d$var$traverse(v1, seen);
    });
    else if ((0, $ciGHN.isPlainObject)(value)) for(const key in value)$a34dd0657f3f171d$var$traverse(value[key], seen);
    return value;
}
function $a34dd0657f3f171d$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: new Map()
    };
    $a34dd0657f3f171d$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $a34dd0657f3f171d$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $a34dd0657f3f171d$var$TransitionHookValidator = [
    Function,
    Array
];
const $a34dd0657f3f171d$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: {
        mode: String,
        appear: Boolean,
        persisted: Boolean,
        // enter
        onBeforeEnter: $a34dd0657f3f171d$var$TransitionHookValidator,
        onEnter: $a34dd0657f3f171d$var$TransitionHookValidator,
        onAfterEnter: $a34dd0657f3f171d$var$TransitionHookValidator,
        onEnterCancelled: $a34dd0657f3f171d$var$TransitionHookValidator,
        // leave
        onBeforeLeave: $a34dd0657f3f171d$var$TransitionHookValidator,
        onLeave: $a34dd0657f3f171d$var$TransitionHookValidator,
        onAfterLeave: $a34dd0657f3f171d$var$TransitionHookValidator,
        onLeaveCancelled: $a34dd0657f3f171d$var$TransitionHookValidator,
        // appear
        onBeforeAppear: $a34dd0657f3f171d$var$TransitionHookValidator,
        onAppear: $a34dd0657f3f171d$var$TransitionHookValidator,
        onAfterAppear: $a34dd0657f3f171d$var$TransitionHookValidator,
        onAppearCancelled: $a34dd0657f3f171d$var$TransitionHookValidator
    },
    setup (props, { slots: slots }) {
        const instance = $a34dd0657f3f171d$export$f13e630aa3915748();
        const state = $a34dd0657f3f171d$export$d2a0a1bc267c90f6();
        let prevTransitionKey;
        return ()=>{
            const children = slots.default && $a34dd0657f3f171d$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            // there's no need to track reactivity for these props so use the raw
            // props for a bit better perf
            const rawProps = (0, $aTBEd.toRaw)(props);
            const { mode: mode } = rawProps;
            // at this point children has a guaranteed length of 1.
            const child = children[0];
            if (state.isLeaving) return $a34dd0657f3f171d$var$emptyPlaceholder(child);
            // in the case of <transition><keep-alive/></transition>, we need to
            // compare the type of the kept-alive children.
            const innerChild = $a34dd0657f3f171d$var$getKeepAliveChild(child);
            if (!innerChild) return $a34dd0657f3f171d$var$emptyPlaceholder(child);
            const enterHooks = $a34dd0657f3f171d$export$76ac1779589cd824(innerChild, rawProps, state, instance);
            $a34dd0657f3f171d$export$7770a22486565649(innerChild, enterHooks);
            const oldChild = instance.subTree;
            const oldInnerChild = oldChild && $a34dd0657f3f171d$var$getKeepAliveChild(oldChild);
            let transitionKeyChanged = false;
            const { getTransitionKey: getTransitionKey } = innerChild.type;
            if (getTransitionKey) {
                const key = getTransitionKey();
                if (prevTransitionKey === undefined) prevTransitionKey = key;
                else if (key !== prevTransitionKey) {
                    prevTransitionKey = key;
                    transitionKeyChanged = true;
                }
            }
            // handle mode
            if (oldInnerChild && oldInnerChild.type !== $a34dd0657f3f171d$export$4d299b491347818a && (!$a34dd0657f3f171d$var$isSameVNodeType(innerChild, oldInnerChild) || transitionKeyChanged)) {
                const leavingHooks = $a34dd0657f3f171d$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                // update old tree's hooks in case of dynamic transition
                $a34dd0657f3f171d$export$7770a22486565649(oldInnerChild, leavingHooks);
                // switching between different views
                if (mode === "out-in") {
                    state.isLeaving = true;
                    // return placeholder node and queue update when leave finishes
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        instance.update();
                    };
                    return $a34dd0657f3f171d$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $a34dd0657f3f171d$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $a34dd0657f3f171d$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    // early removal callback
                    el._leaveCb = ()=>{
                        earlyRemove();
                        el._leaveCb = undefined;
                        delete enterHooks.delayedLeave;
                    };
                    enterHooks.delayedLeave = delayedLeave;
                };
            }
            return child;
        };
    }
};
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
const $a34dd0657f3f171d$export$abd95b5f5e8a8837 = $a34dd0657f3f171d$var$BaseTransitionImpl;
function $a34dd0657f3f171d$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
// The transition hooks are attached to the vnode as vnode.transition
// and will be called at appropriate timing in the renderer.
function $a34dd0657f3f171d$export$76ac1779589cd824(vnode, props, state, instance) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $a34dd0657f3f171d$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $a34dd0657f3f171d$export$dae85862a8d94378(hook, instance, 9 /* TRANSITION_HOOK */ , args);
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            // for same element (v-show)
            if (el._leaveCb) el._leaveCb(true);
            // for toggled element with same key (v-if)
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $a34dd0657f3f171d$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el._leaveCb) // force early removal (not cancelled)
            leavingVNode.el._leaveCb();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el._enterCb = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el._enterCb = undefined;
            };
            if (hook) {
                hook(el, done);
                if (hook.length <= 1) done();
            } else done();
        },
        leave (el, remove) {
            const key = String(vnode.key);
            if (el._enterCb) el._enterCb(true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el._leaveCb = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el._leaveCb = undefined;
                if (leavingVNodesCache[key] === vnode) delete leavingVNodesCache[key];
            };
            leavingVNodesCache[key] = vnode;
            if (onLeave) {
                onLeave(el, done);
                if (onLeave.length <= 1) done();
            } else done();
        },
        clone (vnode) {
            return $a34dd0657f3f171d$export$76ac1779589cd824(vnode, props, state, instance);
        }
    };
    return hooks;
}
// the placeholder really only handles one special case: KeepAlive
// in the case of a KeepAlive in a leave phase we need to return a KeepAlive
// placeholder with empty content to avoid the KeepAlive instance from being
// unmounted.
function $a34dd0657f3f171d$var$emptyPlaceholder(vnode) {
    if ($a34dd0657f3f171d$var$isKeepAlive(vnode)) {
        vnode = $a34dd0657f3f171d$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $a34dd0657f3f171d$var$getKeepAliveChild(vnode) {
    return $a34dd0657f3f171d$var$isKeepAlive(vnode) ? vnode.children ? vnode.children[0] : undefined : vnode;
}
function $a34dd0657f3f171d$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 /* COMPONENT */  && vnode.component) $a34dd0657f3f171d$export$7770a22486565649(vnode.component.subTree, hooks);
    else if (vnode.shapeFlag & 128 /* SUSPENSE */ ) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $a34dd0657f3f171d$export$a67f9b1229c7c97a(children, keepComment = false) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        // handle fragment children case, e.g. v-for
        if (child.type === $a34dd0657f3f171d$export$ffb0004e005737fa) {
            if (child.patchFlag & 128 /* KEYED_FRAGMENT */ ) keyedFragmentCount++;
            ret = ret.concat($a34dd0657f3f171d$export$a67f9b1229c7c97a(child.children, keepComment));
        } else if (keepComment || child.type !== $a34dd0657f3f171d$export$4d299b491347818a) ret.push(child);
    }
    // #1126 if a transition children list contains multiple sub fragments, these
    // fragments will be merged into a flat children array. Since each v-for
    // fragment may contain different static bindings inside, we need to de-op
    // these children to force full diffs to ensure correct behavior.
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2 /* BAIL */ ;
    return ret;
}
// implementation, close to no-op
function $a34dd0657f3f171d$export$afa64b67e5a01c3b(options) {
    return (0, $ciGHN.isFunction)(options) ? {
        setup: options,
        name: options.name
    } : options;
}
const $a34dd0657f3f171d$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
function $a34dd0657f3f171d$export$d75d499b4c16cf21(source) {
    if ((0, $ciGHN.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, timeout: timeout, suspensible: suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            // interop module default
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $a34dd0657f3f171d$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $a34dd0657f3f171d$var$currentInstance;
            // already resolved
            if (resolvedComp) return ()=>$a34dd0657f3f171d$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $a34dd0657f3f171d$export$d3da1ecaf1206c58(err, instance, 13 /* ASYNC_COMPONENT_LOADER */ , !errorComponent /* do not throw in dev if user provided error component */ );
            };
            // suspense-controlled or SSR.
            if (suspensible && instance.suspense || $a34dd0657f3f171d$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$a34dd0657f3f171d$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $a34dd0657f3f171d$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $aTBEd.ref)(false);
            const error = (0, $aTBEd.ref)();
            const delayed = (0, $aTBEd.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $a34dd0657f3f171d$var$isKeepAlive(instance.parent.vnode)) // parent is keep-alive, force update so the loaded component's
                // name is taken into account
                $a34dd0657f3f171d$var$queueJob(instance.parent.update);
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $a34dd0657f3f171d$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $a34dd0657f3f171d$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $a34dd0657f3f171d$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $a34dd0657f3f171d$var$createInnerComp(comp, { vnode: { ref: ref, props: props, children: children } }) {
    const vnode = $a34dd0657f3f171d$export$bf5c4cf060303d58(comp, props, children);
    // ensure inner component inherits the async wrapper's ref owner
    vnode.ref = ref;
    return vnode;
}
const $a34dd0657f3f171d$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $a34dd0657f3f171d$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $a34dd0657f3f171d$export$f13e630aa3915748();
        // KeepAlive communicates with the instantiated renderer via the
        // ctx where the renderer passes in its internals,
        // and the KeepAlive instance exposes activate/deactivate implementations.
        // The whole point of this is to avoid importing KeepAlive directly in the
        // renderer to facilitate tree-shaking.
        const sharedContext = instance.ctx;
        // if the internal renderer is not registered, it indicates that this is server-side rendering,
        // for KeepAlive, we just need to render its children
        if (!sharedContext.renderer) return slots.default;
        const cache = new Map();
        const keys = new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, isSVG, optimized)=>{
            const instance = vnode.component;
            move(vnode, container, anchor, 0 /* ENTER */ , parentSuspense);
            // in case props have changed
            patch(instance.vnode, vnode, container, anchor, instance, parentSuspense, isSVG, vnode.slotScopeIds, optimized);
            $a34dd0657f3f171d$var$queuePostRenderEffect(()=>{
                instance.isDeactivated = false;
                if (instance.a) (0, $ciGHN.invokeArrayFns)(instance.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $a34dd0657f3f171d$var$invokeVNodeHook(vnodeHook, instance.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) // Update components tree
            $a34dd0657f3f171d$var$devtoolsComponentAdded(instance);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance = vnode.component;
            move(vnode, storageContainer, null, 1 /* LEAVE */ , parentSuspense);
            $a34dd0657f3f171d$var$queuePostRenderEffect(()=>{
                if (instance.da) (0, $ciGHN.invokeArrayFns)(instance.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $a34dd0657f3f171d$var$invokeVNodeHook(vnodeHook, instance.parent, vnode);
                instance.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) // Update components tree
            $a34dd0657f3f171d$var$devtoolsComponentAdded(instance);
        };
        function unmount(vnode) {
            // reset the shapeFlag so it can be properly unmounted
            $a34dd0657f3f171d$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $a34dd0657f3f171d$var$getComponentName(vnode.type);
                if (name && (!filter || !filter(name))) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (!current || cached.type !== current.type) unmount(cached);
            else if (current) // current active instance should no longer be kept-alive.
            // we can't unmount it now but it might be later, so reset its flag now.
            $a34dd0657f3f171d$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        // prune cache on include/exclude prop change
        $a34dd0657f3f171d$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$a34dd0657f3f171d$var$matches(include, name));
            exclude && pruneCache((name)=>!$a34dd0657f3f171d$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        // cache sub tree after render
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            // fix #1621, the pendingCacheKey could be 0
            if (pendingCacheKey != null) cache.set(pendingCacheKey, $a34dd0657f3f171d$var$getInnerChild(instance.subTree));
        };
        $a34dd0657f3f171d$export$6d1641039221b5cb(cacheSubtree);
        $a34dd0657f3f171d$export$5876c47052fb88b1(cacheSubtree);
        $a34dd0657f3f171d$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $a34dd0657f3f171d$var$getInnerChild(subTree);
                if (cached.type === vnode.type) {
                    // current instance will be unmounted as part of keep-alive's unmount
                    $a34dd0657f3f171d$var$resetShapeFlag(vnode);
                    // but invoke its deactivated hook here
                    const da = vnode.component.da;
                    da && $a34dd0657f3f171d$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$a34dd0657f3f171d$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4 /* STATEFUL_COMPONENT */ ) && !(rawVNode.shapeFlag & 128 /* SUSPENSE */ )) {
                current = null;
                return rawVNode;
            }
            let vnode = $a34dd0657f3f171d$var$getInnerChild(rawVNode);
            const comp = vnode.type;
            // for async components, name check should be based in its loaded
            // inner component if available
            const name = $a34dd0657f3f171d$var$getComponentName($a34dd0657f3f171d$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$a34dd0657f3f171d$var$matches(include, name)) || exclude && name && $a34dd0657f3f171d$var$matches(exclude, name)) {
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            // clone vnode if it's reused because we are going to mutate it
            if (vnode.el) {
                vnode = $a34dd0657f3f171d$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128 /* SUSPENSE */ ) rawVNode.ssContent = vnode;
            }
            // #1513 it's possible for the returned vnode to be cloned due to attr
            // fallthrough or scopeId, so the vnode here may not be the final vnode
            // that is mounted. Instead of caching it directly, we store the pending
            // key and cache `instance.subTree` (the normalized vnode) in
            // beforeMount/beforeUpdate hooks.
            pendingCacheKey = key;
            if (cachedVNode) {
                // copy over mounted state
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) // recursively update transition hooks on subTree
                $a34dd0657f3f171d$export$7770a22486565649(vnode, vnode.transition);
                // avoid vnode being mounted as fresh
                vnode.shapeFlag |= 512 /* COMPONENT_KEPT_ALIVE */ ;
                // make this key the freshest
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                // prune oldest entry
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            // avoid vnode being unmounted
            vnode.shapeFlag |= 256 /* COMPONENT_SHOULD_KEEP_ALIVE */ ;
            current = vnode;
            return rawVNode;
        };
    }
};
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
const $a34dd0657f3f171d$export$70eb8a58709972df = $a34dd0657f3f171d$var$KeepAliveImpl;
function $a34dd0657f3f171d$var$matches(pattern, name) {
    if ((0, $ciGHN.isArray)(pattern)) return pattern.some((p)=>$a34dd0657f3f171d$var$matches(p, name));
    else if ((0, $ciGHN.isString)(pattern)) return pattern.split(",").includes(name);
    else if (pattern.test) return pattern.test(name);
    /* istanbul ignore next */ return false;
}
function $a34dd0657f3f171d$export$ba52d824b95a2154(hook, target) {
    $a34dd0657f3f171d$var$registerKeepAliveHook(hook, "a" /* ACTIVATED */ , target);
}
function $a34dd0657f3f171d$export$bf1440eeaf5fa709(hook, target) {
    $a34dd0657f3f171d$var$registerKeepAliveHook(hook, "da" /* DEACTIVATED */ , target);
}
function $a34dd0657f3f171d$var$registerKeepAliveHook(hook, type, target = $a34dd0657f3f171d$var$currentInstance) {
    // cache the deactivate branch check wrapper for injected hooks so the same
    // hook can be properly deduped by the scheduler. "__wdc" stands for "with
    // deactivation check".
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        // only fire the hook if the target instance is NOT in a deactivated branch.
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $a34dd0657f3f171d$var$injectHook(type, wrappedHook, target);
    // In addition to registering it on the target instance, we walk up the parent
    // chain and register it on all ancestor instances that are keep-alive roots.
    // This avoids the need to walk the entire component tree when invoking these
    // hooks, and more importantly, avoids the need to track child components in
    // arrays.
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($a34dd0657f3f171d$var$isKeepAlive(current.parent.vnode)) $a34dd0657f3f171d$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $a34dd0657f3f171d$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    // injectHook wraps the original for error handling, so make sure to remove
    // the wrapped version.
    const injected = $a34dd0657f3f171d$var$injectHook(type, hook, keepAliveRoot, true);
    $a34dd0657f3f171d$export$13348a43ccacfe58(()=>{
        (0, $ciGHN.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $a34dd0657f3f171d$var$resetShapeFlag(vnode) {
    let shapeFlag = vnode.shapeFlag;
    if (shapeFlag & 256 /* COMPONENT_SHOULD_KEEP_ALIVE */ ) shapeFlag -= 256 /* COMPONENT_SHOULD_KEEP_ALIVE */ ;
    if (shapeFlag & 512 /* COMPONENT_KEPT_ALIVE */ ) shapeFlag -= 512 /* COMPONENT_KEPT_ALIVE */ ;
    vnode.shapeFlag = shapeFlag;
}
function $a34dd0657f3f171d$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 /* SUSPENSE */  ? vnode.ssContent : vnode;
}
function $a34dd0657f3f171d$var$injectHook(type, hook, target = $a34dd0657f3f171d$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        // cache the error handling wrapper for injected hooks so the same hook
        // can be properly deduped by the scheduler. "__weh" stands for "with error
        // handling".
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            if (target.isUnmounted) return;
            // disable tracking inside all lifecycle hooks
            // since they can potentially be called inside effects.
            (0, $aTBEd.pauseTracking)();
            // Set currentInstance during hook invocation.
            // This assumes the hook does not synchronously trigger other hooks, which
            // can only be false when the user does something really funky.
            $a34dd0657f3f171d$var$setCurrentInstance(target);
            const res = $a34dd0657f3f171d$export$dae85862a8d94378(hook, target, type, args);
            $a34dd0657f3f171d$var$unsetCurrentInstance();
            (0, $aTBEd.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $a34dd0657f3f171d$var$createHook = (lifecycle)=>(hook, target = $a34dd0657f3f171d$var$currentInstance)=>// post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
        (!$a34dd0657f3f171d$var$isInSSRComponentSetup || lifecycle === "sp" /* SERVER_PREFETCH */ ) && $a34dd0657f3f171d$var$injectHook(lifecycle, hook, target);
const $a34dd0657f3f171d$export$23b7aeb0d671f804 = $a34dd0657f3f171d$var$createHook("bm" /* BEFORE_MOUNT */ );
const $a34dd0657f3f171d$export$6d1641039221b5cb = $a34dd0657f3f171d$var$createHook("m" /* MOUNTED */ );
const $a34dd0657f3f171d$export$ab91988a13872e4c = $a34dd0657f3f171d$var$createHook("bu" /* BEFORE_UPDATE */ );
const $a34dd0657f3f171d$export$5876c47052fb88b1 = $a34dd0657f3f171d$var$createHook("u" /* UPDATED */ );
const $a34dd0657f3f171d$export$40c420df62d2614 = $a34dd0657f3f171d$var$createHook("bum" /* BEFORE_UNMOUNT */ );
const $a34dd0657f3f171d$export$13348a43ccacfe58 = $a34dd0657f3f171d$var$createHook("um" /* UNMOUNTED */ );
const $a34dd0657f3f171d$export$ebf0c601f267bceb = $a34dd0657f3f171d$var$createHook("sp" /* SERVER_PREFETCH */ );
const $a34dd0657f3f171d$export$898295a813d662eb = $a34dd0657f3f171d$var$createHook("rtg" /* RENDER_TRIGGERED */ );
const $a34dd0657f3f171d$export$2b41f4235363e921 = $a34dd0657f3f171d$var$createHook("rtc" /* RENDER_TRACKED */ );
function $a34dd0657f3f171d$export$6a3a15856e50ad19(hook, target = $a34dd0657f3f171d$var$currentInstance) {
    $a34dd0657f3f171d$var$injectHook("ec" /* ERROR_CAPTURED */ , hook, target);
}
function $a34dd0657f3f171d$var$createDuplicateChecker() {
    const cache = Object.create(null);
    return (type, key)=>{
        if (cache[key]) $a34dd0657f3f171d$export$c106dd0671a0fc2d(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $a34dd0657f3f171d$var$shouldCacheAccess = true;
function $a34dd0657f3f171d$var$applyOptions(instance) {
    const options = $a34dd0657f3f171d$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    // do not cache property access on public proxy during state initialization
    $a34dd0657f3f171d$var$shouldCacheAccess = false;
    // call beforeCreate first before accessing other options since
    // the hook may mutate resolved options (#2791)
    if (options.beforeCreate) $a34dd0657f3f171d$var$callHook(options.beforeCreate, instance, "bc" /* BEFORE_CREATE */ );
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    // options initialization order (to be consistent with Vue 2):
    // - props (already done outside of this function)
    // - inject
    // - methods
    // - data (deferred since it relies on `this` access)
    // - computed
    // - watch (deferred since it relies on `this` access)
    if (injectOptions) $a34dd0657f3f171d$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties, instance.appContext.config.unwrapInjectedRef);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $ciGHN.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $ciGHN.isObject)(data)) ;
        else instance.data = (0, $aTBEd.reactive)(data);
    }
    // state initialization complete at this point - start caching access
    $a34dd0657f3f171d$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $ciGHN.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $ciGHN.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $ciGHN.NOOP);
        const set = !(0, $ciGHN.isFunction)(opt) && (0, $ciGHN.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $ciGHN.NOOP);
        const c = $a34dd0657f3f171d$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$a34dd0657f3f171d$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $ciGHN.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $a34dd0657f3f171d$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $a34dd0657f3f171d$var$callHook(created, instance, "c" /* CREATED */ );
    function registerLifecycleHook(register, hook) {
        if ((0, $ciGHN.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($a34dd0657f3f171d$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($a34dd0657f3f171d$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($a34dd0657f3f171d$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($a34dd0657f3f171d$export$5876c47052fb88b1, updated);
    registerLifecycleHook($a34dd0657f3f171d$export$ba52d824b95a2154, activated);
    registerLifecycleHook($a34dd0657f3f171d$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($a34dd0657f3f171d$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($a34dd0657f3f171d$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($a34dd0657f3f171d$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($a34dd0657f3f171d$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($a34dd0657f3f171d$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($a34dd0657f3f171d$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $ciGHN.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    // options that are handled when creating the instance but also need to be
    // applied from mixins
    if (render && instance.render === (0, $ciGHN.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    // asset options.
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
}
function $a34dd0657f3f171d$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $ciGHN.NOOP), unwrapRef = false) {
    if ((0, $ciGHN.isArray)(injectOptions)) injectOptions = $a34dd0657f3f171d$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $ciGHN.isObject)(opt)) {
            if ("default" in opt) injected = $a34dd0657f3f171d$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $a34dd0657f3f171d$export$a976684a0efeb93f(opt.from || key);
        } else injected = $a34dd0657f3f171d$export$a976684a0efeb93f(opt);
        if ((0, $aTBEd.isRef)(injected)) {
            // TODO remove the check in 3.3
            if (unwrapRef) Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>injected.value,
                set: (v1)=>injected.value = v1
            });
            else ctx[key] = injected;
        } else ctx[key] = injected;
    }
}
function $a34dd0657f3f171d$var$callHook(hook, instance, type) {
    $a34dd0657f3f171d$export$dae85862a8d94378((0, $ciGHN.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $a34dd0657f3f171d$var$createWatcher(raw, ctx, publicThis, key) {
    const getter = key.includes(".") ? $a34dd0657f3f171d$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $ciGHN.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $ciGHN.isFunction)(handler)) $a34dd0657f3f171d$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $ciGHN.isFunction)(raw)) $a34dd0657f3f171d$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $ciGHN.isObject)(raw)) {
        if ((0, $ciGHN.isArray)(raw)) raw.forEach((r)=>$a34dd0657f3f171d$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $ciGHN.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $ciGHN.isFunction)(handler)) $a34dd0657f3f171d$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
/**
 * Resolve merged options and cache it on the component.
 * This is done only once per-component since the merging does not involve
 * instances.
 */ function $a34dd0657f3f171d$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$a34dd0657f3f171d$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $a34dd0657f3f171d$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    cache.set(base, resolved);
    return resolved;
}
function $a34dd0657f3f171d$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $a34dd0657f3f171d$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$a34dd0657f3f171d$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $a34dd0657f3f171d$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $a34dd0657f3f171d$var$internalOptionMergeStrats = {
    data: $a34dd0657f3f171d$var$mergeDataFn,
    props: $a34dd0657f3f171d$var$mergeObjectOptions,
    emits: $a34dd0657f3f171d$var$mergeObjectOptions,
    // objects
    methods: $a34dd0657f3f171d$var$mergeObjectOptions,
    computed: $a34dd0657f3f171d$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $a34dd0657f3f171d$var$mergeAsArray,
    created: $a34dd0657f3f171d$var$mergeAsArray,
    beforeMount: $a34dd0657f3f171d$var$mergeAsArray,
    mounted: $a34dd0657f3f171d$var$mergeAsArray,
    beforeUpdate: $a34dd0657f3f171d$var$mergeAsArray,
    updated: $a34dd0657f3f171d$var$mergeAsArray,
    beforeDestroy: $a34dd0657f3f171d$var$mergeAsArray,
    beforeUnmount: $a34dd0657f3f171d$var$mergeAsArray,
    destroyed: $a34dd0657f3f171d$var$mergeAsArray,
    unmounted: $a34dd0657f3f171d$var$mergeAsArray,
    activated: $a34dd0657f3f171d$var$mergeAsArray,
    deactivated: $a34dd0657f3f171d$var$mergeAsArray,
    errorCaptured: $a34dd0657f3f171d$var$mergeAsArray,
    serverPrefetch: $a34dd0657f3f171d$var$mergeAsArray,
    // assets
    components: $a34dd0657f3f171d$var$mergeObjectOptions,
    directives: $a34dd0657f3f171d$var$mergeObjectOptions,
    // watch
    watch: $a34dd0657f3f171d$var$mergeWatchOptions,
    // provide / inject
    provide: $a34dd0657f3f171d$var$mergeDataFn,
    inject: $a34dd0657f3f171d$var$mergeInject
};
function $a34dd0657f3f171d$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $ciGHN.extend)((0, $ciGHN.isFunction)(to) ? to.call(this, this) : to, (0, $ciGHN.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $a34dd0657f3f171d$var$mergeInject(to, from) {
    return $a34dd0657f3f171d$var$mergeObjectOptions($a34dd0657f3f171d$var$normalizeInject(to), $a34dd0657f3f171d$var$normalizeInject(from));
}
function $a34dd0657f3f171d$var$normalizeInject(raw) {
    if ((0, $ciGHN.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $a34dd0657f3f171d$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $a34dd0657f3f171d$var$mergeObjectOptions(to, from) {
    return to ? (0, $ciGHN.extend)((0, $ciGHN.extend)(Object.create(null), to), from) : from;
}
function $a34dd0657f3f171d$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $ciGHN.extend)(Object.create(null), to);
    for(const key in from)merged[key] = $a34dd0657f3f171d$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $a34dd0657f3f171d$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = {};
    (0, $ciGHN.def)(attrs, $a34dd0657f3f171d$var$InternalObjectKey, 1);
    instance.propsDefaults = Object.create(null);
    $a34dd0657f3f171d$var$setFullProps(instance, rawProps, props, attrs);
    // ensure all declared prop keys are present
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = undefined;
    if (isStateful) // stateful
    instance.props = isSSR ? props : (0, $aTBEd.shallowReactive)(props);
    else if (!instance.type.props) // functional w/ optional props, props === attrs
    instance.props = attrs;
    else // functional w/ declared props
    instance.props = props;
    instance.attrs = attrs;
}
function $a34dd0657f3f171d$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $aTBEd.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16 /* FULL_PROPS */ )) {
        if (patchFlag & 8 /* PROPS */ ) {
            // Compiler-generated props & no keys change, just set the updated
            // the props.
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                // PROPS flag guarantees rawProps to be non-null
                const value = rawProps[key];
                if (options) {
                    // attr / props separation was done on init and will be consistent
                    // in this code path, so just check if attrs have it.
                    if ((0, $ciGHN.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $ciGHN.camelize)(key);
                        props[camelizedKey] = $a34dd0657f3f171d$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        // full props update.
        if ($a34dd0657f3f171d$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        // in case of dynamic props, check if we need to delete keys from
        // the props object
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $ciGHN.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $ciGHN.hyphenate)(key)) === key || !(0, $ciGHN.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== undefined || // for kebab-case
                rawPrevProps[kebabKey] !== undefined)) props[key] = $a34dd0657f3f171d$var$resolvePropValue(options, rawCurrentProps, key, undefined, instance, true);
            } else delete props[key];
        }
        // in the case of functional component w/o props declaration, props and
        // attrs point to the same object so it should already have been updated.
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $ciGHN.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    // trigger updates for $attrs in case it's used in component slots
    if (hasAttrsChanged) (0, $aTBEd.trigger)(instance, "set" /* SET */ , "$attrs");
}
function $a34dd0657f3f171d$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        // key, ref are reserved and never passed down
        if ((0, $ciGHN.isReservedProp)(key)) continue;
        const value = rawProps[key];
        // prop option names are camelized during normalization, so to support
        // kebab -> camel conversion here we need to camelize the key.
        let camelKey;
        if (options && (0, $ciGHN.hasOwn)(options, camelKey = (0, $ciGHN.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$a34dd0657f3f171d$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $aTBEd.toRaw)(props);
        const castValues = rawCastValues || (0, $ciGHN.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $a34dd0657f3f171d$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $ciGHN.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $a34dd0657f3f171d$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $ciGHN.hasOwn)(opt, "default");
        // default values
        if (hasDefault && value === undefined) {
            const defaultValue = opt.default;
            if (opt.type !== Function && (0, $ciGHN.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    $a34dd0657f3f171d$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    $a34dd0657f3f171d$var$unsetCurrentInstance();
                }
            } else value = defaultValue;
        }
        // boolean casting
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $ciGHN.hyphenate)(key))) value = true;
        }
    }
    return value;
}
function $a34dd0657f3f171d$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    // apply mixin/extends props
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $ciGHN.isFunction)(comp)) {
        const extendProps = (raw)=>{
            hasExtends = true;
            const [props, keys] = $a34dd0657f3f171d$var$normalizePropsOptions(raw, appContext, true);
            (0, $ciGHN.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        cache.set(comp, (0, $ciGHN.EMPTY_ARR));
        return 0, $ciGHN.EMPTY_ARR;
    }
    if ((0, $ciGHN.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $ciGHN.camelize)(raw[i]);
        if ($a34dd0657f3f171d$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $ciGHN.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $ciGHN.camelize)(key);
        if ($a34dd0657f3f171d$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $ciGHN.isArray)(opt) || (0, $ciGHN.isFunction)(opt) ? {
                type: opt
            } : opt;
            if (prop) {
                const booleanIndex = $a34dd0657f3f171d$var$getTypeIndex(Boolean, prop.type);
                const stringIndex = $a34dd0657f3f171d$var$getTypeIndex(String, prop.type);
                prop[0 /* shouldCast */ ] = booleanIndex > -1;
                prop[1 /* shouldCastTrue */ ] = stringIndex < 0 || booleanIndex < stringIndex;
                // if the prop needs boolean casting or default value
                if (booleanIndex > -1 || (0, $ciGHN.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
            }
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    cache.set(comp, res);
    return res;
}
function $a34dd0657f3f171d$var$validatePropName(key) {
    if (key[0] !== "$") return true;
    return false;
}
// use function string name to check type constructors
// so that it works across vms / iframes.
function $a34dd0657f3f171d$var$getType(ctor) {
    const match = ctor && ctor.toString().match(/^\s*function (\w+)/);
    return match ? match[1] : ctor === null ? "null" : "";
}
function $a34dd0657f3f171d$var$isSameType(a, b) {
    return $a34dd0657f3f171d$var$getType(a) === $a34dd0657f3f171d$var$getType(b);
}
function $a34dd0657f3f171d$var$getTypeIndex(type, expectedTypes) {
    if ((0, $ciGHN.isArray)(expectedTypes)) return expectedTypes.findIndex((t)=>$a34dd0657f3f171d$var$isSameType(t, type));
    else if ((0, $ciGHN.isFunction)(expectedTypes)) return $a34dd0657f3f171d$var$isSameType(expectedTypes, type) ? 0 : -1;
    return -1;
}
/**
 * dev only
 */ function $a34dd0657f3f171d$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $aTBEd.toRaw)(props);
    const options = instance.propsOptions[0];
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $a34dd0657f3f171d$var$validateProp(key, resolvedValues[key], opt, !(0, $ciGHN.hasOwn)(rawProps, key) && !(0, $ciGHN.hasOwn)(rawProps, (0, $ciGHN.hyphenate)(key)));
    }
}
/**
 * dev only
 */ function $a34dd0657f3f171d$var$validateProp(name, value, prop, isAbsent) {
    const { type: type, required: required, validator: validator } = prop;
    // required!
    if (required && isAbsent) {
        $a34dd0657f3f171d$export$c106dd0671a0fc2d('Missing required prop: "' + name + '"');
        return;
    }
    // missing but optional
    if (value == null && !prop.required) return;
    // type check
    if (type != null && type !== true) {
        let isValid = false;
        const types = (0, $ciGHN.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        // value is valid as long as one of the specified types match
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $a34dd0657f3f171d$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $a34dd0657f3f171d$export$c106dd0671a0fc2d($a34dd0657f3f171d$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    // custom validator
    if (validator && !validator(value)) $a34dd0657f3f171d$export$c106dd0671a0fc2d('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $a34dd0657f3f171d$var$isSimpleType = /*#__PURE__*/ (0, $ciGHN.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
/**
 * dev only
 */ function $a34dd0657f3f171d$var$assertType(value, type) {
    let valid;
    const expectedType = $a34dd0657f3f171d$var$getType(type);
    if ($a34dd0657f3f171d$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        // for primitive wrapper objects
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $ciGHN.isObject)(value);
    else if (expectedType === "Array") valid = (0, $ciGHN.isArray)(value);
    else if (expectedType === "null") valid = value === null;
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
/**
 * dev only
 */ function $a34dd0657f3f171d$var$getInvalidTypeMessage(name, value, expectedTypes) {
    let message = `Invalid prop: type check failed for prop "${name}".` + ` Expected ${expectedTypes.map((0, $ciGHN.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $ciGHN.toRawType)(value);
    const expectedValue = $a34dd0657f3f171d$var$styleValue(value, expectedType);
    const receivedValue = $a34dd0657f3f171d$var$styleValue(value, receivedType);
    // check if we need to specify expected value
    if (expectedTypes.length === 1 && $a34dd0657f3f171d$var$isExplicable(expectedType) && !$a34dd0657f3f171d$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    // check if we need to specify received value
    if ($a34dd0657f3f171d$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
/**
 * dev only
 */ function $a34dd0657f3f171d$var$styleValue(value, type) {
    if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
/**
 * dev only
 */ function $a34dd0657f3f171d$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
/**
 * dev only
 */ function $a34dd0657f3f171d$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $a34dd0657f3f171d$var$isInternalKey = (key)=>key[0] === "_" || key === "$stable";
const $a34dd0657f3f171d$var$normalizeSlotValue = (value)=>(0, $ciGHN.isArray)(value) ? value.map($a34dd0657f3f171d$var$normalizeVNode) : [
        $a34dd0657f3f171d$var$normalizeVNode(value)
    ];
const $a34dd0657f3f171d$var$normalizeSlot = (key, rawSlot, ctx)=>{
    const normalized = $a34dd0657f3f171d$export$694b237e827a3d23((...args)=>{
        return $a34dd0657f3f171d$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $a34dd0657f3f171d$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($a34dd0657f3f171d$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $ciGHN.isFunction)(value)) slots[key] = $a34dd0657f3f171d$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $a34dd0657f3f171d$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $a34dd0657f3f171d$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $a34dd0657f3f171d$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $a34dd0657f3f171d$var$initSlots = (instance, children)=>{
    if (instance.vnode.shapeFlag & 32 /* SLOTS_CHILDREN */ ) {
        const type = children._;
        if (type) {
            // users can get the shallow readonly version of the slots object through `this.$slots`,
            // we should avoid the proxy object polluting the slots of the internal instance
            instance.slots = (0, $aTBEd.toRaw)(children);
            // make compiler marker non-enumerable
            (0, $ciGHN.def)(children, "_", type);
        } else $a34dd0657f3f171d$var$normalizeObjectSlots(children, instance.slots = {});
    } else {
        instance.slots = {};
        if (children) $a34dd0657f3f171d$var$normalizeVNodeSlots(instance, children);
    }
    (0, $ciGHN.def)(instance.slots, $a34dd0657f3f171d$var$InternalObjectKey, 1);
};
const $a34dd0657f3f171d$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $ciGHN.EMPTY_OBJ);
    if (vnode.shapeFlag & 32 /* SLOTS_CHILDREN */ ) {
        const type = children._;
        if (type) {
            if (optimized && type === 1 /* STABLE */ ) // compiled AND stable.
            // no need to update, and skip stale slots removal.
            needDeletionCheck = false;
            else {
                // compiled but dynamic (v-if/v-for on slots) - update slots, but skip
                // normalization.
                (0, $ciGHN.extend)(slots, children);
                // #2893
                // when rendering the optimized slots by manually written render function,
                // we need to delete the `slots._` flag if necessary to make subsequent updates reliable,
                // i.e. let the `renderSlot` create the bailed Fragment
                if (!optimized && type === 1 /* STABLE */ ) delete slots._;
            }
        } else {
            needDeletionCheck = !children.$stable;
            $a34dd0657f3f171d$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        // non slot object children (direct value) passed to a component
        $a34dd0657f3f171d$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    // delete stale slots
    if (needDeletionCheck) {
        for(const key in slots)if (!$a34dd0657f3f171d$var$isInternalKey(key) && !(key in deletionComparisonTarget)) delete slots[key];
    }
};
/**
Runtime helper for applying directives to a vnode. Example usage:

const comp = resolveComponent('comp')
const foo = resolveDirective('foo')
const bar = resolveDirective('bar')

return withDirectives(h(comp), [
  [foo, this.x],
  [bar, this.y]
])
*/ const $a34dd0657f3f171d$var$isBuiltInDirective = /*#__PURE__*/ (0, $ciGHN.makeMap)("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
function $a34dd0657f3f171d$var$validateDirectiveName(name) {
    if ($a34dd0657f3f171d$var$isBuiltInDirective(name)) $a34dd0657f3f171d$export$c106dd0671a0fc2d("Do not use built-in directive ids as custom directive id: " + name);
}
/**
 * Adds directives to a VNode.
 */ function $a34dd0657f3f171d$export$49729353e7c1e6c5(vnode, directives) {
    const internalInstance = $a34dd0657f3f171d$var$currentRenderingInstance;
    if (internalInstance === null) return vnode;
    const instance = internalInstance.proxy;
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $ciGHN.EMPTY_OBJ)] = directives[i];
        if ((0, $ciGHN.isFunction)(dir)) dir = {
            mounted: dir,
            updated: dir
        };
        if (dir.deep) $a34dd0657f3f171d$var$traverse(value);
        bindings.push({
            dir: dir,
            instance: instance,
            value: value,
            oldValue: void 0,
            arg: arg,
            modifiers: modifiers
        });
    }
    return vnode;
}
function $a34dd0657f3f171d$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            // disable tracking inside all lifecycle hooks
            // since they can potentially be called inside effects.
            (0, $aTBEd.pauseTracking)();
            $a34dd0657f3f171d$export$dae85862a8d94378(hook, instance, 8 /* DIRECTIVE_HOOK */ , [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $aTBEd.resetTracking)();
        }
    }
}
function $a34dd0657f3f171d$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $ciGHN.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: undefined,
            warnHandler: undefined,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: Object.create(null),
        optionsCache: new WeakMap(),
        propsCache: new WeakMap(),
        emitsCache: new WeakMap()
    };
}
let $a34dd0657f3f171d$var$uid = 0;
function $a34dd0657f3f171d$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (rootProps != null && !(0, $ciGHN.isObject)(rootProps)) rootProps = null;
        const context = $a34dd0657f3f171d$var$createAppContext();
        const installedPlugins = new Set();
        let isMounted = false;
        const app = context.app = {
            _uid: $a34dd0657f3f171d$var$uid++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $a34dd0657f3f171d$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $ciGHN.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $ciGHN.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, isSVG) {
                if (!isMounted) {
                    const vnode = $a34dd0657f3f171d$export$bf5c4cf060303d58(rootComponent, rootProps);
                    // store app context on the root VNode.
                    // this will be set on the root instance on initial mount.
                    vnode.appContext = context;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, isSVG);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $a34dd0657f3f171d$var$devtoolsInitApp(app, $a34dd0657f3f171d$export$83d89fbfd8236492);
                    }
                    return $a34dd0657f3f171d$var$getExposeProxy(vnode.component) || vnode.component.proxy;
                }
            },
            unmount () {
                if (isMounted) {
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $a34dd0657f3f171d$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                // TypeScript doesn't allow symbols as index type
                // https://github.com/Microsoft/TypeScript/issues/24587
                context.provides[key] = value;
                return app;
            }
        };
        return app;
    };
}
/**
 * Function for handling a template ref
 */ function $a34dd0657f3f171d$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $ciGHN.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$a34dd0657f3f171d$var$setRef(r, oldRawRef && ((0, $ciGHN.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($a34dd0657f3f171d$var$isAsyncWrapper(vnode) && !isUnmount) // when mounting async components, nothing needs to be done,
    // because the template ref is forwarded to inner component
    return;
    const refValue = vnode.shapeFlag & 4 /* STATEFUL_COMPONENT */  ? $a34dd0657f3f171d$var$getExposeProxy(vnode.component) || vnode.component.proxy : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $ciGHN.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    // dynamic ref changed. unset old ref
    if (oldRef != null && oldRef !== ref) {
        if ((0, $ciGHN.isString)(oldRef)) {
            refs[oldRef] = null;
            if ((0, $ciGHN.hasOwn)(setupState, oldRef)) setupState[oldRef] = null;
        } else if ((0, $aTBEd.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $ciGHN.isFunction)(ref)) $a34dd0657f3f171d$export$b22fcaf88446e9bf(ref, owner, 12 /* FUNCTION_REF */ , [
        value,
        refs
    ]);
    else {
        const _isString = (0, $ciGHN.isString)(ref);
        const _isRef = (0, $aTBEd.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? refs[ref] : ref.value;
                    if (isUnmount) (0, $ciGHN.isArray)(existing) && (0, $ciGHN.remove)(existing, refValue);
                    else {
                        if (!(0, $ciGHN.isArray)(existing)) {
                            if (_isString) refs[ref] = [
                                refValue
                            ];
                            else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if ((0, $ciGHN.hasOwn)(setupState, ref)) setupState[ref] = value;
                } else if ((0, $aTBEd.isRef)(ref)) {
                    ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                doSet.id = -1;
                $a34dd0657f3f171d$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let $a34dd0657f3f171d$var$hasMismatch = false;
const $a34dd0657f3f171d$var$isSVGContainer = (container)=>/svg/.test(container.namespaceURI) && container.tagName !== "foreignObject";
const $a34dd0657f3f171d$var$isComment = (node)=>node.nodeType === 8 /* COMMENT */ ;
// Note: hydration is DOM-specific
// But we have to place it in core due to tight coupling with core - splitting
// it out creates a ton of unnecessary complexity.
// Hydration also depends on some renderer internal logic which needs to be
// passed in via arguments.
function $a34dd0657f3f171d$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            patch(null, vnode, container);
            $a34dd0657f3f171d$var$flushPostFlushCbs();
            return;
        }
        $a34dd0657f3f171d$var$hasMismatch = false;
        hydrateNode(container.firstChild, vnode, null, null, null);
        $a34dd0657f3f171d$var$flushPostFlushCbs();
        if ($a34dd0657f3f171d$var$hasMismatch && true) // this error should show up in production
        console.error(`Hydration completed but contains mismatches.`);
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        const isFragmentStart = $a34dd0657f3f171d$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag } = vnode;
        const domType = node.nodeType;
        vnode.el = node;
        let nextNode = null;
        switch(type){
            case $a34dd0657f3f171d$export$5f1af8db9871e1d6:
                if (domType !== 3 /* TEXT */ ) nextNode = onMismatch();
                else {
                    if (node.data !== vnode.children) {
                        $a34dd0657f3f171d$var$hasMismatch = true;
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $a34dd0657f3f171d$export$4d299b491347818a:
                if (domType !== 8 /* COMMENT */  || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $a34dd0657f3f171d$export$c1b9a1d3af45b7b6:
                if (domType !== 1 /* ELEMENT */ ) nextNode = onMismatch();
                else {
                    // determine anchor, adopt content
                    nextNode = node;
                    // if the static vnode has its content stripped during build,
                    // adopt it from the server-rendered HTML.
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.outerHTML;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return nextNode;
                }
                break;
            case $a34dd0657f3f171d$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1 /* ELEMENT */ ) {
                    if (domType !== 1 /* ELEMENT */  || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6 /* COMPONENT */ ) {
                    // when setting up the render effect, if the initial vnode already
                    // has .el set, the component will perform hydration instead of mount
                    // on its sub-tree.
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $a34dd0657f3f171d$var$isSVGContainer(container), optimized);
                    // component may be async, so in the case of fragments we cannot rely
                    // on component's rendered output to determine the end of the fragment
                    // instead, we do a lookahead to find the end anchor node.
                    nextNode = isFragmentStart ? locateClosingAsyncAnchor(node) : nextSibling(node);
                    // #3787
                    // if component is async, it may get moved / unmounted before its
                    // inner component is loaded, so we need to give it a placeholder
                    // vnode that matches its adopted DOM.
                    if ($a34dd0657f3f171d$var$isAsyncWrapper(vnode)) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $a34dd0657f3f171d$export$bf5c4cf060303d58($a34dd0657f3f171d$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $a34dd0657f3f171d$export$22f9b5ffd89dac9("") : $a34dd0657f3f171d$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64 /* TELEPORT */ ) {
                    if (domType !== 8 /* COMMENT */ ) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128 /* SUSPENSE */ ) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $a34dd0657f3f171d$var$isSVGContainer(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
        }
        if (ref != null) $a34dd0657f3f171d$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs } = vnode;
        // #4006 for form elements with non-string v-model value bindings
        // e.g. <option :value="obj">, <input type="checkbox" :true-value="1">
        const forcePatchValue = type === "input" && dirs || type === "option";
        // skip props & children if this is hoisted static nodes
        if (forcePatchValue || patchFlag !== -1 /* HOISTED */ ) {
            if (dirs) $a34dd0657f3f171d$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            // props
            if (props) {
                if (forcePatchValue || !optimized || patchFlag & 48 /* HYDRATE_EVENTS */ ) {
                    for(const key in props)if (forcePatchValue && key.endsWith("value") || (0, $ciGHN.isOn)(key) && !(0, $ciGHN.isReservedProp)(key)) patchProp(el, key, null, props[key], false, undefined, parentComponent);
                } else if (props.onClick) // Fast path for click listeners (which is most often) to avoid
                // iterating through props.
                patchProp(el, "onClick", null, props.onClick, false, undefined, parentComponent);
            }
            // vnode / directive hooks
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $a34dd0657f3f171d$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $a34dd0657f3f171d$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs) $a34dd0657f3f171d$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $a34dd0657f3f171d$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                dirs && $a34dd0657f3f171d$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
            // children
            if (shapeFlag & 16 /* ARRAY_CHILDREN */  && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    $a34dd0657f3f171d$var$hasMismatch = true;
                    // The SSRed DOM contains more nodes than it should. Remove them.
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8 /* TEXT_CHILDREN */ ) {
                if (el.textContent !== vnode.children) {
                    $a34dd0657f3f171d$var$hasMismatch = true;
                    el.textContent = vnode.children;
                }
            }
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $a34dd0657f3f171d$var$normalizeVNode(children[i]);
            if (node) node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            else if (vnode.type === $a34dd0657f3f171d$export$5f1af8db9871e1d6 && !vnode.children) continue;
            else {
                $a34dd0657f3f171d$var$hasMismatch = true;
                // the SSRed DOM didn't contain enough nodes. Mount the missing ones.
                patch(null, vnode, container, null, parentComponent, parentSuspense, $a34dd0657f3f171d$var$isSVGContainer(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $a34dd0657f3f171d$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            // fragment didn't hydrate successfully, since we didn't get a end anchor
            // back. This should have led to node/children mismatch warnings.
            $a34dd0657f3f171d$var$hasMismatch = true;
            // since the anchor is missing, we need to create one and insert it
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        $a34dd0657f3f171d$var$hasMismatch = true;
        vnode.el = null;
        if (isFragment) {
            // remove excessive fragment nodes
            const end = locateClosingAsyncAnchor(node);
            while(true){
                const next = nextSibling(node);
                if (next && next !== end) remove(next);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $a34dd0657f3f171d$var$isSVGContainer(container), slotScopeIds);
        return next;
    };
    const locateClosingAsyncAnchor = (node)=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $a34dd0657f3f171d$var$isComment(node)) {
                if (node.data === "[") match++;
                if (node.data === "]") {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    return [
        hydrate,
        hydrateNode
    ];
}
/* eslint-disable no-restricted-globals */ let $a34dd0657f3f171d$var$supported;
let $a34dd0657f3f171d$var$perf;
function $a34dd0657f3f171d$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $a34dd0657f3f171d$var$isSupported()) $a34dd0657f3f171d$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $a34dd0657f3f171d$var$devtoolsPerfStart(instance, type, $a34dd0657f3f171d$var$supported ? $a34dd0657f3f171d$var$perf.now() : Date.now());
}
function $a34dd0657f3f171d$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $a34dd0657f3f171d$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        $a34dd0657f3f171d$var$perf.mark(endTag);
        $a34dd0657f3f171d$var$perf.measure(`<${$a34dd0657f3f171d$var$formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        $a34dd0657f3f171d$var$perf.clearMarks(startTag);
        $a34dd0657f3f171d$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $a34dd0657f3f171d$var$devtoolsPerfEnd(instance, type, $a34dd0657f3f171d$var$supported ? $a34dd0657f3f171d$var$perf.now() : Date.now());
}
function $a34dd0657f3f171d$var$isSupported() {
    if ($a34dd0657f3f171d$var$supported !== undefined) return $a34dd0657f3f171d$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $a34dd0657f3f171d$var$supported = true;
        $a34dd0657f3f171d$var$perf = window.performance;
    } else $a34dd0657f3f171d$var$supported = false;
    return $a34dd0657f3f171d$var$supported;
}
/**
 * This is only called in esm-bundler builds.
 * It is called when a renderer is created, in `baseCreateRenderer` so that
 * importing runtime-core is side-effects free.
 *
 * istanbul-ignore-next
 */ function $a34dd0657f3f171d$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $ciGHN.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $ciGHN.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
}
const $a34dd0657f3f171d$var$queuePostRenderEffect = $a34dd0657f3f171d$var$queueEffectWithSuspense;
/**
 * The createRenderer function accepts two generic arguments:
 * HostNode and HostElement, corresponding to Node and Element types in the
 * host environment. For example, for runtime-dom, HostNode would be the DOM
 * `Node` interface and HostElement would be the DOM `Element` interface.
 *
 * Custom renderers can pass in the platform specific types like this:
 *
 * ``` js
 * const { render, createApp } = createRenderer<Node, Element>({
 *   patchProp,
 *   ...nodeOps
 * })
 * ```
 */ function $a34dd0657f3f171d$export$53ae2f996c64e9a(options) {
    return $a34dd0657f3f171d$var$baseCreateRenderer(options);
}
// Separate API for creating hydration-enabled renderer.
// Hydration logic is only used when calling this function, making it
// tree-shakable.
function $a34dd0657f3f171d$export$200524cf0d997ff0(options) {
    return $a34dd0657f3f171d$var$baseCreateRenderer(options, $a34dd0657f3f171d$var$createHydrationFunctions);
}
// implementation
function $a34dd0657f3f171d$var$baseCreateRenderer(options, createHydrationFns) {
    $a34dd0657f3f171d$var$initFeatureFlags();
    const target = (0, $ciGHN.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $a34dd0657f3f171d$export$b0c258b32c26c785(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $ciGHN.NOOP), cloneNode: hostCloneNode, insertStaticContent: hostInsertStaticContent } = options;
    // Note: functions inside this closure should use `const xxx = () => {}`
    // style in order to prevent being inlined by minifiers.
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, isSVG = false, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        // patching & not same type, unmount old tree
        if (n1 && !$a34dd0657f3f171d$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2 /* BAIL */ ) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $a34dd0657f3f171d$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $a34dd0657f3f171d$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $a34dd0657f3f171d$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, isSVG);
                break;
            case $a34dd0657f3f171d$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1 /* ELEMENT */ ) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (shapeFlag & 6 /* COMPONENT */ ) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (shapeFlag & 64 /* TELEPORT */ ) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128 /* SUSPENSE */ ) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
        }
        // set ref
        if (ref != null && parentComponent) $a34dd0657f3f171d$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else // there's no support for dynamic comments
        n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, isSVG)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG, n2.el, n2.anchor);
    };
    /**
     * Dev / HMR only
     */ const patchStaticNode = (n1, n2, container, isSVG)=>{
        // static nodes are only patched during dev for HMR
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            // remove existing
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        isSVG = isSVG || n2.type === "svg";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { type: type, props: props, shapeFlag: shapeFlag, transition: transition, patchFlag: patchFlag, dirs: dirs } = vnode;
        if ((0, vnode.el) && hostCloneNode !== undefined && patchFlag === -1 /* HOISTED */ ) // If a vnode has non-null el, it means it's being reused.
        // Only static vnodes can be reused, so its mounted DOM nodes should be
        // exactly the same, and we can simply do a clone here.
        // only do this in production since cloned trees cannot be HMR updated.
        el = vnode.el = hostCloneNode(vnode.el);
        else {
            el = vnode.el = hostCreateElement(vnode.type, isSVG, props && props.is, props);
            // mount children first, since some props may rely on child content
            // being already rendered, e.g. `<select value>`
            if (shapeFlag & 8 /* TEXT_CHILDREN */ ) hostSetElementText(el, vnode.children);
            else if (shapeFlag & 16 /* ARRAY_CHILDREN */ ) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, isSVG && type !== "foreignObject", slotScopeIds, optimized);
            if (dirs) $a34dd0657f3f171d$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            // props
            if (props) {
                for(const key in props)if (key !== "value" && !(0, $ciGHN.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
                /**
                 * Special case for setting value on DOM elements:
                 * - it can be order-sensitive (e.g. should be set *after* min/max, #2325, #4024)
                 * - it needs to be forced (#1471)
                 * #2353 proposes adding another renderer option to configure this, but
                 * the properties affects are so finite it is worth special casing it
                 * here to reduce the complexity. (Special casing it also should not
                 * affect non-DOM renderers)
                 */ if ("value" in props) hostPatchProp(el, "value", null, props.value);
                if (vnodeHook = props.onVnodeBeforeMount) $a34dd0657f3f171d$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            }
            // scopeId
            setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            Object.defineProperty(el, "__vnode", {
                value: vnode,
                enumerable: false
            });
            Object.defineProperty(el, "__vueParentComponent", {
                value: parentComponent,
                enumerable: false
            });
        }
        if (dirs) $a34dd0657f3f171d$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        // #1583 For inside suspense + suspense not resolved case, enter hook should call when suspense resolved
        // #1689 For inside suspense + suspense resolved case, just call it
        const needCallTransitionHooks = (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $a34dd0657f3f171d$var$queuePostRenderEffect(()=>{
            vnodeHook && $a34dd0657f3f171d$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $a34dd0657f3f171d$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $a34dd0657f3f171d$var$cloneIfMounted(children[i]) : $a34dd0657f3f171d$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        // #1426 take the old vnode's patch flag into account since user may clone a
        // compiler-generated vnode, which de-opts to FULL_PROPS
        patchFlag |= n1.patchFlag & 16 /* FULL_PROPS */ ;
        const oldProps = n1.props || (0, $ciGHN.EMPTY_OBJ);
        const newProps = n2.props || (0, $ciGHN.EMPTY_OBJ);
        let vnodeHook;
        // disable recurse in beforeUpdate hooks
        parentComponent && $a34dd0657f3f171d$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $a34dd0657f3f171d$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $a34dd0657f3f171d$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $a34dd0657f3f171d$var$toggleRecurse(parentComponent, true);
        const areChildrenSVG = isSVG && n2.type !== "foreignObject";
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds);
        else if (!optimized) // full diff
        patchChildren(n1, n2, el, null, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds, false);
        if (patchFlag > 0) {
            // the presence of a patchFlag means this element's render code was
            // generated by the compiler and can take the fast path.
            // in this path old node and new node are guaranteed to have the same shape
            // (i.e. at the exact same position in the source template)
            if (patchFlag & 16 /* FULL_PROPS */ ) // element props contain dynamic keys, full diff needed
            patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
            else {
                // class
                // this flag is matched when the element has dynamic class bindings.
                if (patchFlag & 2 /* CLASS */ ) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, isSVG);
                }
                // style
                // this flag is matched when the element has dynamic style bindings
                if (patchFlag & 4 /* STYLE */ ) hostPatchProp(el, "style", oldProps.style, newProps.style, isSVG);
                // props
                // This flag is matched when the element has dynamic prop/attr bindings
                // other than class and style. The keys of dynamic prop/attrs are saved for
                // faster iteration.
                // Note dynamic keys like :[foo]="bar" will cause this optimization to
                // bail out and go through a full diff because we need to unset the old key
                if (patchFlag & 8 /* PROPS */ ) {
                    // if the flag is present then dynamicProps must be non-null
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        // #1471 force patch value
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, isSVG, n1.children, parentComponent, parentSuspense, unmountChildren);
                    }
                }
            }
            // text
            // This flag is matched when the element has only dynamic text children.
            if (patchFlag & 1 /* TEXT */ ) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) // unoptimized, full diff
        patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $a34dd0657f3f171d$var$queuePostRenderEffect(()=>{
            vnodeHook && $a34dd0657f3f171d$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $a34dd0657f3f171d$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    // The fast path for blocks.
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, isSVG, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            // Determine the container (parent element) for the patch.
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $a34dd0657f3f171d$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$a34dd0657f3f171d$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70 /* TELEPORT */ ) ? hostParentNode(oldVNode.el) : // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, true);
        }
    };
    const patchProps = (el, vnode, oldProps, newProps, parentComponent, parentSuspense, isSVG)=>{
        if (oldProps !== newProps) {
            for(const key in newProps){
                // empty string is not valid prop
                if ((0, $ciGHN.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                // defer patching value
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            if (oldProps !== (0, $ciGHN.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $ciGHN.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        // check if this is a slot fragment with :slotted scope ids
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            // a fragment can only have array children
            // since they are either generated by the compiler, or implicitly created
            // from arrays.
            mountChildren(n2.children, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 /* STABLE_FRAGMENT */  && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            // a stable fragment (template root or <template v-for>) doesn't need to
            // patch children order, but it may contain dynamicChildren.
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, isSVG, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $a34dd0657f3f171d$var$traverseStaticChildren(n1, n2, true);
        } else // keyed / unkeyed, or manual fragments.
        // for keyed & unkeyed, since they are compiler generated from v-for,
        // each child is guaranteed to be a block so the fragment will never
        // have dynamicChildren.
        patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512 /* COMPONENT_KEPT_ALIVE */ ) parentComponent.ctx.activate(n2, container, anchor, isSVG, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, isSVG, optimized)=>{
        const instance = initialVNode.component = $a34dd0657f3f171d$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        // inject renderer internals for keepAlive
        if ($a34dd0657f3f171d$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $a34dd0657f3f171d$var$setupComponent(instance);
        // setup() is async. This component relies on async logic to be resolved
        // before proceeding
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect);
            // Give it a placeholder if this is not hydration
            // TODO handle self-defined fallback
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $a34dd0657f3f171d$export$bf5c4cf060303d58($a34dd0657f3f171d$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
            }
            return;
        }
        setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($a34dd0657f3f171d$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                // normal update
                instance.next = n2;
                // in case the child component is also queued, remove it to avoid
                // double updating the same child component in the same flush.
                $a34dd0657f3f171d$var$invalidateJob(instance.update);
                // instance.update is the reactive effect.
                instance.update();
            }
        } else {
            // no update needed. just copy over properties
            n2.component = n1.component;
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent } = instance;
                const isAsyncWrapperVNode = $a34dd0657f3f171d$var$isAsyncWrapper(initialVNode);
                $a34dd0657f3f171d$var$toggleRecurse(instance, false);
                // beforeMount hook
                if (bm) (0, $ciGHN.invokeArrayFns)(bm);
                // onVnodeBeforeMount
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $a34dd0657f3f171d$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $a34dd0657f3f171d$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    // vnode has adopted host node - perform hydration instead of mount.
                    const hydrateSubTree = ()=>{
                        instance.subTree = $a34dd0657f3f171d$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode) initialVNode.type.__asyncLoader().then(// note: we are moving the render call into an async callback,
                    // which means it won't track dependencies - but it's ok because
                    // a server-rendered async wrapper is already in resolved state
                    // and it will never need to change.
                    ()=>!instance.isUnmounted && hydrateSubTree());
                    else hydrateSubTree();
                } else {
                    const subTree = instance.subTree = $a34dd0657f3f171d$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, isSVG);
                    initialVNode.el = subTree.el;
                }
                // mounted hook
                if (m) $a34dd0657f3f171d$var$queuePostRenderEffect(m, parentSuspense);
                // onVnodeMounted
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $a34dd0657f3f171d$var$queuePostRenderEffect(()=>$a34dd0657f3f171d$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                // activated hook for keep-alive roots.
                // #1742 activated hook must be accessed after first render
                // since the hook may be injected by a child keep-alive
                if (initialVNode.shapeFlag & 256 /* COMPONENT_SHOULD_KEEP_ALIVE */ ) instance.a && $a34dd0657f3f171d$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $a34dd0657f3f171d$var$devtoolsComponentAdded(instance);
                // #2458: deference mount-only object parameters to prevent memleaks
                initialVNode = container = anchor = null;
            } else {
                // updateComponent
                // This is triggered by mutation of component's own state (next: null)
                // OR parent calling processComponent (next: VNode)
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                let originNext = next;
                let vnodeHook;
                // Disallow component effect recursion during pre-lifecycle hooks.
                $a34dd0657f3f171d$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                // beforeUpdate hook
                if (bu) (0, $ciGHN.invokeArrayFns)(bu);
                // onVnodeBeforeUpdate
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $a34dd0657f3f171d$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $a34dd0657f3f171d$var$toggleRecurse(instance, true);
                const nextTree = $a34dd0657f3f171d$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, isSVG);
                next.el = nextTree.el;
                if (originNext === null) // self-triggered update. In case of HOC, update parent component
                // vnode el. HOC is indicated by parent instance's subTree pointing
                // to child component's vnode
                $a34dd0657f3f171d$var$updateHOCHostEl(instance, nextTree.el);
                // updated hook
                if (u) $a34dd0657f3f171d$var$queuePostRenderEffect(u, parentSuspense);
                // onVnodeUpdated
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $a34dd0657f3f171d$var$queuePostRenderEffect(()=>$a34dd0657f3f171d$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $a34dd0657f3f171d$var$devtoolsComponentUpdated(instance);
            }
        };
        // create reactive effect for rendering
        const effect = instance.effect = new (0, $aTBEd.ReactiveEffect)(componentUpdateFn, ()=>$a34dd0657f3f171d$var$queueJob(instance.update), instance.scope // track it in component's effect scope
        );
        const update = instance.update = effect.run.bind(effect);
        update.id = instance.uid;
        // allowRecurse
        // #1801, #2043 component render effects should allow recursive updates
        $a34dd0657f3f171d$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $a34dd0657f3f171d$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $a34dd0657f3f171d$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $aTBEd.pauseTracking)();
        // props update may have triggered pre-flush watchers.
        // flush them before the render update.
        $a34dd0657f3f171d$var$flushPreFlushCbs(undefined, instance.update);
        (0, $aTBEd.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        // fast path
        if (patchFlag > 0) {
            if (patchFlag & 128 /* KEYED_FRAGMENT */ ) {
                // this could be either fully-keyed or mixed (some keyed some not)
                // presence of patchFlag means children are guaranteed to be arrays
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256 /* UNKEYED_FRAGMENT */ ) {
                // unkeyed
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                return;
            }
        }
        // children has 3 possibilities: text, array or no children.
        if (shapeFlag & 8 /* TEXT_CHILDREN */ ) {
            // text children fast path
            if (prevShapeFlag & 16 /* ARRAY_CHILDREN */ ) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16 /* ARRAY_CHILDREN */ ) {
            // prev children was array
            if (shapeFlag & 16 /* ARRAY_CHILDREN */ ) // two arrays, cannot assume anything, do full diff
            patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else // no new children, just unmount old
            unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            // prev children was text OR null
            // new children is array OR null
            if (prevShapeFlag & 8 /* TEXT_CHILDREN */ ) hostSetElementText(container, "");
            // mount new if array
            if (shapeFlag & 16 /* ARRAY_CHILDREN */ ) mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $ciGHN.EMPTY_ARR);
        c2 = c2 || (0, $ciGHN.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $a34dd0657f3f171d$var$cloneIfMounted(c2[i]) : $a34dd0657f3f171d$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
        if (oldLength > newLength) // remove old
        unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else // mount new
        mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, commonLength);
    };
    // can be all-keyed or mixed
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1; // prev ending index
        let e2 = l2 - 1; // next ending index
        // 1. sync from start
        // (a b) c
        // (a b) d e
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $a34dd0657f3f171d$var$cloneIfMounted(c2[i]) : $a34dd0657f3f171d$var$normalizeVNode(c2[i]);
            if ($a34dd0657f3f171d$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else break;
            i++;
        }
        // 2. sync from end
        // a (b c)
        // d e (b c)
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $a34dd0657f3f171d$var$cloneIfMounted(c2[e2]) : $a34dd0657f3f171d$var$normalizeVNode(c2[e2]);
            if ($a34dd0657f3f171d$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        // 3. common sequence + mount
        // (a b)
        // (a b) c
        // i = 2, e1 = 1, e2 = 2
        // (a b)
        // c (a b)
        // i = 0, e1 = -1, e2 = 0
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $a34dd0657f3f171d$var$cloneIfMounted(c2[i]) : $a34dd0657f3f171d$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i; // prev starting index
            const s2 = i; // next starting index
            // 5.1 build key:index map for newChildren
            const keyToNewIndexMap = new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $a34dd0657f3f171d$var$cloneIfMounted(c2[i]) : $a34dd0657f3f171d$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            // 5.2 loop through old children left to be patched and try to patch
            // matching nodes & remove nodes that are no longer present
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            // used to track whether any node has moved
            let maxNewIndexSoFar = 0;
            // works as Map<newIndex, oldIndex>
            // Note that oldIndex is offset by +1
            // and oldIndex = 0 is a special value indicating the new node has
            // no corresponding old node.
            // used for determining longest stable subsequence
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    // all new children have been patched so this can only be a removal
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    // key-less node, try to locate a key-less node of the same type
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $a34dd0657f3f171d$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === undefined) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                    patched++;
                }
            }
            // 5.3 move and mount
            // generate longest stable subsequence only when nodes have moved
            const increasingNewIndexSequence = moved ? $a34dd0657f3f171d$var$getSequence(newIndexToOldIndexMap) : (0, $ciGHN.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            // looping backwards so that we can use last patched node as anchor
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) // mount new
                patch(null, nextChild, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (moved) {
                    // move if:
                    // There is no stable subsequence (e.g. a reverse)
                    // OR current node is not among the stable sequence
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2 /* REORDER */ );
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6 /* COMPONENT */ ) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128 /* SUSPENSE */ ) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64 /* TELEPORT */ ) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $a34dd0657f3f171d$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $a34dd0657f3f171d$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        // single nodes
        const needTransition = moveType !== 2 /* REORDER */  && shapeFlag & 1 /* ELEMENT */  && transition;
        if (needTransition) {
            if (moveType === 0 /* ENTER */ ) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $a34dd0657f3f171d$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove = ()=>hostInsert(el, container, anchor);
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs } = vnode;
        // unset ref
        if (ref != null) $a34dd0657f3f171d$var$setRef(ref, null, parentSuspense, vnode, true);
        if (shapeFlag & 256 /* COMPONENT_SHOULD_KEEP_ALIVE */ ) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 /* ELEMENT */  && dirs;
        const shouldInvokeVnodeHook = !$a34dd0657f3f171d$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $a34dd0657f3f171d$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6 /* COMPONENT */ ) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128 /* SUSPENSE */ ) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $a34dd0657f3f171d$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64 /* TELEPORT */ ) vnode.type.remove(vnode, parentComponent, parentSuspense, optimized, internals, doRemove);
            else if (dynamicChildren && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $a34dd0657f3f171d$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64 /* STABLE_FRAGMENT */ )) // fast path for block nodes: only need to unmount dynamic children.
            unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $a34dd0657f3f171d$export$ffb0004e005737fa && patchFlag & 384 /* UNKEYED_FRAGMENT */  || !optimized && shapeFlag & 16 /* ARRAY_CHILDREN */ ) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $a34dd0657f3f171d$var$queuePostRenderEffect(()=>{
            vnodeHook && $a34dd0657f3f171d$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $a34dd0657f3f171d$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $a34dd0657f3f171d$export$ffb0004e005737fa) {
            removeFragment(el, anchor);
            return;
        }
        if (type === $a34dd0657f3f171d$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 /* ELEMENT */  && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        // For fragments, directly remove all contained DOM nodes.
        // (fragment child nodes cannot have transition)
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, update: update, subTree: subTree, um: um } = instance;
        // beforeUnmount hook
        if (bum) (0, $ciGHN.invokeArrayFns)(bum);
        // stop effects in component scope
        scope.stop();
        // update may be null if a component is unmounted before its async
        // setup has resolved.
        if (update) {
            // so that scheduler will no longer invoke it
            update.active = false;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        // unmounted hook
        if (um) $a34dd0657f3f171d$var$queuePostRenderEffect(um, parentSuspense);
        $a34dd0657f3f171d$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        // A component with async dep inside a pending suspense is unmounted before
        // its async dep resolves. This should remove the dep from the suspense, and
        // cause the suspense to resolve immediately if that was the last dep.
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $a34dd0657f3f171d$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6 /* COMPONENT */ ) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128 /* SUSPENSE */ ) return vnode.suspense.next();
        return hostNextSibling(vnode.anchor || vnode.el);
    };
    const render = (vnode, container, isSVG)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, isSVG);
        $a34dd0657f3f171d$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $a34dd0657f3f171d$var$createAppAPI(render, hydrate)
    };
}
function $a34dd0657f3f171d$var$toggleRecurse({ effect: effect, update: update }, allowed) {
    effect.allowRecurse = update.allowRecurse = allowed;
}
/**
 * #1156
 * When a component is HMR-enabled, we need to make sure that all static nodes
 * inside a block also inherit the DOM element from the previous tree so that
 * HMR updates (which are full updates) can retrieve the element for patching.
 *
 * #2080
 * Inside keyed `template` fragment static children, if a fragment is moved,
 * the children will always be moved. Therefore, in order to ensure correct move
 * position, el should be inherited from previous nodes.
 */ function $a34dd0657f3f171d$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $ciGHN.isArray)(ch1) && (0, $ciGHN.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        // this is only called in the optimized path so array children are
        // guaranteed to be vnodes
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 /* ELEMENT */  && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32 /* HYDRATE_EVENTS */ ) {
                c2 = ch2[i] = $a34dd0657f3f171d$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow) $a34dd0657f3f171d$var$traverseStaticChildren(c1, c2);
        }
    }
}
// https://en.wikipedia.org/wiki/Longest_increasing_subsequence
function $a34dd0657f3f171d$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
const $a34dd0657f3f171d$var$isTeleport = (type)=>type.__isTeleport;
const $a34dd0657f3f171d$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $a34dd0657f3f171d$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $a34dd0657f3f171d$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $ciGHN.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            target;
            return target;
        }
    } else return targetSelector;
};
const $a34dd0657f3f171d$var$TeleportImpl = {
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $a34dd0657f3f171d$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if (n1 == null) {
            // insert anchors in the main view
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const target = n2.target = $a34dd0657f3f171d$var$resolveTarget(n2.props, querySelector);
            const targetAnchor = n2.targetAnchor = createText("");
            if (target) {
                insert(targetAnchor, target);
                // #2652 we could be teleporting from a non-SVG tree into an SVG tree
                isSVG = isSVG || $a34dd0657f3f171d$var$isTargetSVG(target);
            }
            const mount = (container, anchor)=>{
                // Teleport *always* has Array children. This is enforced in both the
                // compiler and vnode children normalization.
                if (shapeFlag & 16 /* ARRAY_CHILDREN */ ) mountChildren(children, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            };
            if (disabled) mount(container, mainAnchor);
            else if (target) mount(target, targetAnchor);
        } else {
            // update content
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $a34dd0657f3f171d$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            isSVG = isSVG || $a34dd0657f3f171d$var$isTargetSVG(target);
            if (dynamicChildren) {
                // fast path when the teleport happens to be a block root
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, isSVG, slotScopeIds);
                // even in block tree mode we need to make sure all root-level nodes
                // in the teleport inherit previous DOM references so that they can
                // be moved in future patches.
                $a34dd0657f3f171d$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) // enabled -> disabled
                // move into main container
                $a34dd0657f3f171d$var$moveTeleport(n2, container, mainAnchor, internals, 1 /* TOGGLE */ );
            } else {
                // target changed
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $a34dd0657f3f171d$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $a34dd0657f3f171d$var$moveTeleport(n2, nextTarget, null, internals, 0 /* TARGET_CHANGE */ );
                } else if (wasDisabled) // disabled -> enabled
                // move into teleport target
                $a34dd0657f3f171d$var$moveTeleport(n2, target, targetAnchor, internals, 1 /* TOGGLE */ );
            }
        }
    },
    remove (vnode, parentComponent, parentSuspense, optimized, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) hostRemove(targetAnchor);
        // an unmounted teleport should always remove its children if not disabled
        if (doRemove || !$a34dd0657f3f171d$var$isTeleportDisabled(props)) {
            hostRemove(anchor);
            if (shapeFlag & 16 /* ARRAY_CHILDREN */ ) for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, true, !!child.dynamicChildren);
            }
        }
    },
    move: $a34dd0657f3f171d$var$moveTeleport,
    hydrate: $a34dd0657f3f171d$var$hydrateTeleport
};
function $a34dd0657f3f171d$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2 /* REORDER */ ) {
    // move target anchor if this is a target change.
    if (moveType === 0 /* TARGET_CHANGE */ ) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2 /* REORDER */ ;
    // move main view anchor if this is a re-order.
    if (isReorder) insert(el, container, parentAnchor);
    // if this is a re-order and teleport is enabled (content is in target)
    // do not move children. So the opposite is: only move children if this
    // is not a reorder, or the teleport is disabled
    if (!isReorder || $a34dd0657f3f171d$var$isTeleportDisabled(props)) {
        // Teleport has either Array children or no children.
        if (shapeFlag & 16 /* ARRAY_CHILDREN */ ) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2 /* REORDER */ );
    }
    // move main view anchor if this is a re-order.
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $a34dd0657f3f171d$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector } }, hydrateChildren) {
    const target = vnode.target = $a34dd0657f3f171d$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        // if multiple teleports rendered to the same target element, we need to
        // pick up from where the last teleport finished instead of the first node
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16 /* ARRAY_CHILDREN */ ) {
            if ($a34dd0657f3f171d$var$isTeleportDisabled(vnode.props)) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetAnchor = targetNode;
            } else {
                vnode.anchor = nextSibling(node);
                vnode.targetAnchor = hydrateChildren(targetNode, vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
            target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
        }
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
// Force-casted public typing for h and TSX props inference
const $a34dd0657f3f171d$export$76d55a0304a371f4 = $a34dd0657f3f171d$var$TeleportImpl;
const $a34dd0657f3f171d$var$COMPONENTS = "components";
const $a34dd0657f3f171d$var$DIRECTIVES = "directives";
/**
 * @private
 */ function $a34dd0657f3f171d$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $a34dd0657f3f171d$var$resolveAsset($a34dd0657f3f171d$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $a34dd0657f3f171d$var$NULL_DYNAMIC_COMPONENT = Symbol();
/**
 * @private
 */ function $a34dd0657f3f171d$export$b44c564a05ca975(component) {
    if ((0, $ciGHN.isString)(component)) return $a34dd0657f3f171d$var$resolveAsset($a34dd0657f3f171d$var$COMPONENTS, component, false) || component;
    else // invalid types will fallthrough to createVNode and raise warning
    return component || $a34dd0657f3f171d$var$NULL_DYNAMIC_COMPONENT;
}
/**
 * @private
 */ function $a34dd0657f3f171d$export$a1989e995cd481be(name) {
    return $a34dd0657f3f171d$var$resolveAsset($a34dd0657f3f171d$var$DIRECTIVES, name);
}
// implementation
function $a34dd0657f3f171d$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $a34dd0657f3f171d$var$currentRenderingInstance || $a34dd0657f3f171d$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        // explicit self name has highest priority
        if (type === $a34dd0657f3f171d$var$COMPONENTS) {
            const selfName = $a34dd0657f3f171d$var$getComponentName(Component);
            if (selfName && (selfName === name || selfName === (0, $ciGHN.camelize)(name) || selfName === (0, $ciGHN.capitalize)((0, $ciGHN.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $a34dd0657f3f171d$var$resolve(instance[type] || Component[type], name) || // global registration
        $a34dd0657f3f171d$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) // fallback to implicit self-reference
        return Component;
        return res;
    }
}
function $a34dd0657f3f171d$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $ciGHN.camelize)(name)] || registry[(0, $ciGHN.capitalize)((0, $ciGHN.camelize)(name))]);
}
const $a34dd0657f3f171d$export$ffb0004e005737fa = Symbol(undefined);
const $a34dd0657f3f171d$export$5f1af8db9871e1d6 = Symbol(undefined);
const $a34dd0657f3f171d$export$4d299b491347818a = Symbol(undefined);
const $a34dd0657f3f171d$export$c1b9a1d3af45b7b6 = Symbol(undefined);
// Since v-if and v-for are the two possible ways node structure can dynamically
// change, once we consider v-if branches and each v-for fragment a block, we
// can divide a template into nested blocks, and within each block the node
// structure would be stable. This allows us to skip most children diffing
// and only worry about the dynamic nodes (indicated by patch flags).
const $a34dd0657f3f171d$var$blockStack = [];
let $a34dd0657f3f171d$var$currentBlock = null;
/**
 * Open a block.
 * This must be called before `createBlock`. It cannot be part of `createBlock`
 * because the children of the block are evaluated before `createBlock` itself
 * is called. The generated code typically looks like this:
 *
 * ```js
 * function render() {
 *   return (openBlock(),createBlock('div', null, [...]))
 * }
 * ```
 * disableTracking is true when creating a v-for fragment block, since a v-for
 * fragment always diffs its children.
 *
 * @private
 */ function $a34dd0657f3f171d$export$e7eaa45e502fe5cc(disableTracking = false) {
    $a34dd0657f3f171d$var$blockStack.push($a34dd0657f3f171d$var$currentBlock = disableTracking ? null : []);
}
function $a34dd0657f3f171d$var$closeBlock() {
    $a34dd0657f3f171d$var$blockStack.pop();
    $a34dd0657f3f171d$var$currentBlock = $a34dd0657f3f171d$var$blockStack[$a34dd0657f3f171d$var$blockStack.length - 1] || null;
}
// Whether we should be tracking dynamic child nodes inside a block.
// Only tracks when this value is > 0
// We are not using a simple boolean because this value may need to be
// incremented/decremented by nested usage of v-once (see below)
let $a34dd0657f3f171d$var$isBlockTreeEnabled = 1;
/**
 * Block tracking sometimes needs to be disabled, for example during the
 * creation of a tree that needs to be cached by v-once. The compiler generates
 * code like this:
 *
 * ``` js
 * _cache[1] || (
 *   setBlockTracking(-1),
 *   _cache[1] = createVNode(...),
 *   setBlockTracking(1),
 *   _cache[1]
 * )
 * ```
 *
 * @private
 */ function $a34dd0657f3f171d$export$c20bee82f26f1e27(value) {
    $a34dd0657f3f171d$var$isBlockTreeEnabled += value;
}
function $a34dd0657f3f171d$var$setupBlock(vnode) {
    // save current block children on the block vnode
    vnode.dynamicChildren = $a34dd0657f3f171d$var$isBlockTreeEnabled > 0 ? $a34dd0657f3f171d$var$currentBlock || (0, $ciGHN.EMPTY_ARR) : null;
    // close block
    $a34dd0657f3f171d$var$closeBlock();
    // a block is always going to be patched, so track it as a child of its
    // parent block
    if ($a34dd0657f3f171d$var$isBlockTreeEnabled > 0 && $a34dd0657f3f171d$var$currentBlock) $a34dd0657f3f171d$var$currentBlock.push(vnode);
    return vnode;
}
/**
 * @private
 */ function $a34dd0657f3f171d$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $a34dd0657f3f171d$var$setupBlock($a34dd0657f3f171d$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
/**
 * Create a block root vnode. Takes the same exact arguments as `createVNode`.
 * A block root keeps track of dynamic nodes within the block in the
 * `dynamicChildren` array.
 *
 * @private
 */ function $a34dd0657f3f171d$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $a34dd0657f3f171d$var$setupBlock($a34dd0657f3f171d$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $a34dd0657f3f171d$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $a34dd0657f3f171d$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $a34dd0657f3f171d$var$vnodeArgsTransformer;
/**
 * Internal API for registering an arguments transform for createVNode
 * used for creating stubs in the test-utils
 * It is *internal* but needs to be exposed for test-utils to pick up proper
 * typings
 */ function $a34dd0657f3f171d$export$83beccd3afeeb809(transformer) {
    $a34dd0657f3f171d$var$vnodeArgsTransformer = transformer;
}
const $a34dd0657f3f171d$var$createVNodeWithArgsTransform = (...args)=>{
    return $a34dd0657f3f171d$var$_createVNode(...$a34dd0657f3f171d$var$vnodeArgsTransformer ? $a34dd0657f3f171d$var$vnodeArgsTransformer(args, $a34dd0657f3f171d$var$currentRenderingInstance) : args);
};
const $a34dd0657f3f171d$var$InternalObjectKey = `__vInternal`;
const $a34dd0657f3f171d$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $a34dd0657f3f171d$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    return ref != null ? (0, $ciGHN.isString)(ref) || (0, $aTBEd.isRef)(ref) || (0, $ciGHN.isFunction)(ref) ? {
        i: $a34dd0657f3f171d$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $a34dd0657f3f171d$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $a34dd0657f3f171d$export$ffb0004e005737fa ? 0 : 1 /* ELEMENT */ , isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $a34dd0657f3f171d$var$normalizeKey(props),
        ref: props && $a34dd0657f3f171d$var$normalizeRef(props),
        scopeId: $a34dd0657f3f171d$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null
    };
    if (needFullChildrenNormalization) {
        $a34dd0657f3f171d$var$normalizeChildren(vnode, children);
        // normalize suspense children
        if (shapeFlag & 128 /* SUSPENSE */ ) type.normalize(vnode);
    } else if (children) // compiled element vnode - if children is passed, only possible types are
    // string or Array.
    vnode.shapeFlag |= (0, $ciGHN.isString)(children) ? 8 /* TEXT_CHILDREN */  : 16 /* ARRAY_CHILDREN */ ;
    // track vnode for block tree
    if ($a34dd0657f3f171d$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $a34dd0657f3f171d$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6 /* COMPONENT */ ) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32 /* HYDRATE_EVENTS */ ) $a34dd0657f3f171d$var$currentBlock.push(vnode);
    return vnode;
}
const $a34dd0657f3f171d$export$bf5c4cf060303d58 = $a34dd0657f3f171d$var$_createVNode;
function $a34dd0657f3f171d$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $a34dd0657f3f171d$var$NULL_DYNAMIC_COMPONENT) type = $a34dd0657f3f171d$export$4d299b491347818a;
    if ($a34dd0657f3f171d$export$3868d13f8734ae81(type)) {
        // createVNode receiving an existing vnode. This happens in cases like
        // <component :is="vnode"/>
        // #2078 make sure to merge refs during the clone instead of overwriting it
        const cloned = $a34dd0657f3f171d$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $a34dd0657f3f171d$var$normalizeChildren(cloned, children);
        return cloned;
    }
    // class component normalization.
    if ($a34dd0657f3f171d$var$isClassComponent(type)) type = type.__vccOpts;
    // class & style normalization.
    if (props) {
        // for reactive or proxy objects, we need to clone it to enable mutation.
        props = $a34dd0657f3f171d$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $ciGHN.isString)(klass)) props.class = (0, $ciGHN.normalizeClass)(klass);
        if ((0, $ciGHN.isObject)(style)) {
            // reactive state objects need to be cloned since they are likely to be
            // mutated
            if ((0, $aTBEd.isProxy)(style) && !(0, $ciGHN.isArray)(style)) style = (0, $ciGHN.extend)({}, style);
            props.style = (0, $ciGHN.normalizeStyle)(style);
        }
    }
    // encode the vnode type information into a bitmap
    const shapeFlag = (0, $ciGHN.isString)(type) ? 1 /* ELEMENT */  : $a34dd0657f3f171d$var$isSuspense(type) ? 128 /* SUSPENSE */  : $a34dd0657f3f171d$var$isTeleport(type) ? 64 /* TELEPORT */  : (0, $ciGHN.isObject)(type) ? 4 /* STATEFUL_COMPONENT */  : (0, $ciGHN.isFunction)(type) ? 2 /* FUNCTIONAL_COMPONENT */  : 0;
    return $a34dd0657f3f171d$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $a34dd0657f3f171d$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $aTBEd.isProxy)(props) || $a34dd0657f3f171d$var$InternalObjectKey in props ? (0, $ciGHN.extend)({}, props) : props;
}
function $a34dd0657f3f171d$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false) {
    // This is intentionally NOT using spread or extend to avoid the runtime
    // key enumeration cost.
    const { props: props, ref: ref, patchFlag: patchFlag, children: children } = vnode;
    const mergedProps = extraProps ? $a34dd0657f3f171d$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $a34dd0657f3f171d$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $ciGHN.isArray)(ref) ? ref.concat($a34dd0657f3f171d$var$normalizeRef(extraProps)) : [
            ref,
            $a34dd0657f3f171d$var$normalizeRef(extraProps)
        ] : $a34dd0657f3f171d$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $a34dd0657f3f171d$export$ffb0004e005737fa ? patchFlag === -1 // hoisted node
         ? 16 /* FULL_PROPS */  : patchFlag | 16 /* FULL_PROPS */  : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: vnode.transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $a34dd0657f3f171d$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $a34dd0657f3f171d$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor
    };
    return cloned;
}
/**
 * Dev only, for HMR of hoisted vnodes reused in v-for
 * https://github.com/vitejs/vite/issues/2022
 */ function $a34dd0657f3f171d$var$deepCloneVNode(vnode) {
    const cloned = $a34dd0657f3f171d$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $ciGHN.isArray)(vnode.children)) cloned.children = vnode.children.map($a34dd0657f3f171d$var$deepCloneVNode);
    return cloned;
}
/**
 * @private
 */ function $a34dd0657f3f171d$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $a34dd0657f3f171d$export$bf5c4cf060303d58($a34dd0657f3f171d$export$5f1af8db9871e1d6, null, text, flag);
}
/**
 * @private
 */ function $a34dd0657f3f171d$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    // A static vnode can contain multiple stringified elements, and the number
    // of elements is necessary for hydration.
    const vnode = $a34dd0657f3f171d$export$bf5c4cf060303d58($a34dd0657f3f171d$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
/**
 * @private
 */ function $a34dd0657f3f171d$export$49553837c7236d3c(text = "", // when used as the v-else branch, the comment node must be created as a
// block to ensure correct updates.
asBlock = false) {
    return asBlock ? ($a34dd0657f3f171d$export$e7eaa45e502fe5cc(), $a34dd0657f3f171d$export$9f2dfe8048dfb22b($a34dd0657f3f171d$export$4d299b491347818a, null, text)) : $a34dd0657f3f171d$export$bf5c4cf060303d58($a34dd0657f3f171d$export$4d299b491347818a, null, text);
}
function $a34dd0657f3f171d$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") // empty placeholder
    return $a34dd0657f3f171d$export$bf5c4cf060303d58($a34dd0657f3f171d$export$4d299b491347818a);
    else if ((0, $ciGHN.isArray)(child)) // fragment
    return $a34dd0657f3f171d$export$bf5c4cf060303d58($a34dd0657f3f171d$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if (typeof child === "object") // already vnode, this should be the most common since compiled templates
    // always produce all-vnode children arrays
    return $a34dd0657f3f171d$var$cloneIfMounted(child);
    else // strings and numbers
    return $a34dd0657f3f171d$export$bf5c4cf060303d58($a34dd0657f3f171d$export$5f1af8db9871e1d6, null, String(child));
}
// optimized normalization for template-compiled render fns
function $a34dd0657f3f171d$var$cloneIfMounted(child) {
    return child.el === null || child.memo ? child : $a34dd0657f3f171d$export$ee4f9e12c0a92a1a(child);
}
function $a34dd0657f3f171d$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $ciGHN.isArray)(children)) type = 16 /* ARRAY_CHILDREN */ ;
    else if (typeof children === "object") {
        if (shapeFlag & 65 /* TELEPORT */ ) {
            // Normalize slot to plain children for plain element and Teleport
            const slot = children.default;
            if (slot) {
                // _c marker is added by withCtx() indicating this is a compiled slot
                slot._c && (slot._d = false);
                $a34dd0657f3f171d$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32 /* SLOTS_CHILDREN */ ;
            const slotFlag = children._;
            if (!slotFlag && !($a34dd0657f3f171d$var$InternalObjectKey in children)) children._ctx = $a34dd0657f3f171d$var$currentRenderingInstance;
            else if (slotFlag === 3 /* FORWARDED */  && $a34dd0657f3f171d$var$currentRenderingInstance) {
                // a child component receives forwarded slots from the parent.
                // its slot type is determined by its parent's slot type.
                if ($a34dd0657f3f171d$var$currentRenderingInstance.slots._ === 1 /* STABLE */ ) children._ = 1 /* STABLE */ ;
                else {
                    children._ = 2 /* DYNAMIC */ ;
                    vnode.patchFlag |= 1024 /* DYNAMIC_SLOTS */ ;
                }
            }
        }
    } else if ((0, $ciGHN.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $a34dd0657f3f171d$var$currentRenderingInstance
        };
        type = 32 /* SLOTS_CHILDREN */ ;
    } else {
        children = String(children);
        // force teleport children to array so it can be moved around
        if (shapeFlag & 64 /* TELEPORT */ ) {
            type = 16 /* ARRAY_CHILDREN */ ;
            children = [
                $a34dd0657f3f171d$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8 /* TEXT_CHILDREN */ ;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $a34dd0657f3f171d$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $ciGHN.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $ciGHN.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $ciGHN.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $ciGHN.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $a34dd0657f3f171d$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $a34dd0657f3f171d$export$dae85862a8d94378(hook, instance, 7 /* VNODE_HOOK */ , [
        vnode,
        prevVNode
    ]);
}
/**
 * Actual implementation
 */ function $a34dd0657f3f171d$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    if ((0, $ciGHN.isArray)(source) || (0, $ciGHN.isString)(source)) {
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(source[i], i, undefined, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, undefined, cached && cached[i]);
    } else if ((0, $ciGHN.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, undefined, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
/**
 * Compiler runtime helper for creating dynamic slots object
 * @private
 */ function $a34dd0657f3f171d$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        // array of dynamic slot generated by <template v-for="..." #[...]>
        if ((0, $ciGHN.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) // conditional single slot generated by <template v-if="..." #foo>
        slots[slot.name] = slot.fn;
    }
    return slots;
}
/**
 * Compiler runtime helper for rendering `<slot/>`
 * @private
 */ function $a34dd0657f3f171d$export$4abee4c34694ada1(slots, name, props = {}, // this is not a user-facing function, so the fallback is always generated by
// the compiler and guaranteed to be a function returning an array
fallback, noSlotted) {
    if ($a34dd0657f3f171d$var$currentRenderingInstance.isCE) return $a34dd0657f3f171d$export$bf5c4cf060303d58("slot", name === "default" ? null : {
        name: name
    }, fallback && fallback());
    let slot = slots[name];
    // a compiled slot disables block tracking by default to avoid manual
    // invocation interfering with template-based block tracking, but in
    // `renderSlot` we can be sure that it's template-based so we can force
    // enable it.
    if (slot && slot._c) slot._d = false;
    $a34dd0657f3f171d$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $a34dd0657f3f171d$var$ensureValidVNode(slot(props));
    const rendered = $a34dd0657f3f171d$export$9f2dfe8048dfb22b($a34dd0657f3f171d$export$ffb0004e005737fa, {
        key: props.key || `_${name}`
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 /* STABLE */  ? 64 /* STABLE_FRAGMENT */  : -2 /* BAIL */ );
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $a34dd0657f3f171d$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$a34dd0657f3f171d$export$3868d13f8734ae81(child)) return true;
        if (child.type === $a34dd0657f3f171d$export$4d299b491347818a) return false;
        if (child.type === $a34dd0657f3f171d$export$ffb0004e005737fa && !$a34dd0657f3f171d$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
/**
 * For prefixing keys in v-on="obj" with "on"
 * @private
 */ function $a34dd0657f3f171d$export$2fb94ff667a6a1a(obj) {
    const ret = {};
    for(const key in obj)ret[(0, $ciGHN.toHandlerKey)(key)] = obj[key];
    return ret;
}
/**
 * #2437 In Vue 3, functional components do not have a public instance proxy but
 * they exist in the internal parent chain. For code that relies on traversing
 * public $parent chains, skip functional ones and go to the parent instead.
 */ const $a34dd0657f3f171d$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($a34dd0657f3f171d$var$isStatefulComponent(i)) return $a34dd0657f3f171d$var$getExposeProxy(i) || i.proxy;
    return $a34dd0657f3f171d$var$getPublicInstance(i.parent);
};
const $a34dd0657f3f171d$var$publicPropertiesMap = (0, $ciGHN.extend)(Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$a34dd0657f3f171d$var$getPublicInstance(i.parent),
    $root: (i)=>$a34dd0657f3f171d$var$getPublicInstance(i.root),
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $a34dd0657f3f171d$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>()=>$a34dd0657f3f171d$var$queueJob(i.update),
    $nextTick: (i)=>$a34dd0657f3f171d$export$bdd553fddd433dcb.bind(i.proxy),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $a34dd0657f3f171d$var$instanceWatch.bind(i) : (0, $ciGHN.NOOP)
});
const $a34dd0657f3f171d$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        // data / props / ctx
        // This getter gets called for every property access on the render context
        // during render and is a major hotspot. The most expensive part of this
        // is the multiple hasOwn() calls. It's much faster to do a simple property
        // access on a plain object, so we use an accessCache object (with null
        // prototype) to memoize what access type a key corresponds to.
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== undefined) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if (setupState !== (0, $ciGHN.EMPTY_OBJ) && (0, $ciGHN.hasOwn)(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $ciGHN.EMPTY_OBJ) && (0, $ciGHN.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $ciGHN.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $ciGHN.EMPTY_OBJ) && (0, $ciGHN.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $a34dd0657f3f171d$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $a34dd0657f3f171d$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        // public $xxx properties
        if (publicGetter) {
            if (key === "$attrs") (0, $aTBEd.track)(instance, "get" /* GET */ , key);
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $ciGHN.EMPTY_OBJ) && (0, $ciGHN.hasOwn)(ctx, key)) {
            // user may set custom properties to `this` that start with `$`
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $ciGHN.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if (setupState !== (0, $ciGHN.EMPTY_OBJ) && (0, $ciGHN.hasOwn)(setupState, key)) setupState[key] = value;
        else if (data !== (0, $ciGHN.EMPTY_OBJ) && (0, $ciGHN.hasOwn)(data, key)) data[key] = value;
        else if ((0, $ciGHN.hasOwn)(instance.props, key)) return false;
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, propsOptions: propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, $ciGHN.EMPTY_OBJ) && (0, $ciGHN.hasOwn)(data, key) || setupState !== (0, $ciGHN.EMPTY_OBJ) && (0, $ciGHN.hasOwn)(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $ciGHN.hasOwn)(normalizedProps, key) || (0, $ciGHN.hasOwn)(ctx, key) || (0, $ciGHN.hasOwn)($a34dd0657f3f171d$var$publicPropertiesMap, key) || (0, $ciGHN.hasOwn)(appContext.config.globalProperties, key);
    }
};
var $a34dd0657f3f171d$var$target;
const $a34dd0657f3f171d$var$RuntimeCompiledPublicInstanceProxyHandlers = /*#__PURE__*/ (0, $ciGHN.extend)({}, $a34dd0657f3f171d$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        // fast path for unscopables when using `with` block
        if (key === Symbol.unscopables) return;
        return $a34dd0657f3f171d$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $ciGHN.isGloballyWhitelisted)(key);
        return has;
    }
});
// dev only
// In dev mode, the proxy target exposes the same properties as seen on `this`
// for easier console inspection. In prod mode it will be an empty object so
// these properties definitions can be skipped.
function $a34dd0657f3f171d$var$createDevRenderContext(instance) {
    const target = {};
    // expose internal instance for proxy handlers
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    // expose public properties
    Object.keys($a34dd0657f3f171d$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$a34dd0657f3f171d$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $ciGHN.NOOP)
        });
    });
    return target;
}
// dev only
function $a34dd0657f3f171d$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $ciGHN.NOOP)
        });
    });
}
// dev only
function $a34dd0657f3f171d$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $aTBEd.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if (key[0] === "$" || key[0] === "_") {
                $a34dd0657f3f171d$export$c106dd0671a0fc2d(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" ` + `which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $ciGHN.NOOP)
            });
        }
    });
}
const $a34dd0657f3f171d$var$emptyAppContext = $a34dd0657f3f171d$var$createAppContext();
let $a34dd0657f3f171d$var$uid$1 = 0;
function $a34dd0657f3f171d$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    // inherit parent app context - or - if root, adopt from root vnode
    const appContext = (parent ? parent.appContext : vnode.appContext) || $a34dd0657f3f171d$var$emptyAppContext;
    const instance = {
        uid: $a34dd0657f3f171d$var$uid$1++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        next: null,
        subTree: null,
        effect: null,
        update: null,
        scope: new (0, $aTBEd.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        accessCache: null,
        renderCache: [],
        // local resovled assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $a34dd0657f3f171d$var$normalizePropsOptions(type, appContext),
        emitsOptions: $a34dd0657f3f171d$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        emitted: null,
        // props default value
        propsDefaults: (0, $ciGHN.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $ciGHN.EMPTY_OBJ),
        data: (0, $ciGHN.EMPTY_OBJ),
        props: (0, $ciGHN.EMPTY_OBJ),
        attrs: (0, $ciGHN.EMPTY_OBJ),
        slots: (0, $ciGHN.EMPTY_OBJ),
        refs: (0, $ciGHN.EMPTY_OBJ),
        setupState: (0, $ciGHN.EMPTY_OBJ),
        setupContext: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $a34dd0657f3f171d$var$emit$1.bind(null, instance);
    // apply custom element special handling
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $a34dd0657f3f171d$var$currentInstance = null;
const $a34dd0657f3f171d$export$f13e630aa3915748 = ()=>$a34dd0657f3f171d$var$currentInstance || $a34dd0657f3f171d$var$currentRenderingInstance;
const $a34dd0657f3f171d$var$setCurrentInstance = (instance)=>{
    $a34dd0657f3f171d$var$currentInstance = instance;
    instance.scope.on();
};
const $a34dd0657f3f171d$var$unsetCurrentInstance = ()=>{
    $a34dd0657f3f171d$var$currentInstance && $a34dd0657f3f171d$var$currentInstance.scope.off();
    $a34dd0657f3f171d$var$currentInstance = null;
};
const $a34dd0657f3f171d$var$isBuiltInTag = /*#__PURE__*/ (0, $ciGHN.makeMap)("slot,component");
function $a34dd0657f3f171d$var$validateComponentName(name, config) {
    const appIsNativeTag = config.isNativeTag || (0, $ciGHN.NO);
    if ($a34dd0657f3f171d$var$isBuiltInTag(name) || appIsNativeTag(name)) $a34dd0657f3f171d$export$c106dd0671a0fc2d("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $a34dd0657f3f171d$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4 /* STATEFUL_COMPONENT */ ;
}
let $a34dd0657f3f171d$var$isInSSRComponentSetup = false;
function $a34dd0657f3f171d$var$setupComponent(instance, isSSR = false) {
    $a34dd0657f3f171d$var$isInSSRComponentSetup = isSSR;
    const { props: props, children: children } = instance.vnode;
    const isStateful = $a34dd0657f3f171d$var$isStatefulComponent(instance);
    $a34dd0657f3f171d$var$initProps(instance, props, isStateful, isSSR);
    $a34dd0657f3f171d$var$initSlots(instance, children);
    const setupResult = isStateful ? $a34dd0657f3f171d$var$setupStatefulComponent(instance, isSSR) : undefined;
    $a34dd0657f3f171d$var$isInSSRComponentSetup = false;
    return setupResult;
}
function $a34dd0657f3f171d$var$setupStatefulComponent(instance, isSSR) {
    const Component = instance.type;
    // 0. create render proxy property access cache
    instance.accessCache = Object.create(null);
    // 1. create public instance / render proxy
    // also mark it raw so it's never observed
    instance.proxy = (0, $aTBEd.markRaw)(new Proxy(instance.ctx, $a34dd0657f3f171d$var$PublicInstanceProxyHandlers));
    // 2. call setup()
    const { setup: setup } = Component;
    if (setup) {
        const setupContext = instance.setupContext = setup.length > 1 ? $a34dd0657f3f171d$var$createSetupContext(instance) : null;
        $a34dd0657f3f171d$var$setCurrentInstance(instance);
        (0, $aTBEd.pauseTracking)();
        const setupResult = $a34dd0657f3f171d$export$b22fcaf88446e9bf(setup, instance, 0 /* SETUP_FUNCTION */ , [
            (0, instance.props),
            setupContext
        ]);
        (0, $aTBEd.resetTracking)();
        $a34dd0657f3f171d$var$unsetCurrentInstance();
        if ((0, $ciGHN.isPromise)(setupResult)) {
            setupResult.then($a34dd0657f3f171d$var$unsetCurrentInstance, $a34dd0657f3f171d$var$unsetCurrentInstance);
            if (isSSR) // return the promise so server-renderer can wait on it
            return setupResult.then((resolvedResult)=>{
                $a34dd0657f3f171d$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $a34dd0657f3f171d$export$d3da1ecaf1206c58(e, instance, 0 /* SETUP_FUNCTION */ );
            });
            else // async setup returned Promise.
            // bail here and wait for re-entry.
            instance.asyncDep = setupResult;
        } else $a34dd0657f3f171d$var$handleSetupResult(instance, setupResult, isSSR);
    } else $a34dd0657f3f171d$var$finishComponentSetup(instance, isSSR);
}
function $a34dd0657f3f171d$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $ciGHN.isFunction)(setupResult)) {
        // setup returned an inline render function
        if (instance.type.__ssrInlineRender) // when the function's name is `ssrRender` (compiled by SFC inline mode),
        // set it as ssrRender instead.
        instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $ciGHN.isObject)(setupResult)) {
        // setup returned bindings.
        // assuming a render function compiled from template is present.
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $aTBEd.proxyRefs)(setupResult);
    }
    $a34dd0657f3f171d$var$finishComponentSetup(instance, isSSR);
}
let $a34dd0657f3f171d$var$compile;
let $a34dd0657f3f171d$var$installWithProxy;
/**
 * For runtime-dom to register the compiler.
 * Note the exported method uses any to avoid d.ts relying on the compiler types.
 */ function $a34dd0657f3f171d$export$667bb5a67822b941(_compile) {
    $a34dd0657f3f171d$var$compile = _compile;
    $a34dd0657f3f171d$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $a34dd0657f3f171d$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
// dev only
const $a34dd0657f3f171d$export$c93a9c496c5211fa = ()=>!$a34dd0657f3f171d$var$compile;
function $a34dd0657f3f171d$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    // template / render function normalization
    // could be already set when returned from setup()
    if (!instance.render) {
        // only do on-the-fly compile if not in SSR - SSR on-the-fly compilation
        // is done by server-renderer
        if (!isSSR && $a34dd0657f3f171d$var$compile && !Component.render) {
            const template = Component.template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $ciGHN.extend)((0, $ciGHN.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $a34dd0657f3f171d$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $ciGHN.NOOP);
        // for runtime-compiled render functions using `with` blocks, the render
        // proxy used needs a different `has` handler which is more performant and
        // also only allows a whitelist of globals to fallthrough.
        if ($a34dd0657f3f171d$var$installWithProxy) $a34dd0657f3f171d$var$installWithProxy(instance);
    }
    // support for 2.x options
    if (__VUE_OPTIONS_API__ && true) {
        $a34dd0657f3f171d$var$setCurrentInstance(instance);
        (0, $aTBEd.pauseTracking)();
        $a34dd0657f3f171d$var$applyOptions(instance);
        (0, $aTBEd.resetTracking)();
        $a34dd0657f3f171d$var$unsetCurrentInstance();
    }
}
function $a34dd0657f3f171d$var$createAttrsProxy(instance) {
    return new Proxy(instance.attrs, {
        get (target, key) {
            (0, $aTBEd.track)(instance, "get" /* GET */ , "$attrs");
            return target[key];
        }
    });
}
function $a34dd0657f3f171d$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    let attrs;
    var event, args;
    return {
        get attrs () {
            return attrs || (attrs = $a34dd0657f3f171d$var$createAttrsProxy(instance));
        },
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $a34dd0657f3f171d$var$getExposeProxy(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $aTBEd.proxyRefs)((0, $aTBEd.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $a34dd0657f3f171d$var$publicPropertiesMap) return $a34dd0657f3f171d$var$publicPropertiesMap[key](instance);
        }
    }));
}
const $a34dd0657f3f171d$var$classifyRE = /(?:^|[-_])(\w)/g;
const $a34dd0657f3f171d$var$classify = (str)=>str.replace($a34dd0657f3f171d$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $a34dd0657f3f171d$var$getComponentName(Component) {
    return (0, $ciGHN.isFunction)(Component) ? Component.displayName || Component.name : Component.name;
}
/* istanbul ignore next */ function $a34dd0657f3f171d$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $a34dd0657f3f171d$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        // try to infer the name based on reverse resolution
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $a34dd0657f3f171d$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $a34dd0657f3f171d$var$isClassComponent(value) {
    return (0, $ciGHN.isFunction)(value) && "__vccOpts" in value;
}
const $a34dd0657f3f171d$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    // @ts-ignore
    return (0, $aTBEd.computed)(getterOrOptions, debugOptions, $a34dd0657f3f171d$var$isInSSRComponentSetup);
};
// dev only
const $a34dd0657f3f171d$var$warnRuntimeUsage = (method)=>$a34dd0657f3f171d$export$c106dd0671a0fc2d(`${method}() is a compiler-hint helper that is only usable inside ` + `<script setup> of a single file component. Its arguments should be ` + `compiled away and passing it at runtime has no effect.`);
// implementation
function $a34dd0657f3f171d$export$80b33eababae110e() {
    return null;
}
// implementation
function $a34dd0657f3f171d$export$51ecece22fc17ddc() {
    return null;
}
/**
 * Vue `<script setup>` compiler macro for declaring a component's exposed
 * instance properties when it is accessed by a parent component via template
 * refs.
 *
 * `<script setup>` components are closed by default - i.e. variables inside
 * the `<script setup>` scope is not exposed to parent unless explicitly exposed
 * via `defineExpose`.
 *
 * This is only usable inside `<script setup>`, is compiled away in the
 * output and should **not** be actually called at runtime.
 */ function $a34dd0657f3f171d$export$da25b65ca24b518a(exposed) {}
/**
 * Vue `<script setup>` compiler macro for providing props default values when
 * using type-based `defineProps` declaration.
 *
 * Example usage:
 * ```ts
 * withDefaults(defineProps<{
 *   size?: number
 *   labels?: string[]
 * }>(), {
 *   size: 3,
 *   labels: () => ['default label']
 * })
 * ```
 *
 * This is only usable inside `<script setup>`, is compiled away in the output
 * and should **not** be actually called at runtime.
 */ function $a34dd0657f3f171d$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $a34dd0657f3f171d$export$9203a8e84125433c() {
    return $a34dd0657f3f171d$var$getContext().slots;
}
function $a34dd0657f3f171d$export$75e29435042cd2ea() {
    return $a34dd0657f3f171d$var$getContext().attrs;
}
function $a34dd0657f3f171d$var$getContext() {
    const i = $a34dd0657f3f171d$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $a34dd0657f3f171d$var$createSetupContext(i));
}
/**
 * Runtime helper for merging default declarations. Imported by compiled code
 * only.
 * @internal
 */ function $a34dd0657f3f171d$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = (0, $ciGHN.isArray)(raw) ? raw.reduce((normalized, p)=>(normalized[p] = {}, normalized), {}) : raw;
    for(const key in defaults){
        const opt = props[key];
        if (opt) {
            if ((0, $ciGHN.isArray)(opt) || (0, $ciGHN.isFunction)(opt)) props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) props[key] = {
            default: defaults[key]
        };
    }
    return props;
}
/**
 * Used to create a proxy for the rest element when destructuring props with
 * defineProps().
 * @internal
 */ function $a34dd0657f3f171d$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
/**
 * `<script setup>` helper for persisting the current instance context over
 * async/await flows.
 *
 * `@vue/compiler-sfc` converts the following:
 *
 * ```ts
 * const x = await foo()
 * ```
 *
 * into:
 *
 * ```ts
 * let __temp, __restore
 * const x = (([__temp, __restore] = withAsyncContext(() => foo())),__temp=await __temp,__restore(),__temp)
 * ```
 * @internal
 */ function $a34dd0657f3f171d$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $a34dd0657f3f171d$export$f13e630aa3915748();
    let awaitable = getAwaitable();
    $a34dd0657f3f171d$var$unsetCurrentInstance();
    if ((0, $ciGHN.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $a34dd0657f3f171d$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$a34dd0657f3f171d$var$setCurrentInstance(ctx)
    ];
}
// Actual implementation
function $a34dd0657f3f171d$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, $ciGHN.isObject)(propsOrChildren) && !(0, $ciGHN.isArray)(propsOrChildren)) {
            // single vnode without props
            if ($a34dd0657f3f171d$export$3868d13f8734ae81(propsOrChildren)) return $a34dd0657f3f171d$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            // props without children
            return $a34dd0657f3f171d$export$bf5c4cf060303d58(type, propsOrChildren);
        } else // omit props
        return $a34dd0657f3f171d$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $a34dd0657f3f171d$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $a34dd0657f3f171d$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
const $a34dd0657f3f171d$export$f2549a27e18acf2d = Symbol(``);
const $a34dd0657f3f171d$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $a34dd0657f3f171d$export$a976684a0efeb93f($a34dd0657f3f171d$export$f2549a27e18acf2d);
        if (!ctx) $a34dd0657f3f171d$export$c106dd0671a0fc2d(`Server rendering context not provided. Make sure to only call ` + `useSSRContext() conditionally in the server build.`);
        return ctx;
    }
};
function $a34dd0657f3f171d$var$isShallow(value) {
    return !!(value && value["__v_isShallow" /* IS_SHALLOW */ ]);
}
function $a34dd0657f3f171d$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $aTBEd.toRaw)(instance.props)));
        if (instance.setupState !== (0, $ciGHN.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $ciGHN.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $aTBEd.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $ciGHN.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $ciGHN.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $aTBEd.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $ciGHN.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $ciGHN.isArray)(opts) && opts.includes(key) || (0, $ciGHN.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ($a34dd0657f3f171d$var$isShallow(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $a34dd0657f3f171d$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $a34dd0657f3f171d$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    // shallow clone
    ret.memo = memo.slice();
    return cache[index] = ret;
}
function $a34dd0657f3f171d$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if (prev[i] !== memo[i]) return false;
    }
    // make sure to let parent block track it when returning cached
    if ($a34dd0657f3f171d$var$isBlockTreeEnabled > 0 && $a34dd0657f3f171d$var$currentBlock) $a34dd0657f3f171d$var$currentBlock.push(cached);
    return true;
}
// Core API ------------------------------------------------------------------
const $a34dd0657f3f171d$export$83d89fbfd8236492 = "3.2.29";
const $a34dd0657f3f171d$var$_ssrUtils = {
    createComponentInstance: $a34dd0657f3f171d$var$createComponentInstance,
    setupComponent: $a34dd0657f3f171d$var$setupComponent,
    renderComponentRoot: $a34dd0657f3f171d$var$renderComponentRoot,
    setCurrentRenderingInstance: $a34dd0657f3f171d$var$setCurrentRenderingInstance,
    isVNode: $a34dd0657f3f171d$export$3868d13f8734ae81,
    normalizeVNode: $a34dd0657f3f171d$var$normalizeVNode
};
/**
 * SSR utils for \@vue/server-renderer. Only exposed in cjs builds.
 * @internal
 */ const $a34dd0657f3f171d$export$a9679033567b336d = $a34dd0657f3f171d$var$_ssrUtils;
/**
 * @internal only exposed in compat builds
 */ const $a34dd0657f3f171d$export$83cf26e06ea620e1 = null;
/**
 * @internal only exposed in compat builds.
 */ const $a34dd0657f3f171d$export$dc678eddf276286e = null;

});
parcelRegister("aTBEd", function(module, exports) {

$parcel$export(module.exports, "EffectScope", function () { return $7eec3e7441dc4067$export$1168ed9dbc71ddbd; });
$parcel$export(module.exports, "ReactiveEffect", function () { return $7eec3e7441dc4067$export$28352bb4dd362521; });
$parcel$export(module.exports, "resetTracking", function () { return $7eec3e7441dc4067$export$c39176b1babaa8b8; });
$parcel$export(module.exports, "pauseTracking", function () { return $7eec3e7441dc4067$export$938a971395fef855; });
$parcel$export(module.exports, "track", function () { return $7eec3e7441dc4067$export$6b2a7d5132615086; });
$parcel$export(module.exports, "trigger", function () { return $7eec3e7441dc4067$export$e614dc9140f7ae71; });
$parcel$export(module.exports, "toRaw", function () { return $7eec3e7441dc4067$export$ab18938b9fc5f28e; });
$parcel$export(module.exports, "isRef", function () { return $7eec3e7441dc4067$export$4f9f5282de18fc69; });
$parcel$export(module.exports, "reactive", function () { return $7eec3e7441dc4067$export$90a44edba14e47be; });
$parcel$export(module.exports, "isShallow", function () { return $7eec3e7441dc4067$export$7f3fe6025abfa26e; });
$parcel$export(module.exports, "shallowReactive", function () { return $7eec3e7441dc4067$export$8d81cefd22d22260; });
$parcel$export(module.exports, "isReactive", function () { return $7eec3e7441dc4067$export$352205f445242f02; });
$parcel$export(module.exports, "isProxy", function () { return $7eec3e7441dc4067$export$5f3ca29d057519b3; });
$parcel$export(module.exports, "markRaw", function () { return $7eec3e7441dc4067$export$995ab8b13ad7a9d0; });
$parcel$export(module.exports, "ref", function () { return $7eec3e7441dc4067$export$eff4d24c3ff7876e; });
$parcel$export(module.exports, "proxyRefs", function () { return $7eec3e7441dc4067$export$f353fd1b97db3fa0; });
$parcel$export(module.exports, "computed", function () { return $7eec3e7441dc4067$export$2983e091f1a1e8e2; });

var $ciGHN = parcelRequire("ciGHN");
function $7eec3e7441dc4067$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $7eec3e7441dc4067$var$activeEffectScope;
const $7eec3e7441dc4067$var$effectScopeStack = [];
class $7eec3e7441dc4067$export$1168ed9dbc71ddbd {
    run(fn) {
        if (this.active) try {
            this.on();
            return fn();
        } finally{
            this.off();
        }
    }
    on() {
        if (this.active) {
            $7eec3e7441dc4067$var$effectScopeStack.push(this);
            $7eec3e7441dc4067$var$activeEffectScope = this;
        }
    }
    off() {
        if (this.active) {
            $7eec3e7441dc4067$var$effectScopeStack.pop();
            $7eec3e7441dc4067$var$activeEffectScope = $7eec3e7441dc4067$var$effectScopeStack[$7eec3e7441dc4067$var$effectScopeStack.length - 1];
        }
    }
    stop(fromParent) {
        if (this.active) {
            this.effects.forEach((e)=>e.stop());
            this.cleanups.forEach((cleanup)=>cleanup());
            if (this.scopes) this.scopes.forEach((e)=>e.stop(true));
            // nested scope, dereference from parent to avoid memory leaks
            if (this.parent && !fromParent) {
                // optimized O(1) removal
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.active = false;
        }
    }
    constructor(detached = false){
        this.active = true;
        this.effects = [];
        this.cleanups = [];
        if (!detached && $7eec3e7441dc4067$var$activeEffectScope) {
            this.parent = $7eec3e7441dc4067$var$activeEffectScope;
            this.index = ($7eec3e7441dc4067$var$activeEffectScope.scopes || ($7eec3e7441dc4067$var$activeEffectScope.scopes = [])).push(this) - 1;
        }
    }
}
function $7eec3e7441dc4067$export$7056603ea81600be(detached) {
    return new $7eec3e7441dc4067$export$1168ed9dbc71ddbd(detached);
}
function $7eec3e7441dc4067$var$recordEffectScope(effect, scope) {
    scope = scope || $7eec3e7441dc4067$var$activeEffectScope;
    if (scope && scope.active) scope.effects.push(effect);
}
function $7eec3e7441dc4067$export$c7be4b0125a10cba() {
    return $7eec3e7441dc4067$var$activeEffectScope;
}
function $7eec3e7441dc4067$export$a780418acd4762da(fn) {
    if ($7eec3e7441dc4067$var$activeEffectScope) $7eec3e7441dc4067$var$activeEffectScope.cleanups.push(fn);
}
const $7eec3e7441dc4067$var$createDep = (effects)=>{
    const dep = new Set(effects);
    dep.w = 0;
    dep.n = 0;
    return dep;
};
const $7eec3e7441dc4067$var$wasTracked = (dep)=>(dep.w & $7eec3e7441dc4067$var$trackOpBit) > 0;
const $7eec3e7441dc4067$var$newTracked = (dep)=>(dep.n & $7eec3e7441dc4067$var$trackOpBit) > 0;
const $7eec3e7441dc4067$var$initDepMarkers = ({ deps: deps })=>{
    if (deps.length) for(let i = 0; i < deps.length; i++)deps[i].w |= $7eec3e7441dc4067$var$trackOpBit; // set was tracked
};
const $7eec3e7441dc4067$var$finalizeDepMarkers = (effect)=>{
    const { deps: deps } = effect;
    if (deps.length) {
        let ptr = 0;
        for(let i = 0; i < deps.length; i++){
            const dep = deps[i];
            if ($7eec3e7441dc4067$var$wasTracked(dep) && !$7eec3e7441dc4067$var$newTracked(dep)) dep.delete(effect);
            else deps[ptr++] = dep;
            // clear bits
            dep.w &= ~$7eec3e7441dc4067$var$trackOpBit;
            dep.n &= ~$7eec3e7441dc4067$var$trackOpBit;
        }
        deps.length = ptr;
    }
};
const $7eec3e7441dc4067$var$targetMap = new WeakMap();
// The number of effects currently being tracked recursively.
let $7eec3e7441dc4067$var$effectTrackDepth = 0;
let $7eec3e7441dc4067$var$trackOpBit = 1;
/**
 * The bitwise track markers support at most 30 levels of recursion.
 * This value is chosen to enable modern JS engines to use a SMI on all platforms.
 * When recursion depth is greater, fall back to using a full cleanup.
 */ const $7eec3e7441dc4067$var$maxMarkerBits = 30;
const $7eec3e7441dc4067$var$effectStack = [];
let $7eec3e7441dc4067$var$activeEffect;
const $7eec3e7441dc4067$export$3c41b1a4e06acc14 = Symbol("");
const $7eec3e7441dc4067$var$MAP_KEY_ITERATE_KEY = Symbol("");
class $7eec3e7441dc4067$export$28352bb4dd362521 {
    run() {
        if (!this.active) return this.fn();
        if (!$7eec3e7441dc4067$var$effectStack.length || !$7eec3e7441dc4067$var$effectStack.includes(this)) try {
            $7eec3e7441dc4067$var$effectStack.push($7eec3e7441dc4067$var$activeEffect = this);
            $7eec3e7441dc4067$export$1f8ffc6fd33b1d16();
            $7eec3e7441dc4067$var$trackOpBit = 1 << ++$7eec3e7441dc4067$var$effectTrackDepth;
            if ($7eec3e7441dc4067$var$effectTrackDepth <= $7eec3e7441dc4067$var$maxMarkerBits) $7eec3e7441dc4067$var$initDepMarkers(this);
            else $7eec3e7441dc4067$var$cleanupEffect(this);
            return this.fn();
        } finally{
            if ($7eec3e7441dc4067$var$effectTrackDepth <= $7eec3e7441dc4067$var$maxMarkerBits) $7eec3e7441dc4067$var$finalizeDepMarkers(this);
            $7eec3e7441dc4067$var$trackOpBit = 1 << --$7eec3e7441dc4067$var$effectTrackDepth;
            $7eec3e7441dc4067$export$c39176b1babaa8b8();
            $7eec3e7441dc4067$var$effectStack.pop();
            const n = $7eec3e7441dc4067$var$effectStack.length;
            $7eec3e7441dc4067$var$activeEffect = n > 0 ? $7eec3e7441dc4067$var$effectStack[n - 1] : undefined;
        }
    }
    stop() {
        if (this.active) {
            $7eec3e7441dc4067$var$cleanupEffect(this);
            if (this.onStop) this.onStop();
            this.active = false;
        }
    }
    constructor(fn, scheduler = null, scope){
        this.fn = fn;
        this.scheduler = scheduler;
        this.active = true;
        this.deps = [];
        $7eec3e7441dc4067$var$recordEffectScope(this, scope);
    }
}
function $7eec3e7441dc4067$var$cleanupEffect(effect) {
    const { deps: deps } = effect;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect);
        deps.length = 0;
    }
}
function $7eec3e7441dc4067$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect) fn = fn.effect.fn;
    const _effect = new $7eec3e7441dc4067$export$28352bb4dd362521(fn);
    if (options) {
        (0, $ciGHN.extend)(_effect, options);
        if (options.scope) $7eec3e7441dc4067$var$recordEffectScope(_effect, options.scope);
    }
    if (!options || !options.lazy) _effect.run();
    const runner = _effect.run.bind(_effect);
    runner.effect = _effect;
    return runner;
}
function $7eec3e7441dc4067$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $7eec3e7441dc4067$var$shouldTrack = true;
const $7eec3e7441dc4067$var$trackStack = [];
function $7eec3e7441dc4067$export$938a971395fef855() {
    $7eec3e7441dc4067$var$trackStack.push($7eec3e7441dc4067$var$shouldTrack);
    $7eec3e7441dc4067$var$shouldTrack = false;
}
function $7eec3e7441dc4067$export$1f8ffc6fd33b1d16() {
    $7eec3e7441dc4067$var$trackStack.push($7eec3e7441dc4067$var$shouldTrack);
    $7eec3e7441dc4067$var$shouldTrack = true;
}
function $7eec3e7441dc4067$export$c39176b1babaa8b8() {
    const last = $7eec3e7441dc4067$var$trackStack.pop();
    $7eec3e7441dc4067$var$shouldTrack = last === undefined ? true : last;
}
function $7eec3e7441dc4067$export$6b2a7d5132615086(target, type, key) {
    if (!$7eec3e7441dc4067$var$isTracking()) return;
    let depsMap = $7eec3e7441dc4067$var$targetMap.get(target);
    if (!depsMap) $7eec3e7441dc4067$var$targetMap.set(target, depsMap = new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = $7eec3e7441dc4067$var$createDep());
    const eventInfo = undefined;
    $7eec3e7441dc4067$var$trackEffects(dep, eventInfo);
}
function $7eec3e7441dc4067$var$isTracking() {
    return $7eec3e7441dc4067$var$shouldTrack && $7eec3e7441dc4067$var$activeEffect !== undefined;
}
function $7eec3e7441dc4067$var$trackEffects(dep, debuggerEventExtraInfo) {
    let shouldTrack = false;
    if ($7eec3e7441dc4067$var$effectTrackDepth <= $7eec3e7441dc4067$var$maxMarkerBits) {
        if (!$7eec3e7441dc4067$var$newTracked(dep)) {
            dep.n |= $7eec3e7441dc4067$var$trackOpBit; // set newly tracked
            shouldTrack = !$7eec3e7441dc4067$var$wasTracked(dep);
        }
    } else // Full cleanup mode.
    shouldTrack = !dep.has($7eec3e7441dc4067$var$activeEffect);
    if (shouldTrack) {
        dep.add($7eec3e7441dc4067$var$activeEffect);
        $7eec3e7441dc4067$var$activeEffect.deps.push(dep);
    }
}
function $7eec3e7441dc4067$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $7eec3e7441dc4067$var$targetMap.get(target);
    if (!depsMap) // never been tracked
    return;
    let deps = [];
    if (type === "clear" /* CLEAR */ ) // collection being cleared
    // trigger all effects for target
    deps = [
        ...depsMap.values()
    ];
    else if (key === "length" && (0, $ciGHN.isArray)(target)) depsMap.forEach((dep, key)=>{
        if (key === "length" || key >= newValue) deps.push(dep);
    });
    else {
        // schedule runs for SET | ADD | DELETE
        if (key !== void 0) deps.push(depsMap.get(key));
        // also run for iteration key on ADD | DELETE | Map.SET
        switch(type){
            case "add" /* ADD */ :
                if (!(0, $ciGHN.isArray)(target)) {
                    deps.push(depsMap.get($7eec3e7441dc4067$export$3c41b1a4e06acc14));
                    if ((0, $ciGHN.isMap)(target)) deps.push(depsMap.get($7eec3e7441dc4067$var$MAP_KEY_ITERATE_KEY));
                } else if ((0, $ciGHN.isIntegerKey)(key)) // new index added to array -> length changes
                deps.push(depsMap.get("length"));
                break;
            case "delete" /* DELETE */ :
                if (!(0, $ciGHN.isArray)(target)) {
                    deps.push(depsMap.get($7eec3e7441dc4067$export$3c41b1a4e06acc14));
                    if ((0, $ciGHN.isMap)(target)) deps.push(depsMap.get($7eec3e7441dc4067$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set" /* SET */ :
                if ((0, $ciGHN.isMap)(target)) deps.push(depsMap.get($7eec3e7441dc4067$export$3c41b1a4e06acc14));
                break;
        }
    }
    const eventInfo = undefined;
    if (deps.length === 1) {
        if (deps[0]) $7eec3e7441dc4067$var$triggerEffects(deps[0]);
    } else {
        const effects = [];
        for (const dep of deps)if (dep) effects.push(...dep);
        $7eec3e7441dc4067$var$triggerEffects($7eec3e7441dc4067$var$createDep(effects));
    }
}
function $7eec3e7441dc4067$var$triggerEffects(dep, debuggerEventExtraInfo) {
    // spread into array for stabilization
    for (const effect of (0, $ciGHN.isArray)(dep) ? dep : [
        ...dep
    ])if (effect !== $7eec3e7441dc4067$var$activeEffect || effect.allowRecurse) {
        if (effect.scheduler) effect.scheduler();
        else effect.run();
    }
}
const $7eec3e7441dc4067$var$isNonTrackableKeys = /*#__PURE__*/ (0, $ciGHN.makeMap)(`__proto__,__v_isRef,__isVue`);
const $7eec3e7441dc4067$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter((0, $ciGHN.isSymbol)));
const $7eec3e7441dc4067$var$get = /*#__PURE__*/ $7eec3e7441dc4067$var$createGetter();
const $7eec3e7441dc4067$var$shallowGet = /*#__PURE__*/ $7eec3e7441dc4067$var$createGetter(false, true);
const $7eec3e7441dc4067$var$readonlyGet = /*#__PURE__*/ $7eec3e7441dc4067$var$createGetter(true);
const $7eec3e7441dc4067$var$shallowReadonlyGet = /*#__PURE__*/ $7eec3e7441dc4067$var$createGetter(true, true);
const $7eec3e7441dc4067$var$arrayInstrumentations = /*#__PURE__*/ $7eec3e7441dc4067$var$createArrayInstrumentations();
function $7eec3e7441dc4067$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $7eec3e7441dc4067$export$ab18938b9fc5f28e(this);
            for(let i = 0, l = this.length; i < l; i++)$7eec3e7441dc4067$export$6b2a7d5132615086(arr, "get" /* GET */ , i + "");
            // we run the method using the original args first (which may be reactive)
            const res = arr[key](...args);
            if (res === -1 || res === false) // if that didn't work, run it again using raw values.
            return arr[key](...args.map($7eec3e7441dc4067$export$ab18938b9fc5f28e));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $7eec3e7441dc4067$export$938a971395fef855();
            const res = $7eec3e7441dc4067$export$ab18938b9fc5f28e(this)[key].apply(this, args);
            $7eec3e7441dc4067$export$c39176b1babaa8b8();
            return res;
        };
    });
    return instrumentations;
}
function $7eec3e7441dc4067$var$createGetter(isReadonly = false, shallow = false) {
    return function get(target, key, receiver) {
        if (key === "__v_isReactive" /* IS_REACTIVE */ ) return !isReadonly;
        else if (key === "__v_isReadonly" /* IS_READONLY */ ) return isReadonly;
        else if (key === "__v_isShallow" /* IS_SHALLOW */ ) return shallow;
        else if (key === "__v_raw" /* RAW */  && receiver === (isReadonly ? shallow ? $7eec3e7441dc4067$var$shallowReadonlyMap : $7eec3e7441dc4067$var$readonlyMap : shallow ? $7eec3e7441dc4067$var$shallowReactiveMap : $7eec3e7441dc4067$var$reactiveMap).get(target)) return target;
        const targetIsArray = (0, $ciGHN.isArray)(target);
        if (!isReadonly && targetIsArray && (0, $ciGHN.hasOwn)($7eec3e7441dc4067$var$arrayInstrumentations, key)) return Reflect.get($7eec3e7441dc4067$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ((0, $ciGHN.isSymbol)(key) ? $7eec3e7441dc4067$var$builtInSymbols.has(key) : $7eec3e7441dc4067$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $7eec3e7441dc4067$export$6b2a7d5132615086(target, "get" /* GET */ , key);
        if (shallow) return res;
        if ($7eec3e7441dc4067$export$4f9f5282de18fc69(res)) {
            // ref unwrapping - does not apply for Array + integer key.
            const shouldUnwrap = !targetIsArray || !(0, $ciGHN.isIntegerKey)(key);
            return shouldUnwrap ? res.value : res;
        }
        if ((0, $ciGHN.isObject)(res)) // Convert returned value into a proxy as well. we do the isObject check
        // here to avoid invalid value warning. Also need to lazy access readonly
        // and reactive here to avoid circular dependency.
        return isReadonly ? $7eec3e7441dc4067$export$6ec456bd5b7b3c51(res) : $7eec3e7441dc4067$export$90a44edba14e47be(res);
        return res;
    };
}
const $7eec3e7441dc4067$var$set = /*#__PURE__*/ $7eec3e7441dc4067$var$createSetter();
const $7eec3e7441dc4067$var$shallowSet = /*#__PURE__*/ $7eec3e7441dc4067$var$createSetter(true);
function $7eec3e7441dc4067$var$createSetter(shallow = false) {
    return function set(target, key, value, receiver) {
        let oldValue = target[key];
        if ($7eec3e7441dc4067$export$92d09b48637741e7(oldValue) && $7eec3e7441dc4067$export$4f9f5282de18fc69(oldValue) && !$7eec3e7441dc4067$export$4f9f5282de18fc69(value)) return false;
        if (!shallow && !$7eec3e7441dc4067$export$92d09b48637741e7(value)) {
            if (!$7eec3e7441dc4067$export$7f3fe6025abfa26e(value)) {
                value = $7eec3e7441dc4067$export$ab18938b9fc5f28e(value);
                oldValue = $7eec3e7441dc4067$export$ab18938b9fc5f28e(oldValue);
            }
            if (!(0, $ciGHN.isArray)(target) && $7eec3e7441dc4067$export$4f9f5282de18fc69(oldValue) && !$7eec3e7441dc4067$export$4f9f5282de18fc69(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = (0, $ciGHN.isArray)(target) && (0, $ciGHN.isIntegerKey)(key) ? Number(key) < target.length : (0, $ciGHN.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, receiver);
        // don't trigger if target is something up in the prototype chain of original
        if (target === $7eec3e7441dc4067$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $7eec3e7441dc4067$export$e614dc9140f7ae71(target, "add" /* ADD */ , key, value);
            else if ((0, $ciGHN.hasChanged)(value, oldValue)) $7eec3e7441dc4067$export$e614dc9140f7ae71(target, "set" /* SET */ , key, value, oldValue);
        }
        return result;
    };
}
function $7eec3e7441dc4067$var$deleteProperty(target, key) {
    const hadKey = (0, $ciGHN.hasOwn)(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $7eec3e7441dc4067$export$e614dc9140f7ae71(target, "delete" /* DELETE */ , key, undefined, oldValue);
    return result;
}
function $7eec3e7441dc4067$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!(0, $ciGHN.isSymbol)(key) || !$7eec3e7441dc4067$var$builtInSymbols.has(key)) $7eec3e7441dc4067$export$6b2a7d5132615086(target, "has" /* HAS */ , key);
    return result;
}
function $7eec3e7441dc4067$var$ownKeys(target) {
    $7eec3e7441dc4067$export$6b2a7d5132615086(target, "iterate" /* ITERATE */ , (0, $ciGHN.isArray)(target) ? "length" : $7eec3e7441dc4067$export$3c41b1a4e06acc14);
    return Reflect.ownKeys(target);
}
const $7eec3e7441dc4067$var$mutableHandlers = {
    get: $7eec3e7441dc4067$var$get,
    set: $7eec3e7441dc4067$var$set,
    deleteProperty: $7eec3e7441dc4067$var$deleteProperty,
    has: $7eec3e7441dc4067$var$has,
    ownKeys: $7eec3e7441dc4067$var$ownKeys
};
const $7eec3e7441dc4067$var$readonlyHandlers = {
    get: $7eec3e7441dc4067$var$readonlyGet,
    set (target, key) {
        return true;
    },
    deleteProperty (target, key) {
        return true;
    }
};
const $7eec3e7441dc4067$var$shallowReactiveHandlers = /*#__PURE__*/ (0, $ciGHN.extend)({}, $7eec3e7441dc4067$var$mutableHandlers, {
    get: $7eec3e7441dc4067$var$shallowGet,
    set: $7eec3e7441dc4067$var$shallowSet
});
// Props handlers are special in the sense that it should not unwrap top-level
// refs (in order to allow refs to be explicitly passed down), but should
// retain the reactivity of the normal readonly object.
const $7eec3e7441dc4067$var$shallowReadonlyHandlers = /*#__PURE__*/ (0, $ciGHN.extend)({}, $7eec3e7441dc4067$var$readonlyHandlers, {
    get: $7eec3e7441dc4067$var$shallowReadonlyGet
});
const $7eec3e7441dc4067$var$toShallow = (value)=>value;
const $7eec3e7441dc4067$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $7eec3e7441dc4067$var$get$1(target, key, isReadonly = false, isShallow = false) {
    // #1772: readonly(reactive(Map)) should return readonly + reactive version
    // of the value
    target = target["__v_raw" /* RAW */ ];
    const rawTarget = $7eec3e7441dc4067$export$ab18938b9fc5f28e(target);
    const rawKey = $7eec3e7441dc4067$export$ab18938b9fc5f28e(key);
    if (key !== rawKey) !isReadonly && $7eec3e7441dc4067$export$6b2a7d5132615086(rawTarget, "get" /* GET */ , key);
    !isReadonly && $7eec3e7441dc4067$export$6b2a7d5132615086(rawTarget, "get" /* GET */ , rawKey);
    const { has: has } = $7eec3e7441dc4067$var$getProto(rawTarget);
    const wrap = isShallow ? $7eec3e7441dc4067$var$toShallow : isReadonly ? $7eec3e7441dc4067$var$toReadonly : $7eec3e7441dc4067$var$toReactive;
    if (has.call(rawTarget, key)) return wrap(target.get(key));
    else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) // #3602 readonly(reactive(Map))
    // ensure that the nested reactive `Map` can do tracking for itself
    target.get(key);
}
function $7eec3e7441dc4067$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw" /* RAW */ ];
    const rawTarget = $7eec3e7441dc4067$export$ab18938b9fc5f28e(target);
    const rawKey = $7eec3e7441dc4067$export$ab18938b9fc5f28e(key);
    if (key !== rawKey) !isReadonly && $7eec3e7441dc4067$export$6b2a7d5132615086(rawTarget, "has" /* HAS */ , key);
    !isReadonly && $7eec3e7441dc4067$export$6b2a7d5132615086(rawTarget, "has" /* HAS */ , rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $7eec3e7441dc4067$var$size(target, isReadonly = false) {
    target = target["__v_raw" /* RAW */ ];
    !isReadonly && $7eec3e7441dc4067$export$6b2a7d5132615086($7eec3e7441dc4067$export$ab18938b9fc5f28e(target), "iterate" /* ITERATE */ , $7eec3e7441dc4067$export$3c41b1a4e06acc14);
    return Reflect.get(target, "size", target);
}
function $7eec3e7441dc4067$var$add(value) {
    value = $7eec3e7441dc4067$export$ab18938b9fc5f28e(value);
    const target = $7eec3e7441dc4067$export$ab18938b9fc5f28e(this);
    const proto = $7eec3e7441dc4067$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $7eec3e7441dc4067$export$e614dc9140f7ae71(target, "add" /* ADD */ , value, value);
    }
    return this;
}
function $7eec3e7441dc4067$var$set$1(key, value) {
    value = $7eec3e7441dc4067$export$ab18938b9fc5f28e(value);
    const target = $7eec3e7441dc4067$export$ab18938b9fc5f28e(this);
    const { has: has, get: get } = $7eec3e7441dc4067$var$getProto(target);
    let hadKey = has.call(target, key);
    if (!hadKey) {
        key = $7eec3e7441dc4067$export$ab18938b9fc5f28e(key);
        hadKey = has.call(target, key);
    }
    const oldValue = get.call(target, key);
    target.set(key, value);
    if (!hadKey) $7eec3e7441dc4067$export$e614dc9140f7ae71(target, "add" /* ADD */ , key, value);
    else if ((0, $ciGHN.hasChanged)(value, oldValue)) $7eec3e7441dc4067$export$e614dc9140f7ae71(target, "set" /* SET */ , key, value, oldValue);
    return this;
}
function $7eec3e7441dc4067$var$deleteEntry(key) {
    const target = $7eec3e7441dc4067$export$ab18938b9fc5f28e(this);
    const { has: has, get: get } = $7eec3e7441dc4067$var$getProto(target);
    let hadKey = has.call(target, key);
    if (!hadKey) {
        key = $7eec3e7441dc4067$export$ab18938b9fc5f28e(key);
        hadKey = has.call(target, key);
    }
    const oldValue = get ? get.call(target, key) : undefined;
    // forward the operation before queueing reactions
    const result = target.delete(key);
    if (hadKey) $7eec3e7441dc4067$export$e614dc9140f7ae71(target, "delete" /* DELETE */ , key, undefined, oldValue);
    return result;
}
function $7eec3e7441dc4067$var$clear() {
    const target = $7eec3e7441dc4067$export$ab18938b9fc5f28e(this);
    const hadItems = target.size !== 0;
    const oldTarget = undefined;
    // forward the operation before queueing reactions
    const result = target.clear();
    if (hadItems) $7eec3e7441dc4067$export$e614dc9140f7ae71(target, "clear" /* CLEAR */ , undefined, undefined, oldTarget);
    return result;
}
function $7eec3e7441dc4067$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw" /* RAW */ ];
        const rawTarget = $7eec3e7441dc4067$export$ab18938b9fc5f28e(target);
        const wrap = isShallow ? $7eec3e7441dc4067$var$toShallow : isReadonly ? $7eec3e7441dc4067$var$toReadonly : $7eec3e7441dc4067$var$toReactive;
        !isReadonly && $7eec3e7441dc4067$export$6b2a7d5132615086(rawTarget, "iterate" /* ITERATE */ , $7eec3e7441dc4067$export$3c41b1a4e06acc14);
        return target.forEach((value, key)=>{
            // important: make sure the callback is
            // 1. invoked with the reactive map as `this` and 3rd arg
            // 2. the value received should be a corresponding reactive/readonly.
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $7eec3e7441dc4067$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw" /* RAW */ ];
        const rawTarget = $7eec3e7441dc4067$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $ciGHN.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $7eec3e7441dc4067$var$toShallow : isReadonly ? $7eec3e7441dc4067$var$toReadonly : $7eec3e7441dc4067$var$toReactive;
        !isReadonly && $7eec3e7441dc4067$export$6b2a7d5132615086(rawTarget, "iterate" /* ITERATE */ , isKeyOnly ? $7eec3e7441dc4067$var$MAP_KEY_ITERATE_KEY : $7eec3e7441dc4067$export$3c41b1a4e06acc14);
        // return a wrapped iterator which returns observed versions of the
        // values emitted from the real iterator
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $7eec3e7441dc4067$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" /* DELETE */  ? false : this;
    };
}
function $7eec3e7441dc4067$var$createInstrumentations() {
    const mutableInstrumentations = {
        get (key) {
            return $7eec3e7441dc4067$var$get$1(this, key);
        },
        get size () {
            return $7eec3e7441dc4067$var$size(this);
        },
        has: $7eec3e7441dc4067$var$has$1,
        add: $7eec3e7441dc4067$var$add,
        set: $7eec3e7441dc4067$var$set$1,
        delete: $7eec3e7441dc4067$var$deleteEntry,
        clear: $7eec3e7441dc4067$var$clear,
        forEach: $7eec3e7441dc4067$var$createForEach(false, false)
    };
    const shallowInstrumentations = {
        get (key) {
            return $7eec3e7441dc4067$var$get$1(this, key, false, true);
        },
        get size () {
            return $7eec3e7441dc4067$var$size(this);
        },
        has: $7eec3e7441dc4067$var$has$1,
        add: $7eec3e7441dc4067$var$add,
        set: $7eec3e7441dc4067$var$set$1,
        delete: $7eec3e7441dc4067$var$deleteEntry,
        clear: $7eec3e7441dc4067$var$clear,
        forEach: $7eec3e7441dc4067$var$createForEach(false, true)
    };
    const readonlyInstrumentations = {
        get (key) {
            return $7eec3e7441dc4067$var$get$1(this, key, true);
        },
        get size () {
            return $7eec3e7441dc4067$var$size(this, true);
        },
        has (key) {
            return $7eec3e7441dc4067$var$has$1.call(this, key, true);
        },
        add: $7eec3e7441dc4067$var$createReadonlyMethod("add" /* ADD */ ),
        set: $7eec3e7441dc4067$var$createReadonlyMethod("set" /* SET */ ),
        delete: $7eec3e7441dc4067$var$createReadonlyMethod("delete" /* DELETE */ ),
        clear: $7eec3e7441dc4067$var$createReadonlyMethod("clear" /* CLEAR */ ),
        forEach: $7eec3e7441dc4067$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations = {
        get (key) {
            return $7eec3e7441dc4067$var$get$1(this, key, true, true);
        },
        get size () {
            return $7eec3e7441dc4067$var$size(this, true);
        },
        has (key) {
            return $7eec3e7441dc4067$var$has$1.call(this, key, true);
        },
        add: $7eec3e7441dc4067$var$createReadonlyMethod("add" /* ADD */ ),
        set: $7eec3e7441dc4067$var$createReadonlyMethod("set" /* SET */ ),
        delete: $7eec3e7441dc4067$var$createReadonlyMethod("delete" /* DELETE */ ),
        clear: $7eec3e7441dc4067$var$createReadonlyMethod("clear" /* CLEAR */ ),
        forEach: $7eec3e7441dc4067$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations[method] = $7eec3e7441dc4067$var$createIterableMethod(method, false, false);
        readonlyInstrumentations[method] = $7eec3e7441dc4067$var$createIterableMethod(method, true, false);
        shallowInstrumentations[method] = $7eec3e7441dc4067$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations[method] = $7eec3e7441dc4067$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations,
        readonlyInstrumentations,
        shallowInstrumentations,
        shallowReadonlyInstrumentations
    ];
}
const [$7eec3e7441dc4067$var$mutableInstrumentations, $7eec3e7441dc4067$var$readonlyInstrumentations, $7eec3e7441dc4067$var$shallowInstrumentations, $7eec3e7441dc4067$var$shallowReadonlyInstrumentations] = /* #__PURE__*/ $7eec3e7441dc4067$var$createInstrumentations();
function $7eec3e7441dc4067$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $7eec3e7441dc4067$var$shallowReadonlyInstrumentations : $7eec3e7441dc4067$var$shallowInstrumentations : isReadonly ? $7eec3e7441dc4067$var$readonlyInstrumentations : $7eec3e7441dc4067$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive" /* IS_REACTIVE */ ) return !isReadonly;
        else if (key === "__v_isReadonly" /* IS_READONLY */ ) return isReadonly;
        else if (key === "__v_raw" /* RAW */ ) return target;
        return Reflect.get((0, $ciGHN.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $7eec3e7441dc4067$var$mutableCollectionHandlers = {
    get: /*#__PURE__*/ $7eec3e7441dc4067$var$createInstrumentationGetter(false, false)
};
const $7eec3e7441dc4067$var$shallowCollectionHandlers = {
    get: /*#__PURE__*/ $7eec3e7441dc4067$var$createInstrumentationGetter(false, true)
};
const $7eec3e7441dc4067$var$readonlyCollectionHandlers = {
    get: /*#__PURE__*/ $7eec3e7441dc4067$var$createInstrumentationGetter(true, false)
};
const $7eec3e7441dc4067$var$shallowReadonlyCollectionHandlers = {
    get: /*#__PURE__*/ $7eec3e7441dc4067$var$createInstrumentationGetter(true, true)
};
function $7eec3e7441dc4067$var$checkIdentityKeys(target, has, key) {
    const rawKey = $7eec3e7441dc4067$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = (0, $ciGHN.toRawType)(target);
        console.warn(`Reactive ${type} contains both the raw and reactive ` + `versions of the same object${type === `Map` ? ` as keys` : ``}, ` + `which can lead to inconsistencies. ` + `Avoid differentiating between the raw and reactive versions ` + `of an object and only use the reactive version if possible.`);
    }
}
const $7eec3e7441dc4067$var$reactiveMap = new WeakMap();
const $7eec3e7441dc4067$var$shallowReactiveMap = new WeakMap();
const $7eec3e7441dc4067$var$readonlyMap = new WeakMap();
const $7eec3e7441dc4067$var$shallowReadonlyMap = new WeakMap();
function $7eec3e7441dc4067$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $7eec3e7441dc4067$var$getTargetType(value) {
    return value["__v_skip" /* SKIP */ ] || !Object.isExtensible(value) ? 0 /* INVALID */  : $7eec3e7441dc4067$var$targetTypeMap((0, $ciGHN.toRawType)(value));
}
function $7eec3e7441dc4067$export$90a44edba14e47be(target) {
    // if trying to observe a readonly proxy, return the readonly version.
    if ($7eec3e7441dc4067$export$92d09b48637741e7(target)) return target;
    return $7eec3e7441dc4067$var$createReactiveObject(target, false, $7eec3e7441dc4067$var$mutableHandlers, $7eec3e7441dc4067$var$mutableCollectionHandlers, $7eec3e7441dc4067$var$reactiveMap);
}
/**
 * Return a shallowly-reactive copy of the original object, where only the root
 * level properties are reactive. It also does not auto-unwrap refs (even at the
 * root level).
 */ function $7eec3e7441dc4067$export$8d81cefd22d22260(target) {
    return $7eec3e7441dc4067$var$createReactiveObject(target, false, $7eec3e7441dc4067$var$shallowReactiveHandlers, $7eec3e7441dc4067$var$shallowCollectionHandlers, $7eec3e7441dc4067$var$shallowReactiveMap);
}
/**
 * Creates a readonly copy of the original object. Note the returned copy is not
 * made reactive, but `readonly` can be called on an already reactive object.
 */ function $7eec3e7441dc4067$export$6ec456bd5b7b3c51(target) {
    return $7eec3e7441dc4067$var$createReactiveObject(target, true, $7eec3e7441dc4067$var$readonlyHandlers, $7eec3e7441dc4067$var$readonlyCollectionHandlers, $7eec3e7441dc4067$var$readonlyMap);
}
/**
 * Returns a reactive-copy of the original object, where only the root level
 * properties are readonly, and does NOT unwrap refs nor recursively convert
 * returned properties.
 * This is used for creating the props proxy object for stateful components.
 */ function $7eec3e7441dc4067$export$7c4b5f2b50f09f6b(target) {
    return $7eec3e7441dc4067$var$createReactiveObject(target, true, $7eec3e7441dc4067$var$shallowReadonlyHandlers, $7eec3e7441dc4067$var$shallowReadonlyCollectionHandlers, $7eec3e7441dc4067$var$shallowReadonlyMap);
}
function $7eec3e7441dc4067$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $ciGHN.isObject)(target)) return target;
    // target is already a Proxy, return it.
    // exception: calling readonly() on a reactive object
    if (target["__v_raw" /* RAW */ ] && !(isReadonly && target["__v_isReactive" /* IS_REACTIVE */ ])) return target;
    // target already has corresponding Proxy
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    // only a whitelist of value types can be observed.
    const targetType = $7eec3e7441dc4067$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $7eec3e7441dc4067$export$352205f445242f02(value) {
    if ($7eec3e7441dc4067$export$92d09b48637741e7(value)) return $7eec3e7441dc4067$export$352205f445242f02(value["__v_raw" /* RAW */ ]);
    return !!(value && value["__v_isReactive" /* IS_REACTIVE */ ]);
}
function $7eec3e7441dc4067$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly" /* IS_READONLY */ ]);
}
function $7eec3e7441dc4067$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow" /* IS_SHALLOW */ ]);
}
function $7eec3e7441dc4067$export$5f3ca29d057519b3(value) {
    return $7eec3e7441dc4067$export$352205f445242f02(value) || $7eec3e7441dc4067$export$92d09b48637741e7(value);
}
function $7eec3e7441dc4067$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw" /* RAW */ ];
    return raw ? $7eec3e7441dc4067$export$ab18938b9fc5f28e(raw) : observed;
}
function $7eec3e7441dc4067$export$995ab8b13ad7a9d0(value) {
    (0, $ciGHN.def)(value, "__v_skip" /* SKIP */ , true);
    return value;
}
const $7eec3e7441dc4067$var$toReactive = (value)=>(0, $ciGHN.isObject)(value) ? $7eec3e7441dc4067$export$90a44edba14e47be(value) : value;
const $7eec3e7441dc4067$var$toReadonly = (value)=>(0, $ciGHN.isObject)(value) ? $7eec3e7441dc4067$export$6ec456bd5b7b3c51(value) : value;
function $7eec3e7441dc4067$var$trackRefValue(ref) {
    if ($7eec3e7441dc4067$var$isTracking()) {
        ref = $7eec3e7441dc4067$export$ab18938b9fc5f28e(ref);
        if (!ref.dep) ref.dep = $7eec3e7441dc4067$var$createDep();
        $7eec3e7441dc4067$var$trackEffects(ref.dep);
    }
}
function $7eec3e7441dc4067$var$triggerRefValue(ref, newVal) {
    ref = $7eec3e7441dc4067$export$ab18938b9fc5f28e(ref);
    if (ref.dep) $7eec3e7441dc4067$var$triggerEffects(ref.dep);
}
function $7eec3e7441dc4067$export$4f9f5282de18fc69(r) {
    return Boolean(r && r.__v_isRef === true);
}
function $7eec3e7441dc4067$export$eff4d24c3ff7876e(value) {
    return $7eec3e7441dc4067$var$createRef(value, false);
}
function $7eec3e7441dc4067$export$9b7bc5fe3b17c8b3(value) {
    return $7eec3e7441dc4067$var$createRef(value, true);
}
function $7eec3e7441dc4067$var$createRef(rawValue, shallow) {
    if ($7eec3e7441dc4067$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $7eec3e7441dc4067$var$RefImpl(rawValue, shallow);
}
class $7eec3e7441dc4067$var$RefImpl {
    get value() {
        $7eec3e7441dc4067$var$trackRefValue(this);
        return this._value;
    }
    set value(newVal) {
        newVal = this.__v_isShallow ? newVal : $7eec3e7441dc4067$export$ab18938b9fc5f28e(newVal);
        if ((0, $ciGHN.hasChanged)(newVal, this._rawValue)) {
            this._rawValue = newVal;
            this._value = this.__v_isShallow ? newVal : $7eec3e7441dc4067$var$toReactive(newVal);
            $7eec3e7441dc4067$var$triggerRefValue(this, newVal);
        }
    }
    constructor(value, __v_isShallow){
        this.__v_isShallow = __v_isShallow;
        this.dep = undefined;
        this.__v_isRef = true;
        this._rawValue = __v_isShallow ? value : $7eec3e7441dc4067$export$ab18938b9fc5f28e(value);
        this._value = __v_isShallow ? value : $7eec3e7441dc4067$var$toReactive(value);
    }
}
function $7eec3e7441dc4067$export$f402f86588575ccc(ref) {
    $7eec3e7441dc4067$var$triggerRefValue(ref, void 0);
}
function $7eec3e7441dc4067$export$a239a76781616204(ref) {
    return $7eec3e7441dc4067$export$4f9f5282de18fc69(ref) ? ref.value : ref;
}
const $7eec3e7441dc4067$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>$7eec3e7441dc4067$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if ($7eec3e7441dc4067$export$4f9f5282de18fc69(oldValue) && !$7eec3e7441dc4067$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $7eec3e7441dc4067$export$f353fd1b97db3fa0(objectWithRefs) {
    return $7eec3e7441dc4067$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $7eec3e7441dc4067$var$shallowUnwrapHandlers);
}
class $7eec3e7441dc4067$var$CustomRefImpl {
    get value() {
        return this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
    constructor(factory){
        this.dep = undefined;
        this.__v_isRef = true;
        const { get: get, set: set } = factory(()=>$7eec3e7441dc4067$var$trackRefValue(this), ()=>$7eec3e7441dc4067$var$triggerRefValue(this));
        this._get = get;
        this._set = set;
    }
}
function $7eec3e7441dc4067$export$a20c2dd6199824cb(factory) {
    return new $7eec3e7441dc4067$var$CustomRefImpl(factory);
}
function $7eec3e7441dc4067$export$2e9533675e5e70e0(object) {
    const ret = (0, $ciGHN.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $7eec3e7441dc4067$export$1f60508e4f47b4b7(object, key);
    return ret;
}
class $7eec3e7441dc4067$var$ObjectRefImpl {
    get value() {
        const val = this._object[this._key];
        return val === undefined ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this.__v_isRef = true;
    }
}
function $7eec3e7441dc4067$export$1f60508e4f47b4b7(object, key, defaultValue) {
    const val = object[key];
    return $7eec3e7441dc4067$export$4f9f5282de18fc69(val) ? val : new $7eec3e7441dc4067$var$ObjectRefImpl(object, key, defaultValue);
}
class $7eec3e7441dc4067$var$ComputedRefImpl {
    get value() {
        // the computed ref may get wrapped by other proxies e.g. readonly() #3376
        const self = $7eec3e7441dc4067$export$ab18938b9fc5f28e(this);
        $7eec3e7441dc4067$var$trackRefValue(self);
        if (self._dirty || !self._cacheable) {
            self._dirty = false;
            self._value = self.effect.run();
        }
        return self._value;
    }
    set value(newValue) {
        this._setter(newValue);
    }
    constructor(getter, _setter, isReadonly, isSSR){
        this._setter = _setter;
        this.dep = undefined;
        this.__v_isRef = true;
        this._dirty = true;
        this.effect = new $7eec3e7441dc4067$export$28352bb4dd362521(getter, ()=>{
            if (!this._dirty) {
                this._dirty = true;
                $7eec3e7441dc4067$var$triggerRefValue(this);
            }
        });
        this.effect.computed = this;
        this.effect.active = this._cacheable = !isSSR;
        this["__v_isReadonly" /* IS_READONLY */ ] = isReadonly;
    }
}
function $7eec3e7441dc4067$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    const onlyGetter = (0, $ciGHN.isFunction)(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter = (0, $ciGHN.NOOP);
    } else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $7eec3e7441dc4067$var$ComputedRefImpl(getter, setter, onlyGetter || !setter, isSSR);
    return cRef;
}
var $7eec3e7441dc4067$var$_a;
const $7eec3e7441dc4067$var$tick = Promise.resolve();
const $7eec3e7441dc4067$var$queue = [];
let $7eec3e7441dc4067$var$queued = false;
const $7eec3e7441dc4067$var$scheduler = (fn)=>{
    $7eec3e7441dc4067$var$queue.push(fn);
    if (!$7eec3e7441dc4067$var$queued) {
        $7eec3e7441dc4067$var$queued = true;
        $7eec3e7441dc4067$var$tick.then($7eec3e7441dc4067$var$flush);
    }
};
const $7eec3e7441dc4067$var$flush = ()=>{
    for(let i = 0; i < $7eec3e7441dc4067$var$queue.length; i++)$7eec3e7441dc4067$var$queue[i]();
    $7eec3e7441dc4067$var$queue.length = 0;
    $7eec3e7441dc4067$var$queued = false;
};
class $7eec3e7441dc4067$var$DeferredComputedRefImpl {
    _get() {
        if (this._dirty) {
            this._dirty = false;
            return this._value = this.effect.run();
        }
        return this._value;
    }
    get value() {
        $7eec3e7441dc4067$var$trackRefValue(this);
        // the computed ref may get wrapped by other proxies e.g. readonly() #3376
        return $7eec3e7441dc4067$export$ab18938b9fc5f28e(this)._get();
    }
    constructor(getter){
        this.dep = undefined;
        this._dirty = true;
        this.__v_isRef = true;
        this[$7eec3e7441dc4067$var$_a] = true;
        let compareTarget;
        let hasCompareTarget = false;
        let scheduled = false;
        this.effect = new $7eec3e7441dc4067$export$28352bb4dd362521(getter, (computedTrigger)=>{
            if (this.dep) {
                if (computedTrigger) {
                    compareTarget = this._value;
                    hasCompareTarget = true;
                } else if (!scheduled) {
                    const valueToCompare = hasCompareTarget ? compareTarget : this._value;
                    scheduled = true;
                    hasCompareTarget = false;
                    $7eec3e7441dc4067$var$scheduler(()=>{
                        if (this.effect.active && this._get() !== valueToCompare) $7eec3e7441dc4067$var$triggerRefValue(this);
                        scheduled = false;
                    });
                }
                // chained upstream computeds are notified synchronously to ensure
                // value invalidation in case of sync access; normal effects are
                // deferred to be triggered in scheduler.
                for (const e of this.dep)if (e.computed instanceof $7eec3e7441dc4067$var$DeferredComputedRefImpl) e.scheduler(true);
            }
            this._dirty = true;
        });
        this.effect.computed = this;
    }
}
$7eec3e7441dc4067$var$_a = "__v_isReadonly" /* IS_READONLY */ ;
function $7eec3e7441dc4067$export$483264c4ec4c46ce(getter) {
    return new $7eec3e7441dc4067$var$DeferredComputedRefImpl(getter);
}

});
parcelRegister("ciGHN", function(module, exports) {

$parcel$export(module.exports, "makeMap", function () { return $8f484ade10ebcd10$export$b41394a5437791c8; });
$parcel$export(module.exports, "isGloballyWhitelisted", function () { return $8f484ade10ebcd10$export$d6571a1911e4f27e; });
$parcel$export(module.exports, "isSpecialBooleanAttr", function () { return $8f484ade10ebcd10$export$d186f5eb2e810715; });
$parcel$export(module.exports, "includeBooleanAttr", function () { return $8f484ade10ebcd10$export$e3f3cdb1390d56ce; });
$parcel$export(module.exports, "normalizeStyle", function () { return $8f484ade10ebcd10$export$8756898546458274; });
$parcel$export(module.exports, "isArray", function () { return $8f484ade10ebcd10$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isString", function () { return $8f484ade10ebcd10$export$844ec244b1367d54; });
$parcel$export(module.exports, "isObject", function () { return $8f484ade10ebcd10$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "hyphenate", function () { return $8f484ade10ebcd10$export$6e6a0a3676c4b8bb; });
$parcel$export(module.exports, "normalizeClass", function () { return $8f484ade10ebcd10$export$4f7022d2d68e2c5a; });
$parcel$export(module.exports, "isHTMLTag", function () { return $8f484ade10ebcd10$export$1ccf854a0984f890; });
$parcel$export(module.exports, "isSVGTag", function () { return $8f484ade10ebcd10$export$6328ce7565ea1049; });
$parcel$export(module.exports, "looseEqual", function () { return $8f484ade10ebcd10$export$ae8015769846262c; });
$parcel$export(module.exports, "looseIndexOf", function () { return $8f484ade10ebcd10$export$42912a80cedb8bd4; });
$parcel$export(module.exports, "toDisplayString", function () { return $8f484ade10ebcd10$export$b5b1545233b45293; });
$parcel$export(module.exports, "isFunction", function () { return $8f484ade10ebcd10$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "isMap", function () { return $8f484ade10ebcd10$export$5c90113a285f2241; });
$parcel$export(module.exports, "isSet", function () { return $8f484ade10ebcd10$export$6750766a7c7ec627; });
$parcel$export(module.exports, "isPlainObject", function () { return $8f484ade10ebcd10$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "EMPTY_OBJ", function () { return $8f484ade10ebcd10$export$cf583d23ab39677c; });
$parcel$export(module.exports, "EMPTY_ARR", function () { return $8f484ade10ebcd10$export$6bd8558f433f1cc1; });
$parcel$export(module.exports, "NOOP", function () { return $8f484ade10ebcd10$export$5702a91a6f42969f; });
$parcel$export(module.exports, "NO", function () { return $8f484ade10ebcd10$export$c01351c0af048e39; });
$parcel$export(module.exports, "isOn", function () { return $8f484ade10ebcd10$export$1a2d97de39ecbb75; });
$parcel$export(module.exports, "isModelListener", function () { return $8f484ade10ebcd10$export$793aa5469768d691; });
$parcel$export(module.exports, "extend", function () { return $8f484ade10ebcd10$export$8b58be045bf06082; });
$parcel$export(module.exports, "remove", function () { return $8f484ade10ebcd10$export$cd7f480d6b8286c3; });
$parcel$export(module.exports, "hasOwn", function () { return $8f484ade10ebcd10$export$b5a638e9b3fff9f3; });
$parcel$export(module.exports, "isSymbol", function () { return $8f484ade10ebcd10$export$a244864fd9645c7f; });
$parcel$export(module.exports, "isPromise", function () { return $8f484ade10ebcd10$export$4369c812aac99591; });
$parcel$export(module.exports, "toRawType", function () { return $8f484ade10ebcd10$export$5ad0a3c360b8fbb5; });
$parcel$export(module.exports, "isIntegerKey", function () { return $8f484ade10ebcd10$export$e2a2b93446ec9fe; });
$parcel$export(module.exports, "isReservedProp", function () { return $8f484ade10ebcd10$export$bf7d3c0236f0aa85; });
$parcel$export(module.exports, "camelize", function () { return $8f484ade10ebcd10$export$161d051f5dd25de7; });
$parcel$export(module.exports, "capitalize", function () { return $8f484ade10ebcd10$export$9a00dee1beb8f576; });
$parcel$export(module.exports, "toHandlerKey", function () { return $8f484ade10ebcd10$export$8c022799eeaaefcd; });
$parcel$export(module.exports, "hasChanged", function () { return $8f484ade10ebcd10$export$f619eb8b89076d23; });
$parcel$export(module.exports, "invokeArrayFns", function () { return $8f484ade10ebcd10$export$39951422d618a9d3; });
$parcel$export(module.exports, "def", function () { return $8f484ade10ebcd10$export$8afb76124cf08683; });
$parcel$export(module.exports, "toNumber", function () { return $8f484ade10ebcd10$export$a0a81dc3380ce7d3; });
$parcel$export(module.exports, "getGlobalThis", function () { return $8f484ade10ebcd10$export$ff5f2eeb11fc7e14; });
/**
 * Make a map and return a function for checking if a key
 * is in that map.
 * IMPORTANT: all calls of this function must be prefixed with
 * \/\*#\_\_PURE\_\_\*\/
 * So that rollup can tree-shake them if necessary.
 */ function $8f484ade10ebcd10$export$b41394a5437791c8(str, expectsLowerCase) {
    const map = Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
/**
 * dev only flag -> name mapping
 */ const $8f484ade10ebcd10$export$def7dc2c2e95a08a = {
    [1 /* TEXT */ ]: `TEXT`,
    [2 /* CLASS */ ]: `CLASS`,
    [4 /* STYLE */ ]: `STYLE`,
    [8 /* PROPS */ ]: `PROPS`,
    [16 /* FULL_PROPS */ ]: `FULL_PROPS`,
    [32 /* HYDRATE_EVENTS */ ]: `HYDRATE_EVENTS`,
    [64 /* STABLE_FRAGMENT */ ]: `STABLE_FRAGMENT`,
    [128 /* KEYED_FRAGMENT */ ]: `KEYED_FRAGMENT`,
    [256 /* UNKEYED_FRAGMENT */ ]: `UNKEYED_FRAGMENT`,
    [512 /* NEED_PATCH */ ]: `NEED_PATCH`,
    [1024 /* DYNAMIC_SLOTS */ ]: `DYNAMIC_SLOTS`,
    [2048 /* DEV_ROOT_FRAGMENT */ ]: `DEV_ROOT_FRAGMENT`,
    [-1 /* HOISTED */ ]: `HOISTED`,
    [-2 /* BAIL */ ]: `BAIL`
};
/**
 * Dev only
 */ const $8f484ade10ebcd10$export$624972196ed3745f = {
    [1 /* STABLE */ ]: "STABLE",
    [2 /* DYNAMIC */ ]: "DYNAMIC",
    [3 /* FORWARDED */ ]: "FORWARDED"
};
const $8f484ade10ebcd10$var$GLOBALS_WHITE_LISTED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt";
const $8f484ade10ebcd10$export$d6571a1911e4f27e = /*#__PURE__*/ $8f484ade10ebcd10$export$b41394a5437791c8($8f484ade10ebcd10$var$GLOBALS_WHITE_LISTED);
const $8f484ade10ebcd10$var$range = 2;
function $8f484ade10ebcd10$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    // Split the content into individual lines but capture the newline sequence
    // that separated each line. This is important because the actual sequence is
    // needed to properly take into account the full line length for offset
    // comparison
    let lines = source.split(/(\r?\n)/);
    // Separate the lines and newline sequences into separate arrays for easier referencing
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $8f484ade10ebcd10$var$range; j <= i + $8f484ade10ebcd10$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    // push underline
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
/**
 * On the client we only need to offer special cases for boolean attributes that
 * have different names from their corresponding dom properties:
 * - itemscope -> N/A
 * - allowfullscreen -> allowFullscreen
 * - formnovalidate -> formNoValidate
 * - ismap -> isMap
 * - nomodule -> noModule
 * - novalidate -> noValidate
 * - readonly -> readOnly
 */ const $8f484ade10ebcd10$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $8f484ade10ebcd10$export$d186f5eb2e810715 = /*#__PURE__*/ $8f484ade10ebcd10$export$b41394a5437791c8($8f484ade10ebcd10$var$specialBooleanAttrs);
/**
 * The full list is needed during SSR to produce the correct initial markup.
 */ const $8f484ade10ebcd10$export$f763ba3b84e9cd8c = /*#__PURE__*/ $8f484ade10ebcd10$export$b41394a5437791c8($8f484ade10ebcd10$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,` + `loop,open,required,reversed,scoped,seamless,` + `checked,muted,multiple,selected`);
/**
 * Boolean attributes should be included if the value is truthy or ''.
 * e.g. `<select multiple>` compiles to `{ multiple: '' }`
 */ function $8f484ade10ebcd10$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $8f484ade10ebcd10$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $8f484ade10ebcd10$var$attrValidationCache = {};
function $8f484ade10ebcd10$export$d55ef77660f30d12(name) {
    if ($8f484ade10ebcd10$var$attrValidationCache.hasOwnProperty(name)) return $8f484ade10ebcd10$var$attrValidationCache[name];
    const isUnsafe = $8f484ade10ebcd10$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $8f484ade10ebcd10$var$attrValidationCache[name] = !isUnsafe;
}
const $8f484ade10ebcd10$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
/**
 * CSS properties that accept plain numbers
 */ const $8f484ade10ebcd10$export$84da53524c6b1314 = /*#__PURE__*/ $8f484ade10ebcd10$export$b41394a5437791c8(`animation-iteration-count,border-image-outset,border-image-slice,` + `border-image-width,box-flex,box-flex-group,box-ordinal-group,column-count,` + `columns,flex,flex-grow,flex-positive,flex-shrink,flex-negative,flex-order,` + `grid-row,grid-row-end,grid-row-span,grid-row-start,grid-column,` + `grid-column-end,grid-column-span,grid-column-start,font-weight,line-clamp,` + `line-height,opacity,order,orphans,tab-size,widows,z-index,zoom,` + // SVG
`fill-opacity,flood-opacity,stop-opacity,stroke-dasharray,stroke-dashoffset,` + `stroke-miterlimit,stroke-opacity,stroke-width`);
/**
 * Known attributes, this is used for stringification of runtime static nodes
 * so that we don't stringify bindings that cannot be set from HTML.
 * Don't also forget to allow `data-*` and `aria-*`!
 * Generated from https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes
 */ const $8f484ade10ebcd10$export$f7e7a1cc7da8d5e9 = /*#__PURE__*/ $8f484ade10ebcd10$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,` + `autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,` + `border,buffered,capture,challenge,charset,checked,cite,class,code,` + `codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,` + `coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,` + `disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,` + `formaction,formenctype,formmethod,formnovalidate,formtarget,headers,` + `height,hidden,high,href,hreflang,http-equiv,icon,id,importance,integrity,` + `ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,` + `manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,` + `open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,` + `referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,` + `selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,` + `start,step,style,summary,tabindex,target,title,translate,type,usemap,` + `value,width,wrap`);
/**
 * Generated from https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute
 */ const $8f484ade10ebcd10$export$80da416f43933831 = /*#__PURE__*/ $8f484ade10ebcd10$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,` + `arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,` + `baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,` + `clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,` + `color-interpolation-filters,color-profile,color-rendering,` + `contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,` + `descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,` + `dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,` + `fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,` + `font-family,font-size,font-size-adjust,font-stretch,font-style,` + `font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,` + `glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,` + `gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,` + `horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,` + `k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,` + `lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,` + `marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,` + `mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,` + `name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,` + `overflow,overline-position,overline-thickness,panose-1,paint-order,path,` + `pathLength,patternContentUnits,patternTransform,patternUnits,ping,` + `pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,` + `preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,` + `rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,` + `restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,` + `specularConstant,specularExponent,speed,spreadMethod,startOffset,` + `stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,` + `strikethrough-position,strikethrough-thickness,string,stroke,` + `stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,` + `stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,` + `systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,` + `text-decoration,text-rendering,textLength,to,transform,transform-origin,` + `type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,` + `unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,` + `v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,` + `vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,` + `writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,` + `xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xml:base,xml:lang,` + `xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
function $8f484ade10ebcd10$export$8756898546458274(value) {
    if ($8f484ade10ebcd10$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $8f484ade10ebcd10$export$844ec244b1367d54(item) ? $8f484ade10ebcd10$export$76a205ce979d066a(item) : $8f484ade10ebcd10$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($8f484ade10ebcd10$export$844ec244b1367d54(value)) return value;
    else if ($8f484ade10ebcd10$export$a6cdc56e425d0d0a(value)) return value;
}
const $8f484ade10ebcd10$var$listDelimiterRE = /;(?![^(]*\))/g;
const $8f484ade10ebcd10$var$propertyDelimiterRE = /:(.+)/;
function $8f484ade10ebcd10$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.split($8f484ade10ebcd10$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($8f484ade10ebcd10$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $8f484ade10ebcd10$export$9466a5a0ee6f1479(styles) {
    let ret = "";
    if (!styles || $8f484ade10ebcd10$export$844ec244b1367d54(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        const normalizedKey = key.startsWith(`--`) ? key : $8f484ade10ebcd10$export$6e6a0a3676c4b8bb(key);
        if ($8f484ade10ebcd10$export$844ec244b1367d54(value) || typeof value === "number" && $8f484ade10ebcd10$export$84da53524c6b1314(normalizedKey)) // only render valid values
        ret += `${normalizedKey}:${value};`;
    }
    return ret;
}
function $8f484ade10ebcd10$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($8f484ade10ebcd10$export$844ec244b1367d54(value)) res = value;
    else if ($8f484ade10ebcd10$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $8f484ade10ebcd10$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($8f484ade10ebcd10$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $8f484ade10ebcd10$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$8f484ade10ebcd10$export$844ec244b1367d54(klass)) props.class = $8f484ade10ebcd10$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $8f484ade10ebcd10$export$8756898546458274(style);
    return props;
}
// These tag configs are shared between compiler-dom and runtime-dom, so they
// https://developer.mozilla.org/en-US/docs/Web/HTML/Element
const $8f484ade10ebcd10$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
// https://developer.mozilla.org/en-US/docs/Web/SVG/Element
const $8f484ade10ebcd10$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistanceLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $8f484ade10ebcd10$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
/**
 * Compiler only.
 * Do NOT use in runtime code paths unless behind `(process.env.NODE_ENV !== 'production')` flag.
 */ const $8f484ade10ebcd10$export$1ccf854a0984f890 = /*#__PURE__*/ $8f484ade10ebcd10$export$b41394a5437791c8($8f484ade10ebcd10$var$HTML_TAGS);
/**
 * Compiler only.
 * Do NOT use in runtime code paths unless behind `(process.env.NODE_ENV !== 'production')` flag.
 */ const $8f484ade10ebcd10$export$6328ce7565ea1049 = /*#__PURE__*/ $8f484ade10ebcd10$export$b41394a5437791c8($8f484ade10ebcd10$var$SVG_TAGS);
/**
 * Compiler only.
 * Do NOT use in runtime code paths unless behind `(process.env.NODE_ENV !== 'production')` flag.
 */ const $8f484ade10ebcd10$export$e5f2d3d97d9367a4 = /*#__PURE__*/ $8f484ade10ebcd10$export$b41394a5437791c8($8f484ade10ebcd10$var$VOID_TAGS);
const $8f484ade10ebcd10$var$escapeRE = /["'&<>]/;
function $8f484ade10ebcd10$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $8f484ade10ebcd10$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
// https://www.w3.org/TR/html52/syntax.html#comments
const $8f484ade10ebcd10$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $8f484ade10ebcd10$export$7b105034a53bde5f(src) {
    return src.replace($8f484ade10ebcd10$var$commentStripRE, "");
}
function $8f484ade10ebcd10$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $8f484ade10ebcd10$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $8f484ade10ebcd10$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $8f484ade10ebcd10$export$871608497c498473(a);
    let bValidType = $8f484ade10ebcd10$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $8f484ade10ebcd10$export$43bee75e5e14138e(a);
    bValidType = $8f484ade10ebcd10$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $8f484ade10ebcd10$var$looseCompareArrays(a, b) : false;
    aValidType = $8f484ade10ebcd10$export$a6cdc56e425d0d0a(a);
    bValidType = $8f484ade10ebcd10$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        /* istanbul ignore if: this if will probably never be called */ if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$8f484ade10ebcd10$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $8f484ade10ebcd10$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$8f484ade10ebcd10$export$ae8015769846262c(item, val));
}
/**
 * For converting {{ interpolation }} values to displayed strings.
 * @private
 */ const $8f484ade10ebcd10$export$b5b1545233b45293 = (val)=>{
    return val == null ? "" : $8f484ade10ebcd10$export$43bee75e5e14138e(val) || $8f484ade10ebcd10$export$a6cdc56e425d0d0a(val) && (val.toString === $8f484ade10ebcd10$export$830c053460e5ddf6 || !$8f484ade10ebcd10$export$f6e2535fb5126e54(val.toString)) ? JSON.stringify(val, $8f484ade10ebcd10$var$replacer, 2) : String(val);
};
const $8f484ade10ebcd10$var$replacer = (_key, val)=>{
    // can't use isRef here since @vue/shared has no deps
    if (val && val.__v_isRef) return $8f484ade10ebcd10$var$replacer(_key, val.value);
    else if ($8f484ade10ebcd10$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val])=>{
            entries[`${key} =>`] = val;
            return entries;
        }, {})
    };
    else if ($8f484ade10ebcd10$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ]
    };
    else if ($8f484ade10ebcd10$export$a6cdc56e425d0d0a(val) && !$8f484ade10ebcd10$export$43bee75e5e14138e(val) && !$8f484ade10ebcd10$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $8f484ade10ebcd10$export$cf583d23ab39677c = {};
const $8f484ade10ebcd10$export$6bd8558f433f1cc1 = [];
const $8f484ade10ebcd10$export$5702a91a6f42969f = ()=>{};
/**
 * Always return false.
 */ const $8f484ade10ebcd10$export$c01351c0af048e39 = ()=>false;
const $8f484ade10ebcd10$var$onRE = /^on[^a-z]/;
const $8f484ade10ebcd10$export$1a2d97de39ecbb75 = (key)=>$8f484ade10ebcd10$var$onRE.test(key);
const $8f484ade10ebcd10$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $8f484ade10ebcd10$export$8b58be045bf06082 = Object.assign;
const $8f484ade10ebcd10$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $8f484ade10ebcd10$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $8f484ade10ebcd10$export$b5a638e9b3fff9f3 = (val, key)=>$8f484ade10ebcd10$var$hasOwnProperty.call(val, key);
const $8f484ade10ebcd10$export$43bee75e5e14138e = Array.isArray;
const $8f484ade10ebcd10$export$5c90113a285f2241 = (val)=>$8f484ade10ebcd10$export$1dccc787cc36538b(val) === "[object Map]";
const $8f484ade10ebcd10$export$6750766a7c7ec627 = (val)=>$8f484ade10ebcd10$export$1dccc787cc36538b(val) === "[object Set]";
const $8f484ade10ebcd10$export$871608497c498473 = (val)=>val instanceof Date;
const $8f484ade10ebcd10$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $8f484ade10ebcd10$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $8f484ade10ebcd10$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $8f484ade10ebcd10$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $8f484ade10ebcd10$export$4369c812aac99591 = (val)=>{
    return $8f484ade10ebcd10$export$a6cdc56e425d0d0a(val) && $8f484ade10ebcd10$export$f6e2535fb5126e54(val.then) && $8f484ade10ebcd10$export$f6e2535fb5126e54(val.catch);
};
const $8f484ade10ebcd10$export$830c053460e5ddf6 = Object.prototype.toString;
const $8f484ade10ebcd10$export$1dccc787cc36538b = (value)=>$8f484ade10ebcd10$export$830c053460e5ddf6.call(value);
const $8f484ade10ebcd10$export$5ad0a3c360b8fbb5 = (value)=>{
    // extract "RawType" from strings like "[object RawType]"
    return $8f484ade10ebcd10$export$1dccc787cc36538b(value).slice(8, -1);
};
const $8f484ade10ebcd10$export$53b83ca8eaab0383 = (val)=>$8f484ade10ebcd10$export$1dccc787cc36538b(val) === "[object Object]";
const $8f484ade10ebcd10$export$e2a2b93446ec9fe = (key)=>$8f484ade10ebcd10$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $8f484ade10ebcd10$export$bf7d3c0236f0aa85 = /*#__PURE__*/ $8f484ade10ebcd10$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $8f484ade10ebcd10$var$cacheStringFunction = (fn)=>{
    const cache = Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $8f484ade10ebcd10$var$camelizeRE = /-(\w)/g;
/**
 * @private
 */ const $8f484ade10ebcd10$export$161d051f5dd25de7 = $8f484ade10ebcd10$var$cacheStringFunction((str)=>{
    return str.replace($8f484ade10ebcd10$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $8f484ade10ebcd10$var$hyphenateRE = /\B([A-Z])/g;
/**
 * @private
 */ const $8f484ade10ebcd10$export$6e6a0a3676c4b8bb = $8f484ade10ebcd10$var$cacheStringFunction((str)=>str.replace($8f484ade10ebcd10$var$hyphenateRE, "-$1").toLowerCase());
/**
 * @private
 */ const $8f484ade10ebcd10$export$9a00dee1beb8f576 = $8f484ade10ebcd10$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
/**
 * @private
 */ const $8f484ade10ebcd10$export$8c022799eeaaefcd = $8f484ade10ebcd10$var$cacheStringFunction((str)=>str ? `on${$8f484ade10ebcd10$export$9a00dee1beb8f576(str)}` : ``);
// compare whether a value has changed, accounting for NaN.
const $8f484ade10ebcd10$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $8f484ade10ebcd10$export$39951422d618a9d3 = (fns, arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](arg);
};
const $8f484ade10ebcd10$export$8afb76124cf08683 = (obj, key, value)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        value: value
    });
};
const $8f484ade10ebcd10$export$a0a81dc3380ce7d3 = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
let $8f484ade10ebcd10$var$_globalThis;
const $8f484ade10ebcd10$export$ff5f2eeb11fc7e14 = ()=>{
    return $8f484ade10ebcd10$var$_globalThis || ($8f484ade10ebcd10$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};

});





parcelRegister("d5hBS", function(module, exports) {

$parcel$export(module.exports, "findKarnaughGroups", function () { return $baa67abb5c8435d6$export$f13cc66eb34e828b; });
$parcel$export(module.exports, "Group", function () { return (parcelRequire("eTXsV")).Group; });
/**
 * @file Methods for generating Karnaugh maps from a truth tables and finding groups from them.
 */ 
var $1gNPB = parcelRequire("1gNPB");

var $7nMB1 = parcelRequire("7nMB1");

var $eTXsV = parcelRequire("eTXsV");
/* export */ const $baa67abb5c8435d6$var$buildKarnaughMap = (truthTable)=>{
    const truth = new (0, $1gNPB.CubeMat)(2, truthTable.length);
    truth.array.push(...truthTable);
    const map = new (0, $1gNPB.Karnaugh)(truthTable.length);
    for(let i = 0; i < truthTable.length; i++){
        const inputs = [];
        for (const coord of map.indexToCoords(i)){
            inputs.push(Boolean((0, $1gNPB.grayOrder)[coord] & 1));
            inputs.push(Boolean((0, $1gNPB.grayOrder)[coord] >>> 1 & 1));
        }
        map.array[i] = truth.get(inputs);
    }
    return map;
};
/* export */ const $baa67abb5c8435d6$var$buildKarnaughPrefix = (map)=>{
    // 5 elements in each dimension except the last, which can either be 5 or 2 (no need to extend if the size is 2 in a direction)
    const prefixArrayLength = 5 ** (map.nDimensions - 1) * (map.isEven ? 5 : 2);
    const prefix = new (0, $1gNPB.CubeMat)(5, prefixArrayLength); // 1 larger in every direction to handle wrapping
    for(let i = 0; i < prefixArrayLength; i++){
        const coords = prefix.indexToCoords(i);
        let sum = Number(map.getWrapping(coords));
        // Method for finding N-dimensional prefix sum element
        //  • Take the current element in the Karnaugh map
        //  • ADD all the elements that are [1 position behind in 1 direction] (ie, adjacent elements in 1D)
        //  • SUBTRACT all the elements that are [1 position behind in 2 directions] (ie, diagonals in 2D)
        //  • ADD all the elements that are [1 position behind in 3 directions] (ie, diagonals in 3D)
        //  • SUBTRACT all the elements that are diagonals in 4D
        //    ⋮
        for(let nShiftedDimensions = 1; nShiftedDimensions <= map.nDimensions; nShiftedDimensions++){
            const sign = nShiftedDimensions % 2 === 0 ? -1 : 1;
            // Account for every coordinate set where exactly `nShiftedDimensions` dimensions have been shifted back 1 space
            for (const combo of (0, $7nMB1.combineBoolean)(map.nDimensions, nShiftedDimensions)){
                // Shift the current coords
                const targetCoords = [];
                for(let j = 0; j < coords.length; j++)targetCoords[j] = combo[j] ? coords[j] - 1 : coords[j];
                sum += sign * prefix.getElse(0, targetCoords);
            }
        }
        prefix.array[i] = sum;
    }
    return prefix;
};
const $baa67abb5c8435d6$export$f13cc66eb34e828b = (truthTable)=>{
    const map = $baa67abb5c8435d6$var$buildKarnaughMap(truthTable);
    const prefix = $baa67abb5c8435d6$var$buildKarnaughPrefix(map);
    const groups = new Set();
    map.array.forEach((value, i)=>{
        if (value === false) return;
        const coords = map.indexToCoords(i);
        const singleDimensionDistances = $baa67abb5c8435d6$var$getSingleDimensionDistances(map, coords);
        const iterateCoordPossibilities = (dimensions, indexOfVariedDimension = 0)=>{
            let anyGroupFound = false;
            let lastValidDistance = -1;
            // Test ALL OF THEM!!! (unoptimized)
            const maxDistance = singleDimensionDistances[indexOfVariedDimension];
            for(let distance = 0; distance <= maxDistance; distance++){
                dimensions[indexOfVariedDimension] = distance;
                if (indexOfVariedDimension + 1 !== dimensions.length) iterateCoordPossibilities(dimensions, indexOfVariedDimension + 1);
                else {
                    const groupFound = $baa67abb5c8435d6$var$testDimensions(prefix, coords, dimensions);
                    if (!groupFound) break;
                    anyGroupFound = true;
                    lastValidDistance = distance;
                }
            }
            if (anyGroupFound) {
                const lastValidDimensions = [
                    ...dimensions
                ];
                lastValidDimensions[indexOfVariedDimension] = lastValidDistance;
                groups.add(new (0, $eTXsV.Group)(coords, lastValidDimensions));
            }
        };
        iterateCoordPossibilities(Array(map.nDimensions).fill(0));
    });
    // :)
    if (map.nDimensions === 0 && map.array[0] === true) groups.add(new (0, $eTXsV.Group)([], []));
    (0, $eTXsV.removeRedundantGroups)(groups, map);
    return groups;
};
const $baa67abb5c8435d6$var$getSingleDimensionDistances = (map, coords)=>{
    const singleDimensionDistances = Array(map.nDimensions).fill(0); // log2(distance)
    for(let dimension = 0; dimension < map.nDimensions; dimension++){
        const axisHasTwoVariables = map.isEven || dimension < map.nDimensions - 1; // code repeated from `interpretGroup`
        // Check for width 2
        if (!axisHasTwoVariables && coords[dimension] !== 0) continue; // Would have been found already
        const testCoords = [
            ...coords
        ];
        testCoords[dimension] = (testCoords[dimension] + 1) % 4;
        if (map.get(testCoords) === true) singleDimensionDistances[dimension] = 1;
        else continue;
        if (!axisHasTwoVariables) continue;
        // Check for width 4
        if (coords[dimension] !== 0) continue; // Would have been found already
        const testCoords2 = [
            ...coords
        ];
        testCoords2[dimension] = (testCoords2[dimension] + 2) % 4;
        const testCoords3 = [
            ...coords
        ];
        testCoords3[dimension] = (testCoords3[dimension] + 3) % 4;
        if (map.get(testCoords2) === true && map.get(testCoords3) === true) singleDimensionDistances[dimension] = 2;
    }
    return singleDimensionDistances;
};
const $baa67abb5c8435d6$var$samplePrefix = (prefix, coords, farCoords)=>{
    const nDimensions = coords.length;
    let prefixResult = prefix.get(farCoords);
    // Same as when building up the prefix sum, but the sign is flipped and the targetCoords are not necessarily
    // adjacent
    for(let nShiftedDimensions = 1; nShiftedDimensions <= nDimensions; nShiftedDimensions++){
        const sign = nShiftedDimensions % 2 !== 0 ? -1 : 1;
        // Let coords = [1, 1] (4 in the following prefix) and farCoords = [2, 2] (9 in the prefix)
        // Map:    Prefix:
        // 1 1 1   1 2 3
        // 1 1 1   2 4 6
        // 1 1 1   3 6 9
        // In 2D, the prefix result would be (9 − 3 − 3 + 1) = 4, which is the number of 1s in the map within the
        // rectangle whose corners are [1, 1] and [2, 2] inclusive.
        for (const combo of (0, $7nMB1.combineBoolean)(nDimensions, nShiftedDimensions)){
            const targetCoords = [];
            for(let j = 0; j < coords.length; j++)targetCoords[j] = combo[j] ? coords[j] - 1 : farCoords[j];
            prefixResult += sign * prefix.getElse(0, targetCoords);
        }
    }
    return prefixResult;
};
const $baa67abb5c8435d6$var$testDimensions = (prefix, coords, dimensions)=>{
    const farCoords = coords.map((coord, i)=>coord + 2 ** dimensions[i] - 1);
    // Count the number of trues
    const prefixResult = $baa67abb5c8435d6$var$samplePrefix(prefix, coords, farCoords);
    return prefixResult === 2 ** dimensions.reduce((exponent, length)=>exponent + length, 0);
};

});
parcelRegister("1gNPB", function(module, exports) {

$parcel$export(module.exports, "grayOrder", function () { return $e502f84cc3b974dd$export$789b4dbc9015a1de; });
$parcel$export(module.exports, "CubeMat", function () { return $e502f84cc3b974dd$export$1ea7d98f93572160; });
$parcel$export(module.exports, "Karnaugh", function () { return $e502f84cc3b974dd$export$6006a4d69805fcad; });

var $9qLgL = parcelRequire("9qLgL");
const $e502f84cc3b974dd$var$mod = (a, b)=>(a % b + b) % b;
const $e502f84cc3b974dd$export$789b4dbc9015a1de = [
    0,
    1,
    3,
    2
]; // smallest bit => first input 
class $e502f84cc3b974dd$export$1ea7d98f93572160 {
    coordsToIndex(coords) {
        let index = 0;
        for(let nDimension = 0; nDimension < coords.length; nDimension++){
            const coord = coords[nDimension];
            if (coord < 0 || coord >= this.width) return -1;
            index += coord * this.width ** nDimension;
        }
        return index;
    }
    // TODO should handle the case where the final axis is size 2 instead of 4
    coordsToIndexWrapping(coords) {
        let index = 0;
        for(let nDimension = 0; nDimension < coords.length; nDimension++){
            const coord = $e502f84cc3b974dd$var$mod(coords[nDimension], this.width);
            index += coord * this.width ** nDimension;
        }
        return index;
    }
    indexToCoords(index) {
        const indexes = [];
        for(let nDimension = 0; nDimension < this.nDimensions; nDimension++)indexes.push(Math.floor(index / this.width ** nDimension) % this.width);
        return indexes;
    }
    get(coords) {
        return this.array[this.coordsToIndex(coords)];
    }
    getElse(alt, coords) {
        var _this_get;
        return (_this_get = this.get(coords)) !== null && _this_get !== void 0 ? _this_get : alt;
    }
    getWrapping(coords) {
        return this.array[this.coordsToIndexWrapping(coords)];
    }
    set(value, coords) {
        this.array[this.coordsToIndex(coords)] = value;
        return this;
    }
    forEach(fn) {
        this.array.forEach((value, i)=>{
            fn(value, this.indexToCoords(i));
        });
    }
    constructor(width, arrayLength){
        (0, $9qLgL._)(this, "array", []);
        (0, $9qLgL._)(this, "width", void 0);
        (0, $9qLgL._)(this, "nDimensions", void 0);
        this.width = width;
        // this.array = Array<T>(arrayLength);
        // Object.seal(this.array); 
        this.nDimensions = Math.ceil(Math.log2(arrayLength) / Math.log2(this.width));
    }
}
class $e502f84cc3b974dd$export$6006a4d69805fcad extends $e502f84cc3b974dd$export$1ea7d98f93572160 {
    static withNDimensions(nDimensions) {
        return new $e502f84cc3b974dd$export$6006a4d69805fcad(4 ** nDimensions);
    }
    constructor(arrayLength){
        super(4, arrayLength);
        (0, $9qLgL._)(this, "nInputBits", void 0);
        /**
	 * Whether the map has an even number of dimensions. If false, the final axis only has 1 variable.
	 */ (0, $9qLgL._)(this, "isEven", void 0);
        this.nInputBits = Math.log2(arrayLength);
        if (this.nInputBits % 1 !== 0) throw new RangeError("Truth table size is not a power of 2");
        this.isEven = this.nInputBits % 2 === 0;
    }
}
var $e502f84cc3b974dd$var$Output;
/* export class TruthTable extends CubeMat<boolean> {
	readonly nInputBits: number;

	constructor(inputs: boolean[]) {
		super(2, inputs.length);
		this.array.push(...inputs);

		this.nInputBits = Math.log2(inputs.length);
	}

	// functionally equivalent, partially copied over
	coordsToIndex(coords: number[]): number {
		let index = 0;
		for (let nDimension = 0; nDimension < coords.length; nDimension++) {
			const coord = coords[nDimension];
			if (coord < 0 || coord >= this.width) {
				return -1;
			}

			index += coord << nDimension;
		}
		return index;
	}
} */ (function(Output) {
    Output[Output["TRUE"] = 0] = "TRUE";
    Output[Output["FALSE"] = 1] = "FALSE";
    Output[Output["DONT_CARE"] = 2] = "DONT_CARE";
})($e502f84cc3b974dd$var$Output || ($e502f84cc3b974dd$var$Output = {}));

});
parcelRegister("9qLgL", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6ddb3577cbce47ba$export$1e71eb4bef00f6b0; });
function $6ddb3577cbce47ba$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("7nMB1", function(module, exports) {

$parcel$export(module.exports, "combineBoolean", function () { return $ea2d628c13ce892f$export$e515bf7ede92e01; });
$parcel$export(module.exports, "anyCombineBoolean", function () { return $ea2d628c13ce892f$export$fd319151ca2b433b; });
$parcel$export(module.exports, "anyCombine", function () { return $ea2d628c13ce892f$export$45f8c2b726941d7; });
/**
 * @file Methods for generating permutations and combinations.
 */ /* const permutations = <T>(items: T[]): T[][] => {
	switch (items.length) {
		case 1:
			return [[items[0]]];

		case 0:
			return [[]];
	}

	const perms = [];

	for (let i = 0; i < items.length; i++) {
		const item = items[i];

		const rest = [...items.slice(0, i), ...items.slice(i + 1)];
		for (const subperm of permutations(rest)) {
			perms.push([item, ...subperm]);
		}
	}
	
	return perms;
};

export default permutations; */ function* $ea2d628c13ce892f$export$95e62ad65da8b7d2(items) {
    switch(items.length){
        case 1:
            yield [
                items[0]
            ];
            return;
        case 0:
            yield [];
            return;
    }
    for(let i = 0; i < items.length; i++){
        const item = items[i];
        const rest = [
            ...items.slice(0, i),
            ...items.slice(i + 1)
        ];
        for (const subperm of $ea2d628c13ce892f$export$95e62ad65da8b7d2(rest))yield [
            item,
            ...subperm
        ];
    }
}
function* $ea2d628c13ce892f$export$e515bf7ede92e01(nTotal, nTrues) {
    if (nTrues > nTotal) throw new RangeError();
    switch(nTotal){
        case 1:
            yield [
                nTrues !== 0
            ];
            return;
        case 0:
            yield [];
            return;
    }
    if (nTrues <= nTotal - 1) for (const subcombo of $ea2d628c13ce892f$export$e515bf7ede92e01(nTotal - 1, nTrues))yield [
        false,
        ...subcombo
    ];
    if (nTrues > 0) for (const subcombo of $ea2d628c13ce892f$export$e515bf7ede92e01(nTotal - 1, nTrues - 1))yield [
        true,
        ...subcombo
    ];
}
function* $ea2d628c13ce892f$export$7be5907b6d6222b(nTotal, nSelected, offset = 0) {
    if (nSelected > nTotal) throw new RangeError();
    switch(nTotal){
        case 1:
            if (nSelected === 0) yield [];
            else yield [
                offset
            ];
            return;
        case 0:
            yield [];
            return;
    }
    // Skip the current entry
    if (nSelected <= nTotal - 1) for (const subcombo of $ea2d628c13ce892f$export$7be5907b6d6222b(nTotal - 1, nSelected, offset + 1))yield subcombo;
    // Add the current entry
    if (nSelected > 0) for (const subcombo of $ea2d628c13ce892f$export$7be5907b6d6222b(nTotal - 1, nSelected - 1, offset + 1))yield [
        offset,
        ...subcombo
    ];
}
function* $ea2d628c13ce892f$export$1be1fc439b849fdf(items, nSelected, i = 0) {
    if (nSelected > items.length) throw new RangeError();
    switch(items.length - i){
        case 1:
            if (nSelected === 0) yield [];
            else yield [
                items[i]
            ];
            return;
        case 0:
            yield [];
            return;
    }
    // Skip the current entry
    if (nSelected <= items.length - 1) for (const subcombo of $ea2d628c13ce892f$export$1be1fc439b849fdf(items, nSelected, i + 1))yield subcombo;
    // Add the current entry
    if (nSelected > 0) for (const subcombo of $ea2d628c13ce892f$export$1be1fc439b849fdf(items, nSelected - 1, i + 1))yield [
        items[i],
        ...subcombo
    ];
}
function* $ea2d628c13ce892f$export$fd319151ca2b433b(nTotal) {
    for(let i = 0; i <= nTotal; i++)yield* $ea2d628c13ce892f$export$e515bf7ede92e01(nTotal, i);
}
function* $ea2d628c13ce892f$export$45f8c2b726941d7(items, rStart = 0, rEnd = items.length) {
    for(let i = rStart; i <= rEnd; i++)yield* $ea2d628c13ce892f$export$1be1fc439b849fdf(items, i);
}
function $ea2d628c13ce892f$export$cda933650d0d537c(start, end) {
    const array = [];
    for(let i = start; i < end; i++)array.push(i);
    return array;
}

});

parcelRegister("eTXsV", function(module, exports) {

$parcel$export(module.exports, "Group", function () { return $ba5861882b07f1a3$export$eb2fcfdbd7ba97d4; });
$parcel$export(module.exports, "removeRedundantGroups", function () { return $ba5861882b07f1a3$export$67f4076a0ab53894; });

var $hUGKe = parcelRequire("hUGKe");

var $lHP9J = parcelRequire("lHP9J");

var $edv7a = parcelRequire("edv7a");

var $9qLgL = parcelRequire("9qLgL");

var $1eXYH = parcelRequire("1eXYH");

var $5wItV = parcelRequire("5wItV");

var $7nMB1 = parcelRequire("7nMB1");
class $ba5861882b07f1a3$export$eb2fcfdbd7ba97d4 {
    eq(target) {
        return this.offset.every((coord, i)=>coord === target.offset[i] && this.size[i] === target.size[i]);
    }
    /**
	 * Determines whether this group contains another group, without considering the wrapping case.
	 * @param target 
	 * @returns 
	 */ partialContains(target) {
        // TODO wrapping in an axis with 1 variable?
        const result = // Is the offset of the container group less than the offset of this group in every direction?
        target.offset.every((coord, dimension)=>this.offset[dimension] <= coord) && target.offset.every((coord, dimension)=>target.endCorner[dimension] <= this.endCorner[dimension] || this.size[dimension] === 2 // Container size is 4 and wraps around infinitely
        );
        return result;
    }
    contains(target) {
        if (this.partialContains(target)) return true;
        // Determine if the container has an offset of 3 and size of 1 in any direction (it wraps around)
        let containerWraps = false;
        const newOffset = [
            ...this.offset
        ];
        const targetOffset = [
            ...target.offset
        ];
        for(let dimension = 0; dimension < this.nDimensions; dimension++){
            if (this.wrapsDimension(dimension)) {
                containerWraps = true;
                newOffset[dimension] -= 4; // Shift the container group back
            }
            if (target.wrapsDimension(dimension)) targetOffset[dimension] -= 4;
        }
        // Try again, but with the shifted coordinates
        if (containerWraps && new $ba5861882b07f1a3$export$eb2fcfdbd7ba97d4(newOffset, this.size).partialContains(new $ba5861882b07f1a3$export$eb2fcfdbd7ba97d4(targetOffset, target.size))) return true;
        return false;
    }
    wrapsDimension(dimension) {
        return this.offset[dimension] === 3 && this.size[dimension] === 1;
    // return this.endCorner[dimension] <= 4;
    }
    getWrappedDimensions() {
        const wrappedDimensions = [];
        for(let dimension = 0; dimension < this.nDimensions; dimension++){
            if (!this.wrapsDimension(dimension)) continue;
            wrappedDimensions.push(dimension);
        }
        return wrappedDimensions;
    }
    get length() {
        var _this__length;
        return (_this__length = this._length) !== null && _this__length !== void 0 ? _this__length : this._length = this.size.map((size)=>2 ** size);
    }
    get endCorner() {
        var _this__endCorner;
        return (_this__endCorner = this._endCorner) !== null && _this__endCorner !== void 0 ? _this__endCorner : this._endCorner = this.offset.map((coord, i)=>coord + this.length[i]);
    }
    constructor(offset, /**
		 * log2(true length) in each direction.
		 */ size){
        (0, $9qLgL._)(this, "offset", void 0);
        (0, $9qLgL._)(this, "size", void 0);
        /**
	 * log2(true volume).
	 */ (0, $9qLgL._)(this, "volume", void 0);
        (0, $9qLgL._)(this, "nDimensions", void 0);
        (0, $9qLgL._)(this, "_length", void 0 // Switched from private fields due to Vue failing to support them
        );
        (0, $9qLgL._)(this, "_endCorner", void 0);
        this.offset = offset;
        this.size = size;
        let volume = 0;
        for (const length of size)volume += length;
        this.volume = volume;
        this.nDimensions = offset.length;
    }
}
var $ba5861882b07f1a3$var$_endCorner = /*#__PURE__*/ new WeakMap();
class $ba5861882b07f1a3$export$c8821cc685709b7b {
    static thatCovers(map) {
        const length = [];
        for(let i = 0; i < map.nDimensions; i++)length.push(i < map.nDimensions - 1 || map.isEven ? 4 : 2);
        return new $ba5861882b07f1a3$export$c8821cc685709b7b(Array(map.nDimensions).fill(0), length);
    }
    /**
	 * (Due to wrapping, a group may consist of multiple cuboids.)
	 * @param group 
	 */ static forGroup(group) {
        // Find all groups in which this group wraps
        const wrappedDimensions = group.getWrappedDimensions();
        if (wrappedDimensions.length === 0) return [
            new $ba5861882b07f1a3$export$c8821cc685709b7b(group.offset, group.length)
        ];
        const cuboids = [];
        for (const combo of (0, $7nMB1.anyCombineBoolean)(wrappedDimensions.length)){
            const offset = [
                ...group.offset
            ];
            const length = [
                ...group.length
            ];
            for(let i = 0; i < wrappedDimensions.length; i++){
                const dimension = wrappedDimensions[i];
                const firstLength = 4 - group.offset[dimension];
                offset[dimension] = combo[i] ? group.offset[dimension] : 0;
                length[dimension] = combo[i] ? firstLength : group.length[dimension] - firstLength;
            }
            cuboids.push(new $ba5861882b07f1a3$export$c8821cc685709b7b(offset, length));
        }
        return cuboids;
    }
    static totalVolume(cuboids) {
        return (0, $5wItV.reduce)(cuboids, (cumVolume, cuboid)=>cumVolume + cuboid.volume(), 0);
    }
    get endCorner() {
        var _class_private_field_get1;
        return (_class_private_field_get1 = (0, $hUGKe._)(this, $ba5861882b07f1a3$var$_endCorner)) !== null && _class_private_field_get1 !== void 0 ? _class_private_field_get1 : (0, $edv7a._)(this, $ba5861882b07f1a3$var$_endCorner, this.offset.map((coord, i)=>coord + this.length[i]));
    }
    subtract(target) {
        const newCuboids = [];
        const newLeftCuboid = (dimension)=>{
            const offset = [];
            const length = [];
            for(let i = 0; i < this.nDimensions; i++){
                if (i < dimension) {
                    offset.push(Math.max(this.offset[i], target.offset[i]));
                    length.push(target.length[i] - Math.max(0, this.offset[i] - target.offset[i]) - Math.max(0, target.endCorner[i] - this.endCorner[i]));
                } else if (i === dimension) {
                    offset.push(this.offset[i]);
                    length.push(target.offset[i] - this.offset[i]);
                } else {
                    offset.push(this.offset[i]);
                    length.push(this.length[i]);
                }
            }
            return new $ba5861882b07f1a3$export$c8821cc685709b7b(offset, length);
        };
        const newRightCuboid = (dimension)=>{
            const offset = [];
            const length = [];
            for(let i = 0; i < this.nDimensions; i++){
                if (i < dimension) {
                    offset.push(Math.max(this.offset[i], target.offset[i]));
                    length.push(target.length[i] - Math.max(0, this.offset[i] - target.offset[i]) - Math.max(0, target.endCorner[i] - this.endCorner[i]));
                } else if (i === dimension) {
                    offset.push(target.endCorner[i]);
                    length.push(this.endCorner[i] - target.endCorner[i]);
                } else {
                    offset.push(this.offset[i]);
                    length.push(this.length[i]);
                }
            }
            return new $ba5861882b07f1a3$export$c8821cc685709b7b(offset, length);
        };
        for(let dimension = 0; dimension < this.nDimensions; dimension++){
            // Does the target actually intersect this? (Only one direction needed to return no)
            if (target.endCorner[dimension] <= this.offset[dimension] || this.endCorner[dimension] <= target.offset[dimension]) return {
                changed: false,
                subcuboids: [
                    this
                ]
            };
            if (this.offset[dimension] < target.offset[dimension]) newCuboids.push(newLeftCuboid(dimension));
            if (target.endCorner[dimension] < this.endCorner[dimension]) newCuboids.push(newRightCuboid(dimension));
        }
        return {
            changed: true,
            subcuboids: newCuboids
        };
    }
    volume() {
        return this.length.reduce((volume, length)=>volume * length, 1);
    }
    constructor(offset, /**
		 * True size; not log2.
		 */ length){
        (0, $9qLgL._)(this, "offset", void 0);
        (0, $9qLgL._)(this, "length", void 0);
        (0, $9qLgL._)(this, "nDimensions", void 0);
        (0, $lHP9J._)(this, $ba5861882b07f1a3$var$_endCorner, {
            writable: true,
            value: void 0
        });
        this.offset = offset;
        this.length = length;
        this.nDimensions = offset.length;
    }
}
const $ba5861882b07f1a3$export$67f4076a0ab53894 = (groups, map)=>{
    // Remove all groups that are contained by 1 other group
    // (unoptimized)
    for (const group of groups)for (const container of groups){
        if (group === container || !container.contains(group)) continue;
        groups.delete(group);
    }
    if (groups.size <= 2) return groups;
    // Remove all groups that are contained by the union of multiple groups
    // (this is basically the minimum set cover problem so it's intrinsically slow)
    // The commented solution here is incomplete since the order of same-size groups matters
    // Determine if a N-cuboid is completely covered by a set of other parallel N-cuboids:
    //  • Create a cuboid covering the entire map and add it to a [set of remaining cuboids] S
    //     (the cuboids in S altogether represent, for any group during the iteration, a volume that has not been
    //     covered by any larger groups)
    //  • Starting with the largest group, subtract (cut out) [the cuboid representing the group] C from each cuboid D in S
    //      • If C does not affect D during the subtraction, remove C from the set of groups
    //      • Replace D in S with the cuboids resulting from the subtraction
    /*	const uncoveredCuboids = new Set<Cuboid>([Cuboid.thatCovers(map)]);
	const groupsSorted = [...groups].sort((a, b) => b.volume - a.volume);

	for (const group of groupsSorted) {
		let atLeastOneChanged = false;

		for (const groupCuboid of Cuboid.forGroup(group)) {
			for (const cuboid of uncoveredCuboids) {
				const {changed, subcuboids} = cuboid.subtract(groupCuboid);
				if (!changed) continue;
	
				atLeastOneChanged = true;
				uncoveredCuboids.delete(cuboid);
				for (const subcuboid of subcuboids) {
					uncoveredCuboids.add(subcuboid);
				}
			}
		}

		if (atLeastOneChanged) continue;
		groups.delete(group);
	}
	
	return; */ const groupsByVolume = new (0, $1eXYH.default)();
    for (const group of groups)groupsByVolume.add(group.volume, group);
    const groupBucketsSorted = [
        ...groupsByVolume.sets()
    ].sort((a, b)=>b[0] - a[0]);
    let uncoveredCuboids = new Set([
        $ba5861882b07f1a3$export$c8821cc685709b7b.thatCovers(map)
    ]);
    for (const [volume, groupsOfVolume] of groupBucketsSorted){
        const cuboidsForGroups = new Map();
        for (const group of groupsOfVolume)cuboidsForGroups.set(group, $ba5861882b07f1a3$export$c8821cc685709b7b.forGroup(group));
        // Find the optimal volume by subtracting all the groups first
        // Optimal volume is the minimum total volume of the uncovered cuboids
        const refUncoveredCuboids = new Set(uncoveredCuboids);
        for (const group of groupsOfVolume){
            for (const groupCuboid of cuboidsForGroups.get(group))for (const cuboid of refUncoveredCuboids){
                const { changed: changed, subcuboids: subcuboids } = cuboid.subtract(groupCuboid);
                if (!changed) continue;
                refUncoveredCuboids.delete(cuboid);
                for (const subcuboid of subcuboids)refUncoveredCuboids.add(subcuboid);
            }
        }
        const optimalVolume = $ba5861882b07f1a3$export$c8821cc685709b7b.totalVolume(refUncoveredCuboids);
        let optimalCombo = [
            ...groupsOfVolume
        ];
        // comboLoop:
        for (const combo of (0, $7nMB1.anyCombine)([
            ...groupsOfVolume
        ], 1, groupsOfVolume.size - 1)){
            const comboUncoveredCuboids = new Set(uncoveredCuboids);
            for (const group of combo){
                for (const groupCuboid of cuboidsForGroups.get(group))// let anyCuboidsChanged = false;
                for (const cuboid of comboUncoveredCuboids){
                    const { changed: changed, subcuboids: subcuboids } = cuboid.subtract(groupCuboid);
                    if (!changed) continue;
                    comboUncoveredCuboids.delete(cuboid);
                    for (const subcuboid of subcuboids)comboUncoveredCuboids.add(subcuboid);
                // anyCuboidsChanged = true;
                }
            }
            // Check the newfound volume against the optimal volume
            if ($ba5861882b07f1a3$export$c8821cc685709b7b.totalVolume(comboUncoveredCuboids) === optimalVolume) {
                optimalCombo = combo;
                break;
            }
        }
        optimalCombo !== null && optimalCombo !== void 0 ? optimalCombo : optimalCombo = [
            ...groupsOfVolume
        ]; // Necessary?
        // Remove all groups that are not in the optimal combination
        const removedGroups = new Set(groupsOfVolume);
        for (const group of optimalCombo)removedGroups.delete(group);
        for (const group of removedGroups)groups.delete(group);
        // Update the original cuboid set
        uncoveredCuboids = refUncoveredCuboids;
    }
    return groups;
}; /*namespace naive {

	const fillMap = (map: Karnaugh, offset: number[], size: number[], dimension: number) => {
		if 

		for (let i = 0; i < size[dimension]; i++) {
			const newOffset = [...offset];
			newOffset[dimension]++;

		}
	};

	const removeRedundantGroups = (groups: Set<Group>, map: Karnaugh) => {
		const newMap = new Karnaugh(map.array.length);
		const groupsSorted = [...groups].sort((a, b) => b.volume - a.volume);
		
		for (const group of groupsSorted) {
			let anyChanged = false;

			fillMap(newMap, group);

			const oldValue = newMap.get(group.offset);
			if (oldValue === false) {
				anyChanged = true;
			}

			newMap.set(true, group.offset);
		}
	};
}*/ 

});
parcelRegister("hUGKe", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d0a8d2d5738e1099$export$5a67b255b80ee4f2; });

var $6eZDW = parcelRequire("6eZDW");

var $aE17a = parcelRequire("aE17a");
function $d0a8d2d5738e1099$export$5a67b255b80ee4f2(receiver, privateMap) {
    var descriptor = (0, $aE17a._class_extract_field_descriptor)(receiver, privateMap, "get");
    return (0, $6eZDW._class_apply_descriptor_get)(receiver, descriptor);
}

});
parcelRegister("6eZDW", function(module, exports) {

$parcel$export(module.exports, "_class_apply_descriptor_get", function () { return $48b3ddf43f6fc301$export$184ff5d81c0e5775; });
function $48b3ddf43f6fc301$export$184ff5d81c0e5775(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}

});

parcelRegister("aE17a", function(module, exports) {

$parcel$export(module.exports, "_class_extract_field_descriptor", function () { return $7bfe8122fc916fca$export$20c20a422940e173; });
function $7bfe8122fc916fca$export$20c20a422940e173(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}

});


parcelRegister("lHP9J", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $fcd54b9c5f18cc7f$export$e235798705076415; });

var $1R8u3 = parcelRequire("1R8u3");
function $fcd54b9c5f18cc7f$export$e235798705076415(obj, privateMap, value) {
    (0, $1R8u3._check_private_redeclaration)(obj, privateMap);
    privateMap.set(obj, value);
}

});
parcelRegister("1R8u3", function(module, exports) {

$parcel$export(module.exports, "_check_private_redeclaration", function () { return $15a1525fd2950e4a$export$6b10452b5ac97eba; });
function $15a1525fd2950e4a$export$6b10452b5ac97eba(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}

});


parcelRegister("edv7a", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a59a6a4e89f1cc4e$export$268446c9779b3a21; });

var $8SJkX = parcelRequire("8SJkX");

var $aE17a = parcelRequire("aE17a");
function $a59a6a4e89f1cc4e$export$268446c9779b3a21(receiver, privateMap, value) {
    var descriptor = (0, $aE17a._class_extract_field_descriptor)(receiver, privateMap, "set");
    (0, $8SJkX._class_apply_descriptor_set)(receiver, descriptor, value);
    return value;
}

});
parcelRegister("8SJkX", function(module, exports) {

$parcel$export(module.exports, "_class_apply_descriptor_set", function () { return $01ab33c17eeb60f8$export$b7b24cdba6bcb11c; });
function $01ab33c17eeb60f8$export$b7b24cdba6bcb11c(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}

});


parcelRegister("1eXYH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9264fcfc4a1d1da$export$2e2bcd8739ae039; });
/**
 * Wraps a `Map<K, Set<V>>`.
 */ 
var $hUGKe = parcelRequire("hUGKe");

var $lHP9J = parcelRequire("lHP9J");

var $edv7a = parcelRequire("edv7a");

var $9qLgL = parcelRequire("9qLgL");
var $d9264fcfc4a1d1da$var$_size = /*#__PURE__*/ new WeakMap();
let $d9264fcfc4a1d1da$var$_Symbol_iterator = Symbol.iterator;
class $d9264fcfc4a1d1da$export$2e2bcd8739ae039 {
    get size() {
        return (0, $hUGKe._)(this, $d9264fcfc4a1d1da$var$_size);
    }
    add(key, value) {
        let set = this.map.get(key);
        if (!set) {
            set = new Set();
            this.map.set(key, set);
        }
        (0, $edv7a._)(this, $d9264fcfc4a1d1da$var$_size, (0, $hUGKe._)(this, $d9264fcfc4a1d1da$var$_size) - set.size);
        set.add(value);
        (0, $edv7a._)(this, $d9264fcfc4a1d1da$var$_size, (0, $hUGKe._)(this, $d9264fcfc4a1d1da$var$_size) + set.size);
    }
    deleteSet(key) {
        var _this_map_get;
        var _this_map_get_size;
        (0, $edv7a._)(this, $d9264fcfc4a1d1da$var$_size, (0, $hUGKe._)(this, $d9264fcfc4a1d1da$var$_size) - ((_this_map_get_size = (_this_map_get = this.map.get(key)) === null || _this_map_get === void 0 ? void 0 : _this_map_get.size) !== null && _this_map_get_size !== void 0 ? _this_map_get_size : 0));
        this.map.delete(key);
    }
    setSet(key, set) {
        var _this_map_get;
        var _this_map_get_size;
        (0, $edv7a._)(this, $d9264fcfc4a1d1da$var$_size, (0, $hUGKe._)(this, $d9264fcfc4a1d1da$var$_size) - ((_this_map_get_size = (_this_map_get = this.map.get(key)) === null || _this_map_get === void 0 ? void 0 : _this_map_get.size) !== null && _this_map_get_size !== void 0 ? _this_map_get_size : 0));
        this.map.set(key, set);
        (0, $edv7a._)(this, $d9264fcfc4a1d1da$var$_size, (0, $hUGKe._)(this, $d9264fcfc4a1d1da$var$_size) + set.size);
    }
    *[$d9264fcfc4a1d1da$var$_Symbol_iterator]() {
        for (const [key, values] of this.map)for (const value of values)yield [
            key,
            value
        ];
    }
    *sets() {
        yield* this.map;
    }
    constructor(){
        (0, $9qLgL._)(this, "map", new Map());
        (0, $lHP9J._)(this, $d9264fcfc4a1d1da$var$_size, {
            writable: true,
            value: 0
        });
    }
}

});

parcelRegister("5wItV", function(module, exports) {

$parcel$export(module.exports, "reduce", function () { return $a23ce63829ae5cbb$export$533b26079ad0b4b; });
$parcel$export(module.exports, "range", function () { return $a23ce63829ae5cbb$export$d02631cccf789723; });
$parcel$export(module.exports, "take", function () { return $a23ce63829ae5cbb$export$b7df5d561049483a; });
const $a23ce63829ae5cbb$export$533b26079ad0b4b = (iterable, fn, accumulated)=>{
    for (const value of iterable)accumulated = fn(accumulated, value);
    return accumulated;
};
const $a23ce63829ae5cbb$export$d02631cccf789723 = function*(n) {
    for(let i = 0; i < n; i++)yield i;
};
const $a23ce63829ae5cbb$export$b7df5d561049483a = function*(iterable, count) {
    const iterator = iterable[Symbol.iterator]();
    let result = iterator.next();
    let i = 0;
    while(!result.done && i < count){
        yield result.value;
        result = iterator.next();
        i++;
    }
};

});



parcelRegister("28kJ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18dc67d5cc1994c9$export$2e2bcd8739ae039; });
let $18dc67d5cc1994c9$var$script;




let $18dc67d5cc1994c9$var$initialize = ()=>{
    $18dc67d5cc1994c9$var$script = (parcelRequire("3KrPs"));
    if ($18dc67d5cc1994c9$var$script.__esModule) $18dc67d5cc1994c9$var$script = $18dc67d5cc1994c9$var$script.default;
    $18dc67d5cc1994c9$var$script.render = (parcelRequire("ic67K")).render;
    $18dc67d5cc1994c9$var$script.__cssModules = {};
    (parcelRequire("hEc7U")).default($18dc67d5cc1994c9$var$script);
    $18dc67d5cc1994c9$var$script.__scopeId = "data-v-2d7fad";
    $18dc67d5cc1994c9$var$script.__file = "Entry.vue";
};
$18dc67d5cc1994c9$var$initialize();
var $18dc67d5cc1994c9$export$2e2bcd8739ae039 = $18dc67d5cc1994c9$var$script;

});
parcelRegister("3KrPs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $2bab4140bb15aa2a$export$2e2bcd8739ae039; });
parcelRequire("kdoAp");
var $e1gjy = parcelRequire("e1gjy");

var $fGg1q = parcelRequire("fGg1q");
const $2bab4140bb15aa2a$var$acceptAlways = ()=>true;
var $2bab4140bb15aa2a$export$2e2bcd8739ae039 = (0, $e1gjy.defineComponent)({
    name: "entry",
    mixins: [
        (0, $fGg1q.default)
    ],
    props: {
        validate: {
            type: Function,
            default: $2bab4140bb15aa2a$var$acceptAlways
        }
    },
    data () {
        return {
            proposedValueIsValid: true,
            isFocused: false
        };
    },
    methods: {
        onInput (event) {
            const proposedValue = this.convertOut(Number(this.$el.value));
            this.proposedValueIsValid = this.validate(proposedValue);
            if (this.proposedValueIsValid) this.$emit("update:modelValue", proposedValue);
            else event.stopPropagation();
        },
        onChange () {
            this.updateDisplayValue();
            this.proposedValueIsValid = true;
        },
        onFocus () {
            this.isFocused = true;
        },
        onBlur () {
            this.isFocused = false;
        }
    },
    watch: {
        value () {
            if (this.isFocused) return;
            this.updateDisplayValue();
        }
    }
});

});
parcelRegister("fGg1q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa93469f2ce2034f$export$2e2bcd8739ae039; });
const $aa93469f2ce2034f$var$identity = (value)=>value;
var $aa93469f2ce2034f$export$2e2bcd8739ae039 = {
    props: {
        convertIn: {
            type: Function,
            default: $aa93469f2ce2034f$var$identity
        },
        convertOut: {
            type: Function,
            default: $aa93469f2ce2034f$var$identity
        },
        modelValue: {
            type: Number,
            default: 0
        }
    },
    methods: {
        updateDisplayValue () {
            this.$el.value = this.convertIn(this.modelValue);
        }
    },
    mounted () {
        this.updateDisplayValue();
    }
};

});


parcelRegister("ic67K", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $d3ee1914ab7670ae$export$b3890eb0ae9dca99; });
parcelRequire("kdoAp");
var $e1gjy = parcelRequire("e1gjy");
var $ciGHN = parcelRequire("ciGHN");
var $95okz = parcelRequire("95okz");
function $d3ee1914ab7670ae$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $e1gjy.openBlock)(), (0, $e1gjy.createElementBlock)("input", {
        type: "number",
        onInput: _cache[0] || (_cache[0] = (...args)=>_ctx.onInput && _ctx.onInput(...args)),
        onChange: _cache[1] || (_cache[1] = (0, $95okz.withModifiers)((...args)=>_ctx.onChange && _ctx.onChange(...args), [
            "stop"
        ])),
        onFocus: _cache[2] || (_cache[2] = (...args)=>_ctx.onFocus && _ctx.onFocus(...args)),
        onBlur: _cache[3] || (_cache[3] = (...args)=>_ctx.onBlur && _ctx.onBlur(...args)),
        class: (0, $ciGHN.normalizeClass)({
            invalid: !_ctx.proposedValueIsValid
        })
    }, null, 34);
}

});

parcelRegister("hEc7U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd8f942abaccbf60$export$2e2bcd8739ae039; });
let $cd8f942abaccbf60$var$NOOP = ()=>{};
var $cd8f942abaccbf60$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("anKEn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78f03d264a479148$export$2e2bcd8739ae039; });
let $78f03d264a479148$var$script;




let $78f03d264a479148$var$initialize = ()=>{
    $78f03d264a479148$var$script = (parcelRequire("eZ1bI"));
    if ($78f03d264a479148$var$script.__esModule) $78f03d264a479148$var$script = $78f03d264a479148$var$script.default;
    $78f03d264a479148$var$script.render = (parcelRequire("lXnP2")).render;
    $78f03d264a479148$var$script.__cssModules = {};
    (parcelRequire("kuBVg")).default($78f03d264a479148$var$script);
    $78f03d264a479148$var$script.__scopeId = "data-v-c006e6";
    $78f03d264a479148$var$script.__file = "KarnaughMap.vue";
};
$78f03d264a479148$var$initialize();
var $78f03d264a479148$export$2e2bcd8739ae039 = $78f03d264a479148$var$script;

});
parcelRegister("eZ1bI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $ce4440200c7969a3$export$2e2bcd8739ae039; });
parcelRequire("kdoAp");
var $e1gjy = parcelRequire("e1gjy");
parcelRequire("d5hBS");
var $eTXsV = parcelRequire("eTXsV");

var $1gNPB = parcelRequire("1gNPB");

var $5wItV = parcelRequire("5wItV");

var $7nMB1 = parcelRequire("7nMB1");

var $5GfdI = parcelRequire("5GfdI");

var $5ozaj = parcelRequire("5ozaj");
var $ce4440200c7969a3$export$2e2bcd8739ae039 = (0, $e1gjy.defineComponent)({
    name: "KarnaughMap",
    mixins: [
        (0, $5ozaj.default)
    ],
    props: {
        groups: {
            type: Set
        },
        truthTable: {
            type: Array
        },
        nInputBits: Number,
        focusedGroup: (0, $eTXsV.Group)
    },
    data: ()=>({
            CELL_SIZE: 40
        }),
    methods: {
        bitOffset (index) {
            const x = (0, $1gNPB.grayOrder).indexOf(index & 3);
            const y = (0, $1gNPB.grayOrder).indexOf(index >>> 2 & 3);
            return [
                x,
                y
            ];
        },
        groupColor: /* toggleBit(event: PointerEvent, index: number) {
			if (event.button !== 0) return;
			this.truthTable[index] = !this.truthTable[index];
		}, */ $5GfdI.groupColor,
        *wrappingCombos (group) {
            const wrappedDimensions = [];
            for(let dimension = 0; dimension < group.nDimensions; dimension++){
                if (group.endCorner[dimension] <= 4) continue;
                wrappedDimensions.push(dimension);
            }
            for (const combo of (0, $7nMB1.anyCombineBoolean)(wrappedDimensions.length)){
                const shiftedAxes = [
                    false,
                    false
                ];
                for(let i = 0; i < wrappedDimensions.length; i++){
                    const dimension = wrappedDimensions[i];
                    shiftedAxes[dimension] = combo[i];
                }
                yield shiftedAxes;
            }
        },
        groupIsFocused (group) {
            return !this.focusedGroup || group === this.focusedGroup;
        },
        take: $5wItV.take
    },
    computed: {
        disabled () {
            return this.nInputBits > 4;
        }
    }
});

});
parcelRegister("5GfdI", function(module, exports) {

$parcel$export(module.exports, "groupColor", function () { return $cda468c9839fd207$export$e0b21b622e978893; });
const $cda468c9839fd207$export$e0b21b622e978893 = (group, alpha = 0.5)=>{
    var _group_offset_;
    const midX = (_group_offset_ = group.offset[0]) !== null && _group_offset_ !== void 0 ? _group_offset_ : 0; // + 2**(group.size[0] ?? 0) / 2;
    var _group_offset_1;
    const midY = (_group_offset_1 = group.offset[1]) !== null && _group_offset_1 !== void 0 ? _group_offset_1 : 0; // + 2**(group.size[1] ?? 0) / 2;
    // const r = (midX + midY) * -128 / 3 + 191;
    // const g = midY * 191 / 3 + 63;
    // const b = midX * 191 / 3 + 63;
    const r = midX * 128 / 3 + 63;
    const g = midY * 128 / 3 + 63;
    const b = 255;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

});

parcelRegister("5ozaj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac6d48805f075be1$export$2e2bcd8739ae039; });
var $ac6d48805f075be1$export$2e2bcd8739ae039 = {
    data: ()=>({
            pointerDown: false
        }),
    methods: {
        toggleBit (event, index) {
            const input = event.currentTarget;
            input.checked = !input.checked;
            this.truthTable[index] = !this.truthTable[index];
        },
        toggleBitIfPointerdown (event, index) {
            if (!this.pointerDown) return;
            this.toggleBit(event, index);
        }
    },
    mounted () {
        addEventListener("pointerdown", (event)=>{
            if (event.button !== 0) return;
            this.pointerDown = true;
            addEventListener("pointerup", (event)=>{
                if (event.button !== 0) return;
                this.pointerDown = false;
            }, {
                once: true
            });
        });
    }
};

});


parcelRegister("lXnP2", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $ffc196468ba73aef$export$b3890eb0ae9dca99; });
parcelRequire("kdoAp");
var $e1gjy = parcelRequire("e1gjy");
var $ciGHN = parcelRequire("ciGHN");
const $ffc196468ba73aef$var$_withScopeId = (n)=>((0, $e1gjy.pushScopeId)("data-v-c006e6"), n = n(), (0, $e1gjy.popScopeId)(), n);
const $ffc196468ba73aef$var$_hoisted_1 = {
    transform: "translate(60, 20)",
    class: "axis-label",
    id: "horizontal-axis"
};
const $ffc196468ba73aef$var$_hoisted_2 = /*#__PURE__*/ $ffc196468ba73aef$var$_withScopeId(()=>/*#__PURE__*/ (0, $e1gjy.createElementVNode)("text", {
        x: "0"
    }, [
        /*#__PURE__*/ (0, $e1gjy.createElementVNode)("tspan", {
            class: "not"
        }, "A\u2032B\u2032")
    ], -1));
const $ffc196468ba73aef$var$_hoisted_3 = [
    "x"
];
const $ffc196468ba73aef$var$_hoisted_4 = /*#__PURE__*/ (0, $e1gjy.createTextVNode)("A");
const $ffc196468ba73aef$var$_hoisted_5 = /*#__PURE__*/ $ffc196468ba73aef$var$_withScopeId(()=>/*#__PURE__*/ (0, $e1gjy.createElementVNode)("tspan", {
        class: "not"
    }, "B\u2032", -1));
const $ffc196468ba73aef$var$_hoisted_6 = [
    $ffc196468ba73aef$var$_hoisted_4,
    $ffc196468ba73aef$var$_hoisted_5
];
const $ffc196468ba73aef$var$_hoisted_7 = [
    "x"
];
const $ffc196468ba73aef$var$_hoisted_8 = [
    "x"
];
const $ffc196468ba73aef$var$_hoisted_9 = /*#__PURE__*/ $ffc196468ba73aef$var$_withScopeId(()=>/*#__PURE__*/ (0, $e1gjy.createElementVNode)("tspan", {
        class: "not"
    }, "A\u2032", -1));
const $ffc196468ba73aef$var$_hoisted_10 = /*#__PURE__*/ (0, $e1gjy.createTextVNode)("B");
const $ffc196468ba73aef$var$_hoisted_11 = [
    $ffc196468ba73aef$var$_hoisted_9,
    $ffc196468ba73aef$var$_hoisted_10
];
const $ffc196468ba73aef$var$_hoisted_12 = {
    transform: "translate(20, 60)",
    class: "axis-label",
    id: "vertical-axis"
};
const $ffc196468ba73aef$var$_hoisted_13 = /*#__PURE__*/ $ffc196468ba73aef$var$_withScopeId(()=>/*#__PURE__*/ (0, $e1gjy.createElementVNode)("text", {
        y: "0"
    }, [
        /*#__PURE__*/ (0, $e1gjy.createElementVNode)("tspan", {
            class: "not"
        }, "C\u2032D\u2032")
    ], -1));
const $ffc196468ba73aef$var$_hoisted_14 = [
    "y"
];
const $ffc196468ba73aef$var$_hoisted_15 = /*#__PURE__*/ (0, $e1gjy.createTextVNode)("C");
const $ffc196468ba73aef$var$_hoisted_16 = /*#__PURE__*/ $ffc196468ba73aef$var$_withScopeId(()=>/*#__PURE__*/ (0, $e1gjy.createElementVNode)("tspan", {
        class: "not"
    }, "D\u2032", -1));
const $ffc196468ba73aef$var$_hoisted_17 = [
    $ffc196468ba73aef$var$_hoisted_15,
    $ffc196468ba73aef$var$_hoisted_16
];
const $ffc196468ba73aef$var$_hoisted_18 = [
    "y"
];
const $ffc196468ba73aef$var$_hoisted_19 = [
    "y"
];
const $ffc196468ba73aef$var$_hoisted_20 = /*#__PURE__*/ $ffc196468ba73aef$var$_withScopeId(()=>/*#__PURE__*/ (0, $e1gjy.createElementVNode)("tspan", {
        class: "not"
    }, "C\u2032", -1));
const $ffc196468ba73aef$var$_hoisted_21 = /*#__PURE__*/ (0, $e1gjy.createTextVNode)("D");
const $ffc196468ba73aef$var$_hoisted_22 = [
    $ffc196468ba73aef$var$_hoisted_20,
    $ffc196468ba73aef$var$_hoisted_21
];
const $ffc196468ba73aef$var$_hoisted_23 = {
    transform: "translate(40, 40)",
    id: "map"
};
const $ffc196468ba73aef$var$_hoisted_24 = /*#__PURE__*/ $ffc196468ba73aef$var$_withScopeId(()=>/*#__PURE__*/ (0, $e1gjy.createElementVNode)("rect", {
        width: "160",
        height: "160",
        stroke: "currentcolor",
        fill: "none"
    }, null, -1));
const $ffc196468ba73aef$var$_hoisted_25 = {
    key: 0,
    id: "map-groups",
    mask: "url(#groups-mask)"
};
const $ffc196468ba73aef$var$_hoisted_26 = [
    "x",
    "y",
    "width",
    "height",
    "stroke"
];
const $ffc196468ba73aef$var$_hoisted_27 = [
    "x",
    "y",
    "width",
    "height",
    "fill"
];
const $ffc196468ba73aef$var$_hoisted_28 = {
    id: "groups-mask"
};
const $ffc196468ba73aef$var$_hoisted_29 = [
    "width",
    "height"
];
const $ffc196468ba73aef$var$_hoisted_30 = {
    id: "map-data",
    transform: "translate(20, 20)"
};
const $ffc196468ba73aef$var$_hoisted_31 = [
    "transform",
    "onPointerdown",
    "onPointerenter"
];
const $ffc196468ba73aef$var$_hoisted_32 = [
    "width",
    "height"
];
function $ffc196468ba73aef$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $e1gjy.openBlock)(), (0, $e1gjy.createElementBlock)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "-15 -10 225 220",
        class: (0, $ciGHN.normalizeClass)({
            disabled: _ctx.disabled
        })
    }, [
        (0, $e1gjy.createElementVNode)("g", $ffc196468ba73aef$var$_hoisted_1, [
            $ffc196468ba73aef$var$_hoisted_2,
            (0, $e1gjy.createElementVNode)("text", {
                x: _ctx.CELL_SIZE
            }, $ffc196468ba73aef$var$_hoisted_6, 8, $ffc196468ba73aef$var$_hoisted_3),
            (0, $e1gjy.createElementVNode)("text", {
                x: _ctx.CELL_SIZE * 2
            }, "AB", 8, $ffc196468ba73aef$var$_hoisted_7),
            (0, $e1gjy.createElementVNode)("text", {
                x: _ctx.CELL_SIZE * 3
            }, $ffc196468ba73aef$var$_hoisted_11, 8, $ffc196468ba73aef$var$_hoisted_8)
        ]),
        (0, $e1gjy.createElementVNode)("g", $ffc196468ba73aef$var$_hoisted_12, [
            $ffc196468ba73aef$var$_hoisted_13,
            (0, $e1gjy.createElementVNode)("text", {
                y: _ctx.CELL_SIZE
            }, $ffc196468ba73aef$var$_hoisted_17, 8, $ffc196468ba73aef$var$_hoisted_14),
            (0, $e1gjy.createElementVNode)("text", {
                y: _ctx.CELL_SIZE * 2
            }, "CD", 8, $ffc196468ba73aef$var$_hoisted_18),
            (0, $e1gjy.createElementVNode)("text", {
                y: _ctx.CELL_SIZE * 3
            }, $ffc196468ba73aef$var$_hoisted_22, 8, $ffc196468ba73aef$var$_hoisted_19)
        ]),
        (0, $e1gjy.createElementVNode)("g", $ffc196468ba73aef$var$_hoisted_23, [
            $ffc196468ba73aef$var$_hoisted_24,
            !_ctx.disabled ? ((0, $e1gjy.openBlock)(), (0, $e1gjy.createElementBlock)("g", $ffc196468ba73aef$var$_hoisted_25, [
                ((0, $e1gjy.openBlock)(true), (0, $e1gjy.createElementBlock)((0, $e1gjy.Fragment), null, (0, $e1gjy.renderList)(_ctx.groups, (group, index)=>{
                    return (0, $e1gjy.openBlock)(), (0, $e1gjy.createElementBlock)("g", {
                        class: (0, $ciGHN.normalizeClass)([
                            "group",
                            {
                                unfocused: !_ctx.groupIsFocused(group)
                            }
                        ]),
                        key: index
                    }, [
                        ((0, $e1gjy.openBlock)(true), (0, $e1gjy.createElementBlock)((0, $e1gjy.Fragment), null, (0, $e1gjy.renderList)(_ctx.wrappingCombos(group), (combo, index2)=>{
                            var _group_offset_, _group_offset_1, _group_size_, _group_size_1, _group_offset_2, _group_offset_3, _group_size_2, _group_size_3;
                            return (0, $e1gjy.openBlock)(), (0, $e1gjy.createElementBlock)("g", {
                                key: index2
                            }, [
                                (0, $e1gjy.createElementVNode)("rect", {
                                    x: (((_group_offset_ = group.offset[0]) !== null && _group_offset_ !== void 0 ? _group_offset_ : 0) - (combo[0] ? 4 : 0)) * _ctx.CELL_SIZE,
                                    y: (((_group_offset_1 = group.offset[1]) !== null && _group_offset_1 !== void 0 ? _group_offset_1 : 0) - (combo[1] ? 4 : 0)) * _ctx.CELL_SIZE,
                                    width: 2 ** ((_group_size_ = group.size[0]) !== null && _group_size_ !== void 0 ? _group_size_ : 0) * _ctx.CELL_SIZE,
                                    height: 2 ** ((_group_size_1 = group.size[1]) !== null && _group_size_1 !== void 0 ? _group_size_1 : 0) * _ctx.CELL_SIZE,
                                    fill: "none",
                                    stroke: _ctx.groupColor(group),
                                    "stroke-width": "4"
                                }, null, 8, $ffc196468ba73aef$var$_hoisted_26),
                                (0, $e1gjy.createElementVNode)("rect", {
                                    x: (((_group_offset_2 = group.offset[0]) !== null && _group_offset_2 !== void 0 ? _group_offset_2 : 0) - (combo[0] ? 4 : 0)) * _ctx.CELL_SIZE + 8,
                                    y: (((_group_offset_3 = group.offset[1]) !== null && _group_offset_3 !== void 0 ? _group_offset_3 : 0) - (combo[1] ? 4 : 0)) * _ctx.CELL_SIZE + 8,
                                    width: 2 ** ((_group_size_2 = group.size[0]) !== null && _group_size_2 !== void 0 ? _group_size_2 : 0) * _ctx.CELL_SIZE - 16,
                                    height: 2 ** ((_group_size_3 = group.size[1]) !== null && _group_size_3 !== void 0 ? _group_size_3 : 0) * _ctx.CELL_SIZE - 16,
                                    fill: _ctx.groupColor(group, 0.375)
                                }, null, 8, $ffc196468ba73aef$var$_hoisted_27)
                            ]);
                        }), 128))
                    ], 2);
                }), 128)),
                (0, $e1gjy.createElementVNode)("mask", $ffc196468ba73aef$var$_hoisted_28, [
                    (0, $e1gjy.createElementVNode)("rect", {
                        x: "-2",
                        y: "-2",
                        width: 2 ** Math.min(_ctx.nInputBits, 2) * _ctx.CELL_SIZE + 4,
                        height: 2 ** Math.max(0, Math.min(_ctx.nInputBits - 2, 2)) * _ctx.CELL_SIZE + 4,
                        fill: "#fff"
                    }, null, 8, $ffc196468ba73aef$var$_hoisted_29)
                ])
            ])) : (0, $e1gjy.createCommentVNode)("", true),
            (0, $e1gjy.createElementVNode)("g", $ffc196468ba73aef$var$_hoisted_30, [
                ((0, $e1gjy.openBlock)(true), (0, $e1gjy.createElementBlock)((0, $e1gjy.Fragment), null, (0, $e1gjy.renderList)(_ctx.take(_ctx.truthTable, 16), (bit, index)=>{
                    return (0, $e1gjy.openBlock)(), (0, $e1gjy.createElementBlock)("g", {
                        key: index,
                        transform: `translate(${_ctx.bitOffset(index)[0] * _ctx.CELL_SIZE}, ${_ctx.bitOffset(index)[1] * _ctx.CELL_SIZE})`,
                        class: (0, $ciGHN.normalizeClass)({
                            not: !bit
                        }),
                        onPointerdown: ($event)=>_ctx.toggleBit($event, index),
                        onPointerenter: ($event)=>_ctx.toggleBitIfPointerdown($event, index)
                    }, [
                        (0, $e1gjy.createElementVNode)("rect", {
                            transform: "translate(-20, -20)",
                            width: _ctx.CELL_SIZE,
                            height: _ctx.CELL_SIZE,
                            fill: "#0000"
                        }, null, 8, $ffc196468ba73aef$var$_hoisted_32),
                        (0, $e1gjy.createElementVNode)("text", null, (0, $ciGHN.toDisplayString)(bit ? "1" : "0"), 1)
                    ], 42, $ffc196468ba73aef$var$_hoisted_31);
                }), 128))
            ])
        ])
    ], 2);
}

});

parcelRegister("kuBVg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eeb4069d0b4ed663$export$2e2bcd8739ae039; });
let $eeb4069d0b4ed663$var$NOOP = ()=>{};
var $eeb4069d0b4ed663$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("icKDq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d40d85b8d8d76c7c$export$2e2bcd8739ae039; });
let $d40d85b8d8d76c7c$var$script;




let $d40d85b8d8d76c7c$var$initialize = ()=>{
    $d40d85b8d8d76c7c$var$script = (parcelRequire("h8dgb"));
    if ($d40d85b8d8d76c7c$var$script.__esModule) $d40d85b8d8d76c7c$var$script = $d40d85b8d8d76c7c$var$script.default;
    $d40d85b8d8d76c7c$var$script.render = (parcelRequire("fPUaN")).render;
    $d40d85b8d8d76c7c$var$script.__cssModules = {};
    (parcelRequire("1edTy")).default($d40d85b8d8d76c7c$var$script);
    $d40d85b8d8d76c7c$var$script.__scopeId = "data-v-e6c4ad";
    $d40d85b8d8d76c7c$var$script.__file = "Expression.vue";
};
$d40d85b8d8d76c7c$var$initialize();
var $d40d85b8d8d76c7c$export$2e2bcd8739ae039 = $d40d85b8d8d76c7c$var$script;

});
parcelRegister("h8dgb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $ed5713b3f5a6f4c3$export$2e2bcd8739ae039; });
parcelRequire("kdoAp");
var $e1gjy = parcelRequire("e1gjy");

var $1gNPB = parcelRequire("1gNPB");

var $i4uSE = parcelRequire("i4uSE");

var $8nWSt = parcelRequire("8nWSt");
const $ed5713b3f5a6f4c3$var$interpretGroup = (group, grays, nInputBits)=>{
    const isEven = nInputBits % 2 === 0; // Used to determine whether an axis only has one variable
    const nDimensions = Math.ceil(nInputBits / 2);
    const dependents = [];
    const A = 0;
    const NOT_A = 1;
    const B = 2;
    const NOT_B = 3;
    const variableOrderForSize2 = [
        NOT_B,
        A,
        B,
        NOT_A
    ]; // Variable that stays constant in a group which has a size of 2 along a given axis, where the group's offset along the axis is `i`
    for(let dimension = 0; dimension < group.nDimensions; dimension++){
        const varOffset = dimension * 4; // Number to be added to the `dependents` value to represent other variables (C, D, E, etc)
        const axisHasTwoVariables = isEven || dimension < nDimensions - 1;
        switch(group.size[dimension]){
            case 0:
                {
                    const gray = grays[dimension];
                    dependents.push((gray & 1 ? A : NOT_A) + varOffset);
                    if (axisHasTwoVariables) dependents.push((gray >> 1 & 1 ? B : NOT_B) + varOffset);
                    break;
                }
            case 1:
                if (axisHasTwoVariables) dependents.push(variableOrderForSize2[group.offset[dimension]] + varOffset);
                else continue;
                break;
            case 2:
                continue;
        }
    }
    return dependents;
};
var $ed5713b3f5a6f4c3$export$2e2bcd8739ae039 = (0, $e1gjy.defineComponent)({
    name: "Expression",
    props: {
        groups: {
            type: Set
        },
        nInputBits: {
            type: Number
        },
        usingProductOfSums: {
            type: Boolean
        }
    },
    data: ()=>({
            expression: "",
            parts: []
        }),
    methods: {
        /* generateExpression() {
			this.generateParts();

			if (!this.usingProductOfSums) {

				if (this.parts.length === 0) { // Empty sum
					return "0"
				}

				return this.parts.map(part => {
					if (part.size === 0) { // Empty product
						return "1";
					}
					return part.map(factor => {
						const letterId = Math.floor(factor / 2);
						const inverted = factor % 2 !== 0;

						return `${String.fromCharCode(letterId + "A".charCodeAt(0))}${inverted ? "′" : ""}`;
					}).join("");
				}).join(" + ");

			} else {

				if (this.parts.length === 0) { // Empty product
					return "1"
				}

				return this.parts.map(part => {
					if (part.size === 0) { // Empty sum
						return "0";
					}

					const string = part.map(factor => {
						const letterId = Math.floor(factor / 2);
						const inverted = factor % 2 !== 0;

						return `${String.fromCharCode(letterId + "A".charCodeAt(0))}${inverted ? "" : "′"}`; // Inverted in product of sums
					}).join(" + ");

					return part.length === 1 || this.parts.length === 1 ? string : `(${string})`;
				}).join("");
			}
		}, */ partText (part) {
            if (!this.usingProductOfSums) {
                if (part.size === 0) return "1";
                return part.dependents.map((factor)=>{
                    const letterId = Math.floor(factor / 2);
                    const inverted = factor % 2 !== 0;
                    return `${String.fromCharCode(letterId + "A".charCodeAt(0))}${inverted ? "\u2032" : ""}`;
                }).join("");
            } else {
                if (part.size === 0) return "0";
                const string = part.dependents.map((factor)=>{
                    const letterId = Math.floor(factor / 2);
                    const inverted = factor % 2 !== 0;
                    return `${String.fromCharCode(letterId + "A".charCodeAt(0))}${inverted ? "" : "\u2032"}`; // Inverted in product of sums
                }).join(" + ");
                return part.dependents.length === 1 || this.parts.length === 1 ? string : `(${string})`;
            }
        },
        generateParts () {
            const parts = [];
            for (const group of this.groups){
                const grays = group.offset.map((coord)=>(0, $1gNPB.grayOrder)[coord]);
                const dependents = $ed5713b3f5a6f4c3$var$interpretGroup(group, grays, this.nInputBits);
                parts.push(new (0, $8nWSt.default)(group, dependents));
            }
            this.parts = parts;
        }
    },
    watch: {
        groups () {
            this.generateParts();
        },
        nInputBits () {
            this.generateParts();
        },
        usingProductOfSums () {
            this.generateParts();
        }
    },
    components: {
        ExpressionPart: $i4uSE.default
    }
});

});
parcelRegister("i4uSE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2808df512cb3536$export$2e2bcd8739ae039; });
let $d2808df512cb3536$var$script;



let $d2808df512cb3536$var$initialize = ()=>{
    $d2808df512cb3536$var$script = (parcelRequire("8vqnO"));
    if ($d2808df512cb3536$var$script.__esModule) $d2808df512cb3536$var$script = $d2808df512cb3536$var$script.default;
    $d2808df512cb3536$var$script.render = (parcelRequire("8VV1X")).render;
    (parcelRequire("6t2L6")).default($d2808df512cb3536$var$script);
    $d2808df512cb3536$var$script.__scopeId = "data-v-349e59";
    $d2808df512cb3536$var$script.__file = "ExpressionPart.vue";
};
$d2808df512cb3536$var$initialize();
var $d2808df512cb3536$export$2e2bcd8739ae039 = $d2808df512cb3536$var$script;

});
parcelRegister("8vqnO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $5cd0ee878c023da3$export$2e2bcd8739ae039; });
parcelRequire("kdoAp");
var $e1gjy = parcelRequire("e1gjy");

var $8nWSt = parcelRequire("8nWSt");
var $5cd0ee878c023da3$export$2e2bcd8739ae039 = (0, $e1gjy.defineComponent)({
    name: "ExpressionPart",
    props: {
        part: (0, $8nWSt.default),
        usingProductOfSums: Number,
        text: String
    },
    methods: {
        focusGroup () {
            this.$emit("focusGroup", this.part.group);
        },
        blurGroup () {
            this.$emit("focusGroup", null);
        }
    }
});

});
parcelRegister("8nWSt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $740b27b499c8f1b3$export$2e2bcd8739ae039; });

var $9qLgL = parcelRequire("9qLgL");
class $740b27b499c8f1b3$export$2e2bcd8739ae039 {
    get size() {
        return this.dependents.length;
    }
    constructor(group, dependents){
        (0, $9qLgL._)(this, "group", void 0);
        (0, $9qLgL._)(this, "dependents", void 0);
        this.group = group;
        this.dependents = dependents;
    }
}

});


parcelRegister("8VV1X", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $680fe2ad515dfde8$export$b3890eb0ae9dca99; });
parcelRequire("kdoAp");
var $e1gjy = parcelRequire("e1gjy");
var $ciGHN = parcelRequire("ciGHN");
function $680fe2ad515dfde8$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $e1gjy.openBlock)(), (0, $e1gjy.createElementBlock)("span", {
        class: "part",
        onPointerenter: _cache[0] || (_cache[0] = (...args)=>_ctx.focusGroup && _ctx.focusGroup(...args)),
        onPointerleave: _cache[1] || (_cache[1] = (...args)=>_ctx.blurGroup && _ctx.blurGroup(...args))
    }, (0, $ciGHN.toDisplayString)(_ctx.text), 33);
}

});

parcelRegister("6t2L6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b5797540914feee$export$2e2bcd8739ae039; });
let $4b5797540914feee$var$NOOP = ()=>{};
var $4b5797540914feee$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("fPUaN", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $b877313bec2f8eb4$export$b3890eb0ae9dca99; });
parcelRequire("kdoAp");
var $e1gjy = parcelRequire("e1gjy");
var $ciGHN = parcelRequire("ciGHN");
const $b877313bec2f8eb4$var$_withScopeId = (n)=>((0, $e1gjy.pushScopeId)("data-v-e6c4ad"), n = n(), (0, $e1gjy.popScopeId)(), n);
const $b877313bec2f8eb4$var$_hoisted_1 = {
    key: 0,
    class: "part empty"
};
const $b877313bec2f8eb4$var$_hoisted_2 = {
    key: 0,
    class: "separator"
};
function $b877313bec2f8eb4$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ExpressionPart = (0, $e1gjy.resolveComponent)("ExpressionPart");
    const _component_expression_ = (0, $e1gjy.resolveComponent)("expression-");
    return (0, $e1gjy.openBlock)(), (0, $e1gjy.createBlock)(_component_expression_, null, {
        default: (0, $e1gjy.withCtx)(()=>[
                _ctx.groups.size === 0 ? ((0, $e1gjy.openBlock)(), (0, $e1gjy.createElementBlock)("span", $b877313bec2f8eb4$var$_hoisted_1, (0, $ciGHN.toDisplayString)(_ctx.usingProductOfSums ? "1" : "0"), 1)) : ((0, $e1gjy.openBlock)(true), (0, $e1gjy.createElementBlock)((0, $e1gjy.Fragment), {
                    key: 1
                }, (0, $e1gjy.renderList)(_ctx.parts, (part, index)=>{
                    return (0, $e1gjy.openBlock)(), (0, $e1gjy.createElementBlock)((0, $e1gjy.Fragment), {
                        key: index
                    }, [
                        (0, $e1gjy.createVNode)(_component_ExpressionPart, {
                            part: part,
                            usingProductOfSums: _ctx.usingProductOfSums,
                            text: _ctx.partText(part),
                            onFocusGroup: _cache[0] || (_cache[0] = (group)=>_ctx.$emit("focusGroup", group))
                        }, null, 8, [
                            "part",
                            "usingProductOfSums",
                            "text"
                        ]),
                        !_ctx.usingProductOfSums && index < _ctx.parts.length - 1 ? ((0, $e1gjy.openBlock)(), (0, $e1gjy.createElementBlock)("span", $b877313bec2f8eb4$var$_hoisted_2, " + ")) : (0, $e1gjy.createCommentVNode)("", true)
                    ], 64);
                }), 128))
            ]),
        _: 1
    });
}

});

parcelRegister("1edTy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e51e07f4000da59$export$2e2bcd8739ae039; });
let $0e51e07f4000da59$var$NOOP = ()=>{};
var $0e51e07f4000da59$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("3XThP", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $2e31c48919c7d7cf$export$b3890eb0ae9dca99; });
parcelRequire("kdoAp");
var $e1gjy = parcelRequire("e1gjy");
var $ciGHN = parcelRequire("ciGHN");
var $95okz = parcelRequire("95okz");
const $2e31c48919c7d7cf$var$_hoisted_1 = {
    class: "truth-table"
};
const $2e31c48919c7d7cf$var$_hoisted_2 = /*#__PURE__*/ (0, $e1gjy.createElementVNode)("td", null, "out", -1);
const $2e31c48919c7d7cf$var$_hoisted_3 = [
    "onPointerenter"
];
const $2e31c48919c7d7cf$var$_hoisted_4 = [
    "onUpdate:modelValue",
    "onPointerdown"
];
const $2e31c48919c7d7cf$var$_hoisted_5 = /*#__PURE__*/ (0, $e1gjy.createElementVNode)("label", null, "Input variables", -1);
const $2e31c48919c7d7cf$var$_hoisted_6 = /*#__PURE__*/ (0, $e1gjy.createElementVNode)("label", {
    for: "compute-product-input"
}, [
    /*#__PURE__*/ (0, $e1gjy.createTextVNode)("Compute "),
    /*#__PURE__*/ (0, $e1gjy.createElementVNode)("i", null, "Product of Sums")
], -1);
function $2e31c48919c7d7cf$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_input_table = (0, $e1gjy.resolveComponent)("input-table");
    const _component_KarnaughMap = (0, $e1gjy.resolveComponent)("KarnaughMap");
    const _component_Expression = (0, $e1gjy.resolveComponent)("Expression");
    const _component_output_ = (0, $e1gjy.resolveComponent)("output-");
    const _component_Entry = (0, $e1gjy.resolveComponent)("Entry");
    const _component_settings_ = (0, $e1gjy.resolveComponent)("settings-");
    const _component_side_panel = (0, $e1gjy.resolveComponent)("side-panel");
    return (0, $e1gjy.openBlock)(), (0, $e1gjy.createElementBlock)((0, $e1gjy.Fragment), null, [
        (0, $e1gjy.createVNode)(_component_input_table, null, {
            default: (0, $e1gjy.withCtx)(()=>[
                    (0, $e1gjy.createElementVNode)("table", $2e31c48919c7d7cf$var$_hoisted_1, [
                        (0, $e1gjy.createElementVNode)("thead", null, [
                            (0, $e1gjy.createElementVNode)("tr", null, [
                                ((0, $e1gjy.openBlock)(true), (0, $e1gjy.createElementBlock)((0, $e1gjy.Fragment), null, (0, $e1gjy.renderList)(_ctx.range(_ctx.nInputBits), (inputIndex)=>{
                                    return (0, $e1gjy.openBlock)(), (0, $e1gjy.createElementBlock)("td", {
                                        key: inputIndex
                                    }, (0, $ciGHN.toDisplayString)(String.fromCharCode("A".charCodeAt() + inputIndex)), 1);
                                }), 128)),
                                $2e31c48919c7d7cf$var$_hoisted_2
                            ])
                        ]),
                        (0, $e1gjy.createElementVNode)("tbody", null, [
                            ((0, $e1gjy.openBlock)(true), (0, $e1gjy.createElementBlock)((0, $e1gjy.Fragment), null, (0, $e1gjy.renderList)(_ctx.truthTable, (output, index)=>{
                                return (0, $e1gjy.openBlock)(), (0, $e1gjy.createElementBlock)("tr", {
                                    key: index
                                }, [
                                    ((0, $e1gjy.openBlock)(true), (0, $e1gjy.createElementBlock)((0, $e1gjy.Fragment), null, (0, $e1gjy.renderList)(_ctx.range(_ctx.nInputBits), (inputIndex)=>{
                                        return (0, $e1gjy.openBlock)(), (0, $e1gjy.createElementBlock)("td", {
                                            key: inputIndex,
                                            class: (0, $ciGHN.normalizeClass)([
                                                "input",
                                                {
                                                    positive: index >> inputIndex & 1
                                                }
                                            ])
                                        }, (0, $ciGHN.toDisplayString)(index >> inputIndex & 1), 3);
                                    }), 128)),
                                    (0, $e1gjy.createElementVNode)("td", {
                                        onPointerenter: ($event)=>_ctx.toggleBitIfPointerdown($event, index)
                                    }, [
                                        (0, $e1gjy.withDirectives)((0, $e1gjy.createElementVNode)("input", {
                                            type: "checkbox",
                                            "onUpdate:modelValue": ($event)=>_ctx.truthTable[index] = $event,
                                            onClick: _cache[0] || (_cache[0] = (0, $95okz.withModifiers)(()=>{}, [
                                                "prevent"
                                            ])),
                                            onPointerdown: ($event)=>_ctx.toggleBit($event, index)
                                        }, null, 40, $2e31c48919c7d7cf$var$_hoisted_4), [
                                            [
                                                (0, $95okz.vModelCheckbox),
                                                _ctx.truthTable[index]
                                            ]
                                        ])
                                    ], 40, $2e31c48919c7d7cf$var$_hoisted_3)
                                ]);
                            }), 128))
                        ])
                    ])
                ]),
            _: 1
        }),
        (0, $e1gjy.createVNode)(_component_side_panel, null, {
            default: (0, $e1gjy.withCtx)(()=>[
                    (0, $e1gjy.createVNode)(_component_KarnaughMap, {
                        truthTable: _ctx.truthTable,
                        nInputBits: _ctx.nInputBits,
                        groups: _ctx.groups,
                        focusedGroup: _ctx.focusedGroup
                    }, null, 8, [
                        "truthTable",
                        "nInputBits",
                        "groups",
                        "focusedGroup"
                    ]),
                    (0, $e1gjy.createVNode)(_component_output_, null, {
                        default: (0, $e1gjy.withCtx)(()=>[
                                (0, $e1gjy.createVNode)(_component_Expression, {
                                    groups: _ctx.groups,
                                    nInputBits: _ctx.nInputBits,
                                    usingProductOfSums: _ctx.usingProductOfSums,
                                    onFocusGroup: _ctx.setFocusedGroup
                                }, null, 8, [
                                    "groups",
                                    "nInputBits",
                                    "usingProductOfSums",
                                    "onFocusGroup"
                                ])
                            ]),
                        _: 1
                    }),
                    (0, $e1gjy.createVNode)(_component_settings_, null, {
                        default: (0, $e1gjy.withCtx)(()=>[
                                (0, $e1gjy.createElementVNode)("div", null, [
                                    (0, $e1gjy.createVNode)(_component_Entry, {
                                        modelValue: _ctx.nInputBits,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>_ctx.nInputBits = $event),
                                        validate: (value)=>0 <= value && value <= _ctx.N_MAX_INPUTS && value % 1 === 0,
                                        onInput: _ctx.refreshTruthTable
                                    }, null, 8, [
                                        "modelValue",
                                        "validate",
                                        "onInput"
                                    ]),
                                    $2e31c48919c7d7cf$var$_hoisted_5
                                ]),
                                (0, $e1gjy.createElementVNode)("div", null, [
                                    (0, $e1gjy.createElementVNode)("button", {
                                        onClick: _cache[2] || (_cache[2] = ($event)=>_ctx.clearTruthTable(false))
                                    }, "All 0s"),
                                    (0, $e1gjy.createElementVNode)("button", {
                                        onClick: _cache[3] || (_cache[3] = ($event)=>_ctx.clearTruthTable(true))
                                    }, "All 1s")
                                ]),
                                (0, $e1gjy.createElementVNode)("div", null, [
                                    (0, $e1gjy.withDirectives)((0, $e1gjy.createElementVNode)("input", {
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>_ctx.usingProductOfSums = $event),
                                        id: "compute-product-input"
                                    }, null, 512), [
                                        [
                                            (0, $95okz.vModelCheckbox),
                                            _ctx.usingProductOfSums
                                        ]
                                    ]),
                                    $2e31c48919c7d7cf$var$_hoisted_6
                                ])
                            ]),
                        _: 1
                    })
                ]),
            _: 1
        })
    ], 64);
}

});

parcelRegister("35yBq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23fcae15d94fd2dc$export$2e2bcd8739ae039; });
let $23fcae15d94fd2dc$var$NOOP = ()=>{};
var $23fcae15d94fd2dc$export$2e2bcd8739ae039 = (script)=>{};

});

/* import {Var, Not, And, Or} from "./Algebra";

(() => {

	// Input
	const truthTable = [false, true, true, true];
	const nInputBits = 2;
	
	const toBits = (n: number) => [...new Array(nInputBits)].map((_, i) => Boolean(n >>> i & 0b1)); // Smallest bit is first input
	
	const initialExpr = new Or(...truthTable.reduce((cumArray, truth, i) => {
		if (!truth) return cumArray;

		return [...cumArray, new And(...toBits(i).map((bit, i) => {
			return bit
					? new Var(i)
					: new Not(new Var(i));
		}))];
	}, []));

	console.log(initialExpr);

	console.log("SIMPLIFYING!!!");
	const simplified = initialExpr.simplify();
	console.log("simplified: ", simplified);

	// console.log(Or(Var(0), Var(1), Var(0), Not(Var(0))));

	document.body.textContent = simplified.toString();
})(); */ parcelRequire("kdoAp");
var $95okz = parcelRequire("95okz");
let $40581e1590de6129$var$script;




let $40581e1590de6129$var$initialize = ()=>{
    $40581e1590de6129$var$script = (parcelRequire("wfCCk"));
    if ($40581e1590de6129$var$script.__esModule) $40581e1590de6129$var$script = $40581e1590de6129$var$script.default;
    $40581e1590de6129$var$script.render = (parcelRequire("3XThP")).render;
    $40581e1590de6129$var$script.__cssModules = {};
    (parcelRequire("35yBq")).default($40581e1590de6129$var$script);
    $40581e1590de6129$var$script.__scopeId = "data-v-ffbde5";
    $40581e1590de6129$var$script.__file = "Root.vue";
};
$40581e1590de6129$var$initialize();
var $40581e1590de6129$export$2e2bcd8739ae039 = $40581e1590de6129$var$script;


// import {buildKarnaughMap, buildKarnaughPrefix, findKarnaughGroups, generateExpression} from "./Boolean/Karnaugh";
(()=>{
    /* const truthTable = [true];

	const map = buildKarnaughMap(truthTable);
	const prefix = buildKarnaughPrefix(map);

	console.log(map, prefix);

	const groups = findKarnaughGroups(truthTable);

	console.log([...groups].map(([coords, set]) => [coords, [...set]]));

	// document.body.textContent = generateExpression(groups);
	console.log(generateExpression(groups, 1)); */ const app = (0, $95okz.createApp)((0, $40581e1590de6129$export$2e2bcd8739ae039));
    app.mount("main");
})();

})();
//# sourceMappingURL=index.2e7f7ca6.js.map
